// @ts-nocheck
import ReviewsModal from '../../components/ReviewsModal';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
  Box, Typography, Avatar, IconButton, Dialog, DialogContent,
  DialogTitle, DialogActions,
  TextField, Button, CircularProgress, Alert, Snackbar,
  InputAdornment, Divider, Menu, MenuItem, Slide, Chip, useMediaQuery, Checkbox
} from '@mui/material';
import {
  Search, Star, AccessTime, Close, ChevronLeft, ChevronRight,
  CheckCircle, Phone, ContentCut, Visibility, VisibilityOff,
  EventNote, Logout, LogoutOutlined, ShoppingBag, WhatsApp, Place, Share, CreditCard,
  Map, Login, ExpandMore, CalendarMonth, CopyAll, SearchRounded, Language, Instagram, Facebook,
  NotificationsActive, HourglassEmpty, PersonAdd, NearMe, Info
} from '@mui/icons-material';
import {
  format, addMonths, subMonths, startOfMonth, endOfMonth,
  eachDayOfInterval, isSameDay, isBefore, startOfDay, parseISO, addDays
} from 'date-fns';
import { ptBR } from 'date-fns/locale';
import axios from 'axios';
import { ServiceIcon } from '../../components/ServiceIcon';
import { normalizeInstagram } from '../../utils/instagramHandle';
import { trackGrowthEvent, getGrowthIdsForBooking } from '../../utils/growthTracking';
import { ClientMenuV2 } from './pilot/ClientMenuV2';
import { PreviewBarV2, TestBookingConfirmDialog, PREVIEW_BAR_HEIGHT } from './pilot/PreviewBarV2';
import { ConfirmationV2 } from './pilot/ConfirmationV2';
import { ProactiveReviewModal, PendingReviewBooking } from './pilot/ProactiveReviewModal';
import PaymentMethodSelector, { PixSymbol } from './PaymentMethodSelector';
import { isPaymentSelectorBOn } from '../../config/paymentSelectorFlags';


const clientWhatsappDigits = (value: string) => String(value || '').replace(/\D/g, '').slice(0, 11);

const formatClientWhatsapp = (value: string) => {
  const d = clientWhatsappDigits(value);
  if (!d) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

// Aguarda o Device ID do Mercado Pago (window.MP_DEVICE_SESSION_ID, gerado pelo security.js)
// estar disponível antes de enviar o pagamento — reduz casos de device_id ausente por timing
// (script ainda carregando quando o cliente clica em pagar). Não bloqueia o pagamento: após o
// timeout, segue sem o device_id (igual ao comportamento anterior).
const getMpDeviceId = async (timeoutMs = 4500, intervalMs = 150) => {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    const id = (window as any).MP_DEVICE_SESSION_ID;
    if (id) return id;
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return (window as any).MP_DEVICE_SESSION_ID || undefined;
};

const isClientWhatsappComplete = (value: string) => {
  const d = clientWhatsappDigits(value);
  if (!/^\d{10,11}$/.test(d)) return false;
  const ddd = Number(d.slice(0, 2));
  if (ddd < 11 || ddd > 99) return false;
  if (d.length === 11 && d[2] !== '9') return false;
  return true;
};

const API = process.env.REACT_APP_API_URL || 'https://app.agendali.com.br/api';
const WEEK_DAYS = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
const today = startOfDay(new Date());

function loadCustomer() {
  try { return JSON.parse(localStorage.getItem('cust_user') || 'null'); } catch { return null; }
}
function saveCustomer(user: any, token: string, slug?: string) {
  localStorage.setItem('cust_user', JSON.stringify(user));
  if (token) localStorage.setItem('cust_token', token);
  if (user?.phone) localStorage.setItem('cust_phone', String(user.phone).replace(/\D/g, ''));
  if (slug) localStorage.setItem('cust_slug', slug);
}
function getCustomerToken(data?: any) {
  return data?.customer_token || data?.token || data?.auth_token || data?.access_token || data?.jwt || data?.customer?.token || '';
}
function clearCustomer() {
  localStorage.removeItem('cust_user');
  localStorage.removeItem('cust_token');
}

const GoogleG = () => (
  <svg width="18" height="18" viewBox="0 0 48 48">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    <path fill="none" d="M0 0h48v48H0z"/>
  </svg>
);


// Thumbnail de serviço com fallback quando a imagem falha
function ServiceThumb({ url, size = 14 }: { url?: string | null, size?: number }) {
  const [err, setErr] = React.useState(false);
  if (!url || err) return <ContentCut sx={{ fontSize: size, color: '#ddd' }} />;
  return <img src={url} alt="" loading="lazy" style={{ width:'100%', height:'100%', objectFit:'cover' }} onError={() => setErr(true)} />;
}


// ── Dark Mode Preset ─────────────────────────────────────────────────────────
const DARK_THEME = {
  bg:            '#0f0f0f',
  surface:       '#1a1a1a',
  surfaceAlt:    '#222222',
  border:        '#2e2e2e',
  textPrimary:   '#f1f5f9',
  textSecondary: '#94a3b8',
  accent:        '#c9a227',
  accentHover:   '#b8941f',
  fadeGradient:  'rgba(15,15,15,1)',
} as const;
type DarkTheme = typeof DARK_THEME | null;
// ─────────────────────────────────────────────────────────────────────────────

// Sub-componente para tabs de dados do cliente (precisa de useState próprio)
function DataTabsInner({ name, setName, phone, setPhone, phone2, setPhone2, accentColor, onLoginClick, onRegisterClick, notes, setNotes, requirePhoneConfirm, showNotes, showTermsCheck, termsAccepted, setTermsAccepted, onOpenTerms, collectEmail, email, setEmail, isDark, T }: any) {
  const [dataTab, setDataTab] = React.useState<'guest'|'login'>('guest');
  return (
    <Box>
      {/* Heading */}
      <Box sx={{ mb:2.5 }}>
        <Typography fontWeight={900} fontSize={26} letterSpacing='-0.03em' sx={{ color: T?.textPrimary ?? '#0f172a' }} lineHeight={1.2} mb={0.6}>
          Quase lá, falta só você
        </Typography>
        <Typography fontSize={14} sx={{ color: T?.textSecondary ?? '#64748b' }}>A confirmação chega no seu WhatsApp na hora.</Typography>
      </Box>

      {/* Auth toggle */}
      <Box sx={{ display:'flex', gap:0.8, p:0.6, bgcolor: T?.surfaceAlt ?? '#f1f5f9', borderRadius:1.5, mb:2.5 }}>
        <Box onClick={() => setDataTab('guest')} sx={{
          flex:1, py:1, textAlign:'center', borderRadius:1.2, cursor:'pointer',
          bgcolor: dataTab === 'guest' ? (T ? 'rgba(255,255,255,0.40)' : '#fff') : 'transparent',
          boxShadow: dataTab === 'guest' ? (T ? 'none' : '0 2px 4px rgba(0,0,0,0.06)') : 'none',
          transition:'all 0.2s',
        }}>
          <Typography fontWeight={dataTab === 'guest' ? 700 : 500} fontSize={13.5} sx={{ color: dataTab === 'guest' ? (T?.textPrimary ?? '#0f172a') : (T?.textSecondary ?? '#64748b') }}>
            Sem conta
          </Typography>
        </Box>
        <Box onClick={() => setDataTab('login')} sx={{
          flex:1, py:1, textAlign:'center', borderRadius:1.2, cursor:'pointer',
          bgcolor: dataTab === 'login' ? (T ? 'rgba(255,255,255,0.40)' : '#fff') : 'transparent',
          boxShadow: dataTab === 'login' ? (T ? 'none' : '0 2px 4px rgba(0,0,0,0.06)') : 'none',
          transition:'all 0.2s',
        }}>
          <Typography fontWeight={dataTab === 'login' ? 700 : 500} fontSize={13.5} sx={{ color: dataTab === 'login' ? (T?.textPrimary ?? '#0f172a') : (T?.textSecondary ?? '#64748b') }}>
            Já tenho conta
          </Typography>
        </Box>
      </Box>

      {dataTab === 'guest' && (
        <Box sx={{ display:'flex', flexDirection:'column', gap:1.8 }}>
          {/* Nome */}
          <Box>
            <Typography fontSize={13} fontWeight={600} sx={{ color: T?.textPrimary ?? '#0f172a' }} mb={0.8}>Nome completo</Typography>
            <TextField fullWidth value={name}
              onChange={(e: any) => setName(e.target.value)} size="small"
              placeholder="Seu nome"
              InputProps={{ sx: { borderRadius:1.5, fontSize:15, bgcolor: T?.surface ?? '#fff', color: T?.textPrimary } }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius:1.5 }, '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: accentColor }, '& .MuiOutlinedInput-notchedOutline': { borderColor: T?.border }, '& .MuiInputBase-input::placeholder': { color: T?.textSecondary, opacity: T ? 1 : undefined }, '& .MuiInputBase-input': { color: T?.textPrimary ?? '#0f172a' } }} />
          </Box>
          {/* WhatsApp */}
          <Box>
            <Typography fontSize={13} fontWeight={600} sx={{ color: T?.textPrimary ?? '#0f172a' }} mb={0.8}>WhatsApp</Typography>
            <TextField fullWidth value={phone} size="small"
              type="tel" autoComplete="off"
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
              error={!!phone && !isClientWhatsappComplete(phone)}
              onPaste={(e: any) => {
                e.preventDefault();
                const formatted = formatClientWhatsapp(e.clipboardData.getData('text'));
                setPhone(formatted);
                setPhone2(formatted);
              }}
              onChange={(e: any) => {
                const formatted = formatClientWhatsapp(e.target.value);
                setPhone(formatted);
                setPhone2(formatted);
              }}
              placeholder="(11) 99999-9999"
              InputProps={{ sx: { borderRadius:1.5, fontSize:15, bgcolor: T?.surface ?? '#fff', color: T?.textPrimary } }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius:1.5 }, '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: accentColor }, '& .MuiOutlinedInput-notchedOutline': { borderColor: T?.border }, '& .MuiInputBase-input::placeholder': { color: T?.textSecondary, opacity: T ? 1 : undefined }, '& .MuiInputBase-input': { color: T?.textPrimary ?? '#0f172a' } }} />
            <Box sx={{ display:'flex', alignItems:'center', gap:0.6, mt:0.8 }}>
              <Typography sx={{ fontSize:12, color: T?.textSecondary ?? '#64748b' }}>🛡 Usado só para confirmação e lembrete.</Typography>
            </Box>
          </Box>
          {requirePhoneConfirm && (
          <Box>
            <Typography fontSize={13} fontWeight={600} sx={{ color: T?.textPrimary ?? '#0f172a' }} mb={0.8}>Confirme seu WhatsApp</Typography>
            <TextField fullWidth value={phone2} size="small"
              type="tel" autoComplete="off"
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
              error={!!phone2 && clientWhatsappDigits(phone2) !== clientWhatsappDigits(phone)}
              helperText={!!phone2 && clientWhatsappDigits(phone2) !== clientWhatsappDigits(phone) ? 'Os números não coincidem' : ''}
              onChange={(e: any) => {
                setPhone2(formatClientWhatsapp(e.target.value));
              }}
              placeholder="(11) 99999-9999"
              InputProps={{ sx: { borderRadius:1.5, fontSize:15, bgcolor: T?.surface ?? '#fff', color: T?.textPrimary } }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius:1.5 }, '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: accentColor }, '& .MuiOutlinedInput-notchedOutline': { borderColor: T?.border }, '& .MuiInputBase-input::placeholder': { color: T?.textSecondary, opacity: T ? 1 : undefined }, '& .MuiInputBase-input': { color: T?.textPrimary ?? '#0f172a' } }} />
          </Box>
          )}
          {collectEmail && (
          <Box>
            <Typography fontSize={13} fontWeight={600} sx={{ color: T?.textPrimary ?? '#0f172a' }} mb={0.8}>E-mail</Typography>
            <TextField fullWidth value={email || ''} size="small"
              type="email" autoComplete="email"
              onChange={(e: any) => setEmail && setEmail(e.target.value)}
              placeholder="seu@email.com"
              InputProps={{ sx: { borderRadius:1.5, fontSize:15, bgcolor: T?.surface ?? '#fff', color: T?.textPrimary } }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius:1.5 }, '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: accentColor }, '& .MuiOutlinedInput-notchedOutline': { borderColor: T?.border }, '& .MuiInputBase-input::placeholder': { color: T?.textSecondary, opacity: T ? 1 : undefined }, '& .MuiInputBase-input': { color: T?.textPrimary ?? '#0f172a' } }} />
          </Box>
          )}
          {showNotes !== false && (
          <Box>
            <Typography fontSize={13} fontWeight={600} sx={{ color: T?.textPrimary ?? '#0f172a' }} mb={0.8}>Algo a comunicar? (opcional)</Typography>
            <TextField fullWidth value={notes || ''} size="small"
              onChange={(e: any) => setNotes && setNotes(e.target.value)}
              placeholder=""
              InputProps={{ sx: { borderRadius:1.5, fontSize:14, bgcolor: T?.surface ?? '#fff', color: T?.textPrimary } }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius:1.5 }, '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: accentColor }, '& .MuiOutlinedInput-notchedOutline': { borderColor: T?.border }, '& .MuiInputBase-input::placeholder': { color: T?.textSecondary, opacity: T ? 1 : undefined }, '& .MuiInputBase-input': { color: T?.textPrimary ?? '#0f172a' } }} />
          </Box>
          )}
          {showTermsCheck && (
          <Box sx={{ display:'flex', alignItems:'flex-start', gap:1, p:1.5, bgcolor: T?.surfaceAlt ?? '#f8fafc', borderRadius:1.5, border: `1px solid ${T?.border ?? '#e2e8f0'}` }}>
            <Box onClick={() => setTermsAccepted && setTermsAccepted(!termsAccepted)} sx={{ width:20, height:20, minWidth:20, borderRadius:0.8, border:`2px solid ${termsAccepted ? accentColor : '#cbd5e1'}`, bgcolor: termsAccepted ? accentColor : (T?.surface ?? '#fff'), display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', mt:0.1, transition:'all 0.15s' }}>
              {termsAccepted && <Typography fontSize={12} color="#fff" fontWeight={800}>✓</Typography>}
            </Box>
            <Typography fontSize={12} sx={{ color: T?.textSecondary ?? '#475569' }} lineHeight={1.5}>
              Li e aceito os{' '}
              <Typography component="span" fontSize={12} color={accentColor} fontWeight={700} sx={{ cursor:'pointer', textDecoration:'underline' }} onClick={() => onOpenTerms && onOpenTerms()}>
                Termos de Uso
              </Typography>
              {' '}do estabelecimento
            </Typography>
          </Box>
          )}
        </Box>
      )}
      {dataTab === 'login' && (
        <Box sx={{ display:'flex', flexDirection:'column', gap:1.5 }}>
          <Button fullWidth variant="contained" size="large" onClick={onLoginClick}
            sx={{ borderRadius:1.5, textTransform:'none', fontWeight:700, fontSize:15, py:1.6, bgcolor:'#1a1a1a', color:'#fff', '&:hover': { bgcolor:'#333' } }}>
            Entrar na minha conta
          </Button>
          <Button fullWidth variant="outlined" size="large" onClick={onRegisterClick}
            sx={{ borderRadius:1.5, textTransform:'none', fontWeight:600, fontSize:14, py:1.3, color: T?.textPrimary ?? '#333', borderColor: T?.border ?? '#e2e8f0', '&:hover': { borderColor: T?.textSecondary ?? '#999', bgcolor: T?.surfaceAlt ?? '#fafafa' } }}>
            Criar conta nova
          </Button>
        </Box>
      )}
    </Box>
  );
}

const SlideUp = React.forwardRef(function SlideUp(props: any, ref: any) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Comunicados (barra + pop-up) — incidente real (empresa 322, Espaço Kezia
// Agape, 22/09/2026): dono ativou o toggle sem preencher nada; a checagem
// antiga só olhava `enabled`, então a barra/o pop-up abriam vazios (faixa
// colorida sem texto; caixa branca com fundo escuro, sem título/texto/
// imagem). Estas duas funções puras são a ÚNICA fonte da regra "tem
// conteúdo de verdade" — usadas nos dois pontos de decisão do pop-up
// (agendar abertura e renderizar) para nunca divergirem entre si. Nunca
// acessam campo nenhum sem checar o objeto primeiro (empresa sem
// `announcements` configurado não pode quebrar a página).
function barHasText(cfg: any): boolean {
  return !!String(cfg?.text || '').trim();
}
function popupHasContent(cfg: any): boolean {
  if (!cfg) return false;
  return !!String(cfg.title || '').trim() || !!String(cfg.body || '').trim() || !!String(cfg.image_url || '').trim();
}

export default function BookingPage({ slug }: { slug: string }) {
  const [company, setCompany] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [reviews, setReviews] = useState<any[]>([]);
  const [reviewModal, setReviewModal] = useState(false);
  const [showReviewsModal, setShowReviewsModal] = useState(false);
  const [reviewRating, setReviewRating] = useState(5);
  const [reviewComment, setReviewComment] = useState('');
  const [reviewSending, setReviewSending] = useState(false);
  const [search, setSearch] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [custUser, setCustUser] = useState(loadCustomer);
  const [pendingReview, setPendingReview] = useState<PendingReviewBooking | null>(null);
  const [pendingReviewOpen, setPendingReviewOpen] = useState(false);
  const [pendingReviewSubmitting, setPendingReviewSubmitting] = useState(false);
  const [upsellOffer, setUpsellOffer] = useState<any>(null);
  const [upsellAccepted, setUpsellAccepted] = useState<{ item_name: string; item_price: number } | null>(null);
  const [upsellAccepting, setUpsellAccepting] = useState(false);
  const [userMenuAnchor, setUserMenuAnchor] = useState<null | HTMLElement>(null);
  const [snack, setSnack] = useState('');
  const [stickyHeader, setStickyHeader] = useState(false);
  const heroRef = useRef<HTMLDivElement>(null);
  const [annPopupOpen, setAnnPopupOpen] = useState(false);
  const [annBarClosed, setAnnBarClosed] = useState(false);

  // Multi-select
  const [selected, setSelected] = useState<any[]>([]);

  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [selectedBumps, setSelectedBumps] = useState<any[]>([]);

  // Modal agendamento
  const [modalOpen, setModalOpen] = useState(false);
  const [calMonth, setCalMonth] = useState(new Date());
  const [selDate, setSelDate] = useState<Date | null>(null);
  const [slots, setSlots] = useState<any[]>([]);
  const [slotsLoading, setSlotsLoading] = useState(false);
  const [nextSlotsData, setNextSlotsData] = useState<{date:string; label:string; slots:string[]}[]>([]);
  const [nextSlotsLoading, setNextSlotsLoading] = useState(false);
  const [showInlineNext, setShowInlineNext] = useState(false);
  const [inlineNextPage, setInlineNextPage] = useState(2);
  const [proAnchor, setProAnchor] = useState<HTMLElement | null>(null);
  const [selPro, setSelPro] = useState<any>(null);
  const [selTime, setSelTime] = useState<string>('');

  const [availableDays, setAvailableDays] = useState<string[]>([]);

  // Fila de espera
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  const [waitlistName, setWaitlistName] = useState('');
  const [waitlistPhone, setWaitlistPhone] = useState('');
  const [waitlistEmail, setWaitlistEmail] = useState('');
  const [waitlistPeriod, setWaitlistPeriod] = useState<string>('qualquer');
  const [waitlistSaving, setWaitlistSaving] = useState(false);
  const [waitlistDone, setWaitlistDone] = useState<any>(null);

  const [step, setStep] = useState('booking');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [phone2, setPhone2] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [bookingNotes, setBookingNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);
  // Confirmação antes de criar agendamento real no modo prévia (todas as empresas).
  const [testConfirmOpen, setTestConfirmOpen] = useState(false);
  const [bookingResult, setBookingResult] = useState<any>(null);
  const [payModal, setPayModal] = useState(false);
  const [payAmount, setPayAmount] = useState(0);
  const [payMethodSel, setPayMethodSel] = useState<'pix'|'card'|'cash'>('pix');
  // Piloto de Crédito (empresa 7) — só oferecido a cliente com sessão FORTE
  // (senha/Google, ver auth_strength no objeto do cliente); nunca pelo
  // simples fato de ter um telefone/JWT fraco (achado F8). Estimativa aqui é
  // só para exibição — o valor realmente aplicado é sempre recalculado no
  // servidor a partir do saldo real no banco.
  const [useCreditBalance, setUseCreditBalance] = useState(true);
  const [pixData, setPixData] = useState<{qr_code:string; qr_code_base64:string|null; payment_id:number} | null>(null);
  const [pixCopied, setPixCopied] = useState(false);
  const [pixPollingRef] = useState<{interval: any}>({ interval: null });
  const [pixCreating, setPixCreating] = useState(false);
  const [pendingBookingId, setPendingBookingId] = useState<number | null>(null);
  const [pendingBookingToken, setPendingBookingToken] = useState<string | null>(null);
  const [pendingServiceName, setPendingServiceName] = useState('');
  const [bricksReady, setBricksReady] = useState(false);
  const [bricksError, setBricksError] = useState('');
  const [bricksRetryKey, setBricksRetryKey] = useState(0);
  const bricksControllerRef = React.useRef<any>(null);
  const autoAdvancedCalRef = React.useRef(false);
  const bricksInitRef = React.useRef(false); // previne init duplo
  const [payCountdown, setPayCountdown] = useState(30 * 60); // 30 min em segundos (mínimo MP)
  const [payTotalSeconds, setPayTotalSeconds] = useState(30 * 60); // total para cálculo da barra de progresso
  const countdownRef = React.useRef<any>(null);
  const dialogContentRef = React.useRef<HTMLDivElement | null>(null);

  // Login dialog
  const [loginOpen, setLoginOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [termsText, setTermsText] = useState('');

  const getAutoTerms = (companyName: string) => `TERMOS DE USO — ${companyName}

Última atualização: ${new Date().toLocaleDateString('pt-BR')}

1. IDENTIFICAÇÃO DO ESTABELECIMENTO
${companyName} é responsável pelos serviços prestados por meio desta plataforma de agendamento online.

2. ACEITAÇÃO DOS TERMOS
Ao realizar um agendamento, você declara que leu, entendeu e concorda com os presentes Termos de Uso.

3. AGENDAMENTOS E DISPONIBILIDADE
Os horários disponíveis estão sujeitos à disponibilidade da agenda. A confirmação fica condicionada às políticas de pagamento vigentes no momento da reserva.

4. CANCELAMENTO E REMARCAÇÃO
O cancelamento ou remarcação deve ser solicitado com antecedência mínima de 2 (duas) horas antes do horário agendado. Cancelamentos fora deste prazo podem não ser aceitos ou gerar cobrança de taxa.

5. NÃO COMPARECIMENTO
O não comparecimento sem aviso prévio poderá implicar restrição de novos agendamentos e eventual perda do sinal pago, quando aplicável.

6. PAGAMENTO E SINAL
Quando exigida, a cobrança de sinal ou valor integral é realizada no momento do agendamento. Valores pagos como entrada podem ser retidos em caso de cancelamento fora do prazo.

7. DADOS PESSOAIS
Suas informações são coletadas e utilizadas exclusivamente para a gestão dos seus agendamentos, nos termos da LGPD (Lei nº 13.709/2018). Consulte também nossa Política de Privacidade.

8. RESPONSABILIDADES
${companyName} compromete-se a prestar os serviços com qualidade e pontualidade. Em caso de impossibilidade, o cliente será informado e poderá reagendar ou receber reembolso integral.

9. LEGISLAÇÃO
Estes Termos são regidos pelo Código de Defesa do Consumidor (Lei nº 8.078/1990) e pela LGPD (Lei nº 13.709/2018).

10. CONTATO
Dúvidas? Entre em contato pelos canais disponíveis nesta página de agendamento.`;

  const getAutoPrivacy = (companyName: string) => `POLÍTICA DE PRIVACIDADE — ${companyName}

Última atualização: ${new Date().toLocaleDateString('pt-BR')}

${companyName} está comprometido com a proteção dos seus dados pessoais, em conformidade com a LGPD (Lei nº 13.709/2018) e o CDC (Lei nº 8.078/1990).

1. DADOS QUE COLETAMOS
• Nome completo (obrigatório)
• Número de WhatsApp (obrigatório)
• E-mail (quando fornecido)
• Data de nascimento (opcional)
• Histórico de agendamentos

2. COMO USAMOS SEUS DADOS
Suas informações são utilizadas exclusivamente para:
• Confirmar, gerenciar e lembrar seus agendamentos
• Enviar comunicações sobre seus atendimentos
• Cumprir obrigações legais aplicáveis

3. COMPARTILHAMENTO
Não compartilhamos seus dados para fins comerciais. Prestadores de tecnologia podem processar dados estritamente para viabilizar o serviço, com garantias de confidencialidade.

4. SEGURANÇA
Adotamos medidas técnicas para proteger suas informações contra acesso não autorizado.

5. SEUS DIREITOS (LGPD)
Você tem direito a acessar, corrigir, excluir ou solicitar a portabilidade dos seus dados, além de revogar o consentimento a qualquer momento.

6. RETENÇÃO
Seus dados são mantidos pelo tempo necessário à prestação dos serviços. Após esse período, são excluídos ou anonimizados.

7. CONTATO
Para exercer seus direitos ou tirar dúvidas, entre em contato com ${companyName} pelos canais disponíveis nesta página.`;

  const [termsAccepted, setTermsAccepted] = useState(false);

  // Informações para o atendimento — modal de perguntas rápidas antes de
  // finalizar. Só ativo se a empresa ligar em Configurações (nasce desligado).
  const [intakeModalOpen, setIntakeModalOpen] = useState(false);
  const [intakeDraftAnswers, setIntakeDraftAnswers] = useState({}); // rascunho dentro do modal
  const [intakeSavedAnswers, setIntakeSavedAnswers] = useState(null); // null = ainda não respondeu

  const [loginMode, setLoginMode] = useState<'login' | 'register'>('login');
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginShowPwd, setLoginShowPwd] = useState(false);
  const [loginName, setLoginName] = useState('');
  const [loginPhone, setLoginPhone] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  // Google OAuth redirect flow states
  const [googleLoading, setGoogleLoading] = useState(false);
  // Pending: conta nova via Google aguardando nome + WhatsApp
  const [googlePending, setGooglePending] = useState(false);
  const [googlePendingToken, setGooglePendingToken] = useState('');
  const [googlePendingName, setGooglePendingName] = useState('');
  const [googlePendingPhone, setGooglePendingPhone] = useState('');
  const [googlePendingPhoneError, setGooglePendingPhoneError] = useState('');
  // Phone conflict: WhatsApp já existe em conta antiga
  const [googlePhoneConflict, setGooglePhoneConflict] = useState(false);
  const [googleConflictOldName, setGoogleConflictOldName] = useState('');
  const [googleConflictOldHasPassword, setGoogleConflictOldHasPassword] = useState(false);
  const [googleConflictPassword, setGoogleConflictPassword] = useState('');
  const [googleConflictError, setGoogleConflictError] = useState('');
  // E-mail já cadastrado numa conta COM senha (achado da revisão pré-liberação
  // global) — nunca vincula automático nesse caso, sempre exige a senha.
  const [googleEmailNeedsPassword, setGoogleEmailNeedsPassword] = useState(false);

  const [loginThenBook, setLoginThenBook] = useState(false);
  // Adendo 5.4.1 — plano que o cliente tentava comprar quando precisou logar.
  // Só usado para levar o contexto pro Google (?tab=pacotes&pacote=X no
  // redirect); a compra em si nunca é retomada sozinha, o cliente clica de
  // novo em "Comprar pacote" ao voltar.
  const [googleReturnPlanId, setGoogleReturnPlanId] = useState<number | null>(null);
  const [customerSubscriptions, setCustomerSubscriptions] = useState<any[]>([]);
  const [customerSubscriptionsLoading, setCustomerSubscriptionsLoading] = useState(false);
  // "Reservar e pagar no local": reservas pendentes de pagamento (sempre mostradas,
  // inclusive após recarregar a página) e pacotes já ocupados pela trava do limite.
  const [pendingReservations, setPendingReservations] = useState<any[]>([]);
  const [blockedPlans, setBlockedPlans] = useState<any[]>([]);
  // Uma chave por intenção de reservar um pacote (duplo clique / nova tentativa
  // após falha de rede reaproveitam a mesma; o servidor devolve a mesma reserva).
  const planReserveRequestRef = useRef<Record<number, string>>({});
  const applyCustomerWallet = (data: any) => {
    const rows = Array.isArray(data) ? data : (data?.subscriptions || []);
    setCustomerSubscriptions(rows);
    setPendingReservations(Array.isArray(data?.pending_reservations) ? data.pending_reservations : []);
    setBlockedPlans(Array.isArray(data?.blocked_plans) ? data.blocked_plans : []);
    return rows;
  };
  const reloadCustomerWallet = async () => {
    const tok = localStorage.getItem('cust_token');
    if (!tok || tok === 'null' || tok === 'undefined') return;
    try {
      const { data } = await axios.get(`${API}/public/${slug}/customers/subscriptions`, { headers: { Authorization: `Bearer ${tok}` } });
      applyCustomerWallet(data);
    } catch (_) {}
  };
  const [packagePickerOpen, setPackagePickerOpen] = useState(false);
  const [packagePickerPlan, setPackagePickerPlan] = useState<any>(null);
  const [packageSelectionIds, setPackageSelectionIds] = useState<number[]>([]);
  const [packageBookingSubscription, setPackageBookingSubscription] = useState<any>(null);
  const [planCheckoutLoadingId, setPlanCheckoutLoadingId] = useState<number | null>(null);
  // Rodada 5.2 — seletor "Escolha o que vai usar hoje" em tela cheia no
  // mobile, para não apertar a lista de itens do saldo.
  const packagePickerFullScreen = useMediaQuery('(max-width:600px)');


  // ── Handler para retorno do Google OAuth (URL params) ─────────────────────
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const googleToken = params.get('google_token');
    const googleError = params.get('google_error');
    const isPending = params.get('google_pending');
    const pendingToken = params.get('pending_token');
    const googleNameParam = params.get('google_name');
    const needsPassword = params.get('google_needs_password');

    if (googleToken) {
      // Login/vinculação direta — salvar token e sincronizar sessão do cliente
      localStorage.setItem('cust_token', googleToken);
      axios.get(`${API}/public/${slug}/customers/me`, {
        headers: { Authorization: `Bearer ${googleToken}` }
      }).then(({ data }) => {
        const freshToken = data?.fresh_token || googleToken;
        const customerData = data?.customer || (data?.id ? data : null);

        if (customerData?.id) {
          saveCustomer(customerData, freshToken, slug);
          setCustUser(customerData);
          setLoginOpen(false);
          setLoginError('');
        } else {
          localStorage.removeItem('cust_user');
          localStorage.removeItem('cust_token');
          setLoginOpen(true);
          setLoginError('Nao foi possivel concluir o login com Google. Tente novamente.');
        }
      }).catch((err) => {
        localStorage.removeItem('cust_user');
        localStorage.removeItem('cust_token');
        setLoginOpen(true);
        setLoginError(err?.response?.data?.error || 'Nao foi possivel concluir o login com Google. Tente novamente.');
      });

      // Limpar params da URL sem reload
      const url = new URL(window.location.href);
      url.searchParams.delete('google_token');
      url.searchParams.delete('google_name');
      window.history.replaceState({}, '', url.toString());
    }

    if (googleError) {
      setLoginOpen(true);
      setLoginError(decodeURIComponent(googleError));
      const url = new URL(window.location.href);
      url.searchParams.delete('google_error');
      window.history.replaceState({}, '', url.toString());
    }

    if (isPending && pendingToken) {
      setGooglePendingToken(pendingToken);
      if (needsPassword) {
        // E-mail já cadastrado numa conta COM senha — nunca vincula
        // automático, sempre exige a senha (ver CustomerAuthController).
        setGoogleEmailNeedsPassword(true);
        setGoogleConflictOldName(decodeURIComponent(googleNameParam || ''));
      } else {
        // Conta nova — exige nome + WhatsApp
        setGooglePending(true);
        setGooglePendingName(decodeURIComponent(googleNameParam || ''));
      }
      setLoginOpen(true);
      const url = new URL(window.location.href);
      url.searchParams.delete('google_pending');
      url.searchParams.delete('pending_token');
      url.searchParams.delete('google_name');
      url.searchParams.delete('google_needs_password');
      window.history.replaceState({}, '', url.toString());
    }
  }, []);

  useEffect(() => {
    axios.get(`${API}/public/${slug}`)
      .then(({ data }) => { setCompany(data); const urlProfId = new URLSearchParams(window.location.search).get("professional"); if (urlProfId && data?.professionals) { const found = data.professionals.find((p) => String(p.id) === String(urlProfId)); if (found) setSelPro(found); } })
      .catch(() => {})
      .finally(() => setLoading(false));
    axios.get(`${API}/public/${slug}/reviews`)
      .then(({ data }) => setReviews(data))
      .catch(() => {});
  }, [slug]);

  // Módulo Crescimento (piloto, company_id 7) — captação anônima first-party.
  // Só dispara quando a própria empresa vem com growth_module_enabled=true no
  // perfil público; o endpoint de ingestão também recusa gravar de qualquer
  // forma se não estiver no piloto (defesa em profundidade).
  useEffect(() => {
    if (!company) return;
    trackGrowthEvent(slug, company?.growth_module_enabled, 'page_view');
  }, [company, slug]);

  // Comunicado pop-up: exibe conforme frequência configurada (seguro por default — só mostra se enabled=true)
  useEffect(() => {
    if (!company) return;
    const annCfg = company?.settings?.announcements?.popup;
    if (!annCfg?.enabled || !popupHasContent(annCfg)) return;
    const now = new Date();
    if (annCfg.starts_at && new Date(annCfg.starts_at) > now) return;
    if (annCfg.ends_at && new Date(annCfg.ends_at) < now) return;
    const freq = annCfg.frequency || 'once';
    const key = `ann_popup_${slug}`;
    if (freq === 'once' && localStorage.getItem(key)) return;
    if (freq === 'session' && sessionStorage.getItem(key)) return;
    const t = setTimeout(() => setAnnPopupOpen(true), 700);
    return () => clearTimeout(t);
  }, [company]);

  // [PATCH B] Fallback de confirmação para Checkout Pro (assinaturas)
  // Quando o usuário retorna do MP com ?payment=success&collection_id=X, dispara verificação extra.
  // Garante confirmação mesmo se o webhook falhou.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paymentReturn = params.get('payment');
    const collectionId = params.get('collection_id') || params.get('payment_id');
    if (paymentReturn === 'success' && collectionId) {
      axios.get(`${API}/public/${slug}/verify-payment?payment_id=${collectionId}`)
        .then(({ data }) => {
          if (data.ok && (data.payment_status === 'paid' || data.payment_status === 'approved')) {
            setSnack('✅ Pagamento confirmado! Seu plano está ativo.');
          }
        })
        .catch(() => {}); // silencioso — webhook pode já ter processado
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Facebook Pixel injection (cliente)
  useEffect(() => {
    const pixelId = String(company?.settings?.facebook_pixel_id || '').replace(/[^0-9A-Za-z_-]/g, '');
    if (!pixelId) return;
    if (document.getElementById('fb-pixel-script')) return;
    const script = document.createElement('script');
    script.id = 'fb-pixel-script';
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${pixelId}');fbq('track','PageView');`;
    document.head.appendChild(script);
  }, [company]);

  // Google Analytics (GA4)
  useEffect(() => {
    const gaId = String(company?.settings?.ga_id || '').replace(/[^0-9A-Za-z_-]/g, '');
    if (!gaId || document.getElementById('ga-script')) return;
    const s1 = document.createElement('script');
    s1.id = 'ga-script';
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s1);
    const s2 = document.createElement('script');
    s2.id = 'ga-init';
    s2.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gaId}');`;
    document.head.appendChild(s2);
  }, [company]);

  // Google Tag Manager
  useEffect(() => {
    const gtmId = String(company?.settings?.gtm_id || '').replace(/[^0-9A-Za-z_-]/g, '');
    if (!gtmId || document.getElementById('gtm-script')) return;
    const s = document.createElement('script');
    s.id = 'gtm-script';
    s.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`;
    document.head.appendChild(s);
  }, [company]);

  // Custom scripts list
  useEffect(() => {
    const list = company?.settings?.custom_scripts_list;
    if (!Array.isArray(list) || list.length === 0) return;
    list.forEach((item: any, idx: number) => {
      const id = "custom-script-" + idx;
      if (document.getElementById(id)) return;
      const div = document.createElement('div');
      div.innerHTML = item.code || '';
      Array.from(div.querySelectorAll('script')).forEach((old: any) => {
        const ns = document.createElement('script') as any;
        ns.id = id;
        Array.from(old.attributes).forEach((a: any) => ns.setAttribute(a.name, a.value));
        ns.innerHTML = old.innerHTML;
        document.head.appendChild(ns);
      });
    });
  }, [company]);



  useEffect(() => {
    if (custUser) {
      const fmt = custUser.phone && custUser.phone.length === 11
        ? `(${custUser.phone.slice(0,2)}) ${custUser.phone.slice(2,7)}-${custUser.phone.slice(7)}`
        : (custUser.phone || '');
      setName(custUser.name);
      setPhone(fmt);
    }
  }, [custUser]);

  useEffect(() => {
    const token = localStorage.getItem('cust_token');
    if (!custUser || !token || token === 'null' || token === 'undefined') {
      setCustomerSubscriptions([]);
      setPendingReservations([]);
      setBlockedPlans([]);
      setCustomerSubscriptionsLoading(false);
      return;
    }

    setCustomerSubscriptionsLoading(true);
    axios.get(`${API}/public/${slug}/customers/subscriptions`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(({ data }) => {
        applyCustomerWallet(data);
      })
      .catch(() => { setCustomerSubscriptions([]); setPendingReservations([]); setBlockedPlans([]); })
      .finally(() => setCustomerSubscriptionsLoading(false));
  }, [custUser?.id, slug]);

  // Sticky header on scroll
  useEffect(() => {
    const onScroll = () => {
      const heroHeight = heroRef.current?.offsetHeight || 220;
      setStickyHeader(window.scrollY > heroHeight - 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Reset scroll do modal ao entrar na confirmação
  useEffect(() => {
    if (step === 'done' && dialogContentRef.current) {
      dialogContentRef.current.scrollTop = 0;
    }
  }, [step]);

  const toggleService = (service: any) => {
    setPackageBookingSubscription(null);
    setSelected(prev => {
      const exists = prev.find(s => s.id === service.id);
      if (exists) return prev.filter(s => s.id !== service.id);
      return [...prev, service];
    });
  };

  const removeService = (serviceId: number) => {
    const newSel = selected.filter(s => s.id !== serviceId);
    setSelected(newSel);
    if (newSel.length === 0) {
      setPackageBookingSubscription(null);
      setModalOpen(false);
    }
    setSlots([]);
    setSelTime('');
  };

  const loadSlots = useCallback(async (date: Date, services: any[], pro: any, keepTime?: string) => {
    if (!date || services.length === 0) return;
    setSlotsLoading(true);
    const totalDuration = services.reduce((sum: number, s: any) => sum + s.duration_min, 0);
    const proId = pro?.id || 'any';
    const svc = services[0];
    trackGrowthEvent(slug, company?.growth_module_enabled, 'date_view', { service_id: svc?.id, professional_id: pro?.id || undefined });
    let newSlots: any[] = [];
    try {
      const { data } = await axios.get(`${API}/public/${slug}/availability`, {
        params: { date: format(date, 'yyyy-MM-dd'), professional_id: proId, service_id: svc.id, duration_min: totalDuration }
      });
      if (data.slots) {
        newSlots = data.slots;
      } else if (data.professionals && data.professionals.length > 0) {
        const slotObj: Record<string,any> = {};
        data.professionals.forEach((prof: any) => {
          (prof.slots || []).forEach((slot: any) => {
            if (!slotObj[slot.time] || slot.available) slotObj[slot.time] = slot;
          });
        });
        newSlots = Object.values(slotObj).sort((a: any, b: any) => a.time.localeCompare(b.time));
      }
    } catch {
      newSlots = [];
    }
    setSlots(newSlots);
    if (newSlots.length === 0) {
      trackGrowthEvent(slug, company?.growth_module_enabled, 'no_slots_found', { service_id: svc?.id, professional_id: pro?.id || undefined });
    }
    if (keepTime) {
      const stillAvailable = newSlots.some((s: any) => s.time === keepTime && s.available);
      if (!stillAvailable) setSelTime('');
      // se ainda disponível, mantém o horário selecionado sem chamar setSelTime
    } else {
      setSelTime('');
    }
    setSlotsLoading(false);
  }, [slug, company?.growth_module_enabled]);

  const loadAvailableDays = useCallback(async (month: Date, services: any[], pro: any) => {
    if (services.length === 0) { setAvailableDays([]); return; }
    const monthStr = format(month, "yyyy-MM");
    const totalDuration = services.reduce((sum: number, s: any) => sum + s.duration_min, 0);
    const proId = pro?.id || "any";
    const svc = services[0];
    try {
      const { data } = await axios.get(`${API}/public/${slug}/available-days`, {
        params: { month: monthStr, service_id: svc.id, professional_id: proId, duration_min: totalDuration }
      });
      setAvailableDays(data.available_days || []);
    } catch { setAvailableDays([]); }
  }, [slug]);

  // ── Checkout INTERNO de pacotes — piloto isolado (13/09/2026) ────────────
  // Só existe visualmente quando packagePaymentMethods.inline===true (vem
  // pronto do backend, nunca calculado aqui — mesmo padrão de "online"/
  // "local"). Fora do piloto, packageCheckoutPlan nunca é setado e
  // startPlanCheckout mantém o redirecionamento de sempre. Precisa ficar
  // ANTES de qualquer useEffect que dependa de packageCheckoutStep — um
  // useEffect(fn, [packageCheckoutStep]) executado antes deste useState
  // existir lançaria "Cannot access before initialization" na primeira
  // renderização (bug real encontrado e corrigido nesta rodada de testes).
  const [packageCheckoutPlan, setPackageCheckoutPlan] = useState<any>(null);
  const [packageCheckoutStep, setPackageCheckoutStep] = useState<'choose' | 'pix' | 'card' | 'done'>('choose');
  const [packagePixData, setPackagePixData] = useState<{ qr_code: string; qr_code_base64: string | null; payment_id: number } | null>(null);
  const [packagePixLoading, setPackagePixLoading] = useState(false);
  const [packageBricksReady, setPackageBricksReady] = useState(false);
  const [packageBricksError, setPackageBricksError] = useState('');
  // E-mail: só pedido quando o cliente autenticado não tem um válido
  // cadastrado — nunca sobrescreve o cadastro, é usado só nesta compra.
  const [packageEmailOverride, setPackageEmailOverride] = useState('');
  // ID real da assinatura confirmada active no banco — nunca um objeto
  // "otimista" local. Só existe depois que subscription_status==='active'
  // foi confirmado por polling/resposta do backend (nunca antes).
  const [packageActiveSubscriptionId, setPackageActiveSubscriptionId] = useState<number | null>(null);
  const packageBricksControllerRef = useRef<any>(null);
  const packagePixPollRef = useRef<any>(null);

  const startPlanCheckout = async (plan: any) => {
    if (!custUser) {
      setLoginMode('login');
      setLoginThenBook(false);
      setGoogleReturnPlanId(Number(plan.id));
      setLoginOpen(true);
      setSnack('Entre para comprar o pacote.');
      return;
    }

    const authToken = localStorage.getItem('cust_token');
    if (!authToken || authToken === 'null' || authToken === 'undefined') {
      setLoginMode('login');
      setLoginThenBook(false);
      setGoogleReturnPlanId(Number(plan.id));
      setLoginOpen(true);
      setSnack('Sua sessão expirou. Entre novamente para comprar o pacote.');
      return;
    }

    // Piloto do checkout interno — some se a empresa não tiver a flag ligada
    // (vem pronto do backend); fora do piloto, cai direto no comportamento
    // de sempre (redirecionamento externo), sem nenhuma mudança.
    if (packagePaymentMethods.inline) {
      setPackageCheckoutPlan(plan);
      setPackageCheckoutStep('choose');
      setPackagePixData(null);
      setPackageBricksReady(false);
      setPackageBricksError('');
      setPackageActiveSubscriptionId(null);
      return;
    }

    setPlanCheckoutLoadingId(Number(plan.id));

    try {
      const { data } = await axios.post(
        `${API}/public/${slug}/subscription-plans/${plan.id}/create-payment`,
        {
          customer_name: custUser.name,
          customer_email: custUser.email || undefined,
        },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      if (!data?.checkout_url) {
        throw new Error('Não foi possível iniciar o pagamento do pacote.');
      }

      window.location.href = data.checkout_url;
    } catch (e: any) {
      setSnack(e.response?.data?.error || e.message || 'Não foi possível iniciar a compra do pacote.');
    } finally {
      setPlanCheckoutLoadingId(null);
    }
  };

  // ── Checkout interno de pacotes — piloto isolado ──────────────────────────
  const isValidEmailFormat = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim());
  const custEmailValid = isValidEmailFormat(custUser?.email);
  // E-mail efetivo desta compra: o do cadastro se for válido; senão, o que
  // a pessoa digitar aqui (nunca grava de volta no cadastro do cliente).
  const packageCheckoutEmail = custEmailValid ? custUser.email : packageEmailOverride;
  const packageCheckoutEmailValid = custEmailValid || isValidEmailFormat(packageEmailOverride);

  const closePackageCheckout = () => {
    // Fechar (X) NUNCA cria, ativa nem cancela nada no servidor — só limpa
    // estado local. Um Pix já gerado continua pending_online_payment
    // exatamente como estava; reabrir e escolher Pix de novo reaproveita o
    // mesmo QR (o backend decide isso, não o frontend).
    if (packagePixPollRef.current) { clearInterval(packagePixPollRef.current); packagePixPollRef.current = null; }
    if (packageBricksControllerRef.current) { try { packageBricksControllerRef.current.unmount(); } catch (_) {} packageBricksControllerRef.current = null; }
    setPackageCheckoutPlan(null);
    setPackageEmailOverride('');
  };

  // Seta de voltar (Pix/cartão -> escolha). Mesma garantia do X: nunca
  // cria/ativa/cancela nada — só para o polling local e desmonta o Brick
  // (formulário de cartão OCIOSO, nunca enviado). Se o cliente escolher o
  // MESMO método de novo, o backend reaproveita o pagamento já criado; se
  // escolher o OUTRO método, o backend agora processa esse método de
  // verdade (reivindicação por método, não mais por reserva inteira).
  const backToChoosePayment = () => {
    if (packagePixPollRef.current) { clearInterval(packagePixPollRef.current); packagePixPollRef.current = null; }
    if (packageBricksControllerRef.current) { try { packageBricksControllerRef.current.unmount(); } catch (_) {} packageBricksControllerRef.current = null; }
    setPackagePixData(null);
    setPackageBricksReady(false);
    setPackageBricksError('');
    setPackageCheckoutStep('choose');
  };

  // Confere no PRÓPRIO banco (nunca só no rótulo do pagamento) antes de
  // anunciar sucesso — pedido explícito: nunca mostrar "liberado" com a
  // assinatura ainda pending. Usada tanto pelo polling do Pix quanto, se
  // necessário, logo após o cartão ser processado. Guarda o ID real da
  // assinatura ativada — é ele (nunca um objeto local "otimista") que o
  // botão "Agendar agora" usa para abrir o agendamento com saldo.
  const confirmPackageActiveOrPoll = async (paymentId: number, alreadyKnownStatus?: string | null, alreadyKnownSubId?: number | null) => {
    if (alreadyKnownStatus === 'active') { setPackageActiveSubscriptionId(alreadyKnownSubId || null); setPackageCheckoutStep('done'); return; }
    for (let attempt = 0; attempt < 5; attempt++) {
      try {
        const st = await axios.get(`${API}/public/${slug}/subscription-plans/${packageCheckoutPlan.id}/checkout/payment-status/${paymentId}`);
        if (st.data?.subscription_status === 'active') {
          setPackageActiveSubscriptionId(st.data?.subscription_id || null);
          setPackageCheckoutStep('done');
          return;
        }
        if (['failed', 'cancelled', 'expired'].includes(st.data?.normalized_status)) {
          setSnack('Pagamento não foi aprovado.');
          setPackageCheckoutStep('choose');
          return;
        }
      } catch (_) {}
      await new Promise((r) => setTimeout(r, 1500));
    }
    // Pagamento aprovado mas confirmação da assinatura demorou mais que o
    // esperado — mantém "aguardando" em vez de arriscar anunciar algo que
    // ainda não está confirmado.
  };

  const startPackagePix = async () => {
    if (!packageCheckoutPlan || !packageCheckoutEmailValid) return;
    const authToken = localStorage.getItem('cust_token');
    setPackagePixLoading(true);
    setPackageCheckoutStep('pix');
    try {
      const { data } = await axios.post(
        `${API}/public/${slug}/subscription-plans/${packageCheckoutPlan.id}/checkout/create-pix`,
        { customer_name: custUser?.name, customer_email: packageCheckoutEmail },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      setPackagePixData({ qr_code: data.qr_code, qr_code_base64: data.qr_code_base64, payment_id: data.payment_id });

      packagePixPollRef.current = setInterval(async () => {
        try {
          const st = await axios.get(`${API}/public/${slug}/subscription-plans/${packageCheckoutPlan.id}/checkout/payment-status/${data.payment_id}`);
          // "active" no BANCO é a única prova aceita — normalized_status
          // paid sozinho pode chegar um instante antes da ativação terminar.
          if (st.data?.subscription_status === 'active') {
            clearInterval(packagePixPollRef.current); packagePixPollRef.current = null;
            setPackageActiveSubscriptionId(st.data?.subscription_id || null);
            setPackageCheckoutStep('done');
          }
        } catch (_) {}
      }, 4000);
    } catch (e: any) {
      setSnack(e.response?.data?.error || 'Não foi possível gerar o Pix do pacote.');
      setPackageCheckoutStep('choose');
    } finally {
      setPackagePixLoading(false);
    }
  };

  // Botão "Agendar agora" da tela de sucesso — reaproveita 100% a mesma
  // função já usada pelo aviso "Agendar com saldo" (openPackageBooking):
  // busca a lista real de assinaturas no banco (nunca monta um objeto local
  // "otimista"), acha a que acabou de ativar e entrega pra ELA decidir se
  // pula direto pro calendário (1 serviço) ou abre o seletor (vários) — a
  // MESMA lógica de sempre, sem duplicar nada. Nunca cria agendamento
  // sozinho: só abre a tela de escolher serviço/profissional/data/horário.
  const openJustActivatedPackageBooking = async () => {
    const subId = packageActiveSubscriptionId;
    closePackageCheckout();
    if (!subId) return;
    const authToken = localStorage.getItem('cust_token');
    if (!authToken) return;
    try {
      const { data } = await axios.get(`${API}/public/${slug}/customers/subscriptions`, {
        headers: { Authorization: `Bearer ${authToken}` }
      });
      const rows = applyCustomerWallet(data);
      const justActivated = rows.find((r: any) => Number(r.id) === Number(subId));
      if (justActivated) openPackageBooking(justActivated);
    } catch (_) {
      setSnack('Pacote ativado! Abra a aba Pacotes para agendar com o saldo.');
    }
  };

  async function initPackageBricks(pubKey: string) {
    if (!packageCheckoutPlan) return;
    try {
      const container = document.getElementById('mp-package-bricks-container');
      if (!container) return;
      container.innerHTML = '';
      setPackageBricksError('');
      setPackageBricksReady(false);
      const mp = new (window as any).MercadoPago(pubKey, { locale: 'pt-BR' });
      const bricksBuilder = mp.bricks();
      const amount = Number(packageCheckoutPlan.price || 0);
      const brandColor = company?.settings?.brand_color || '#c9a227';

      const cardSettings = {
        initialization: {
          amount,
          payer: {
            email: packageCheckoutEmail || '',
            firstName: custUser?.name?.split(' ')[0] || '',
            lastName: custUser?.name?.split(' ').slice(1).join(' ') || '',
          },
        },
        customization: {
          paymentMethods: { minInstallments: 1, maxInstallments: Number(company?.settings?.mp_max_installments || 12) },
          // Cor da empresa no próprio formulário do Brick — não fica preso
          // num azul genérico do Mercado Pago.
          visual: { style: { theme: 'default', customVariables: { formBackgroundColor: 'transparent', baseColor: brandColor } } },
        },
        callbacks: {
          onReady: () => setPackageBricksReady(true),
          onError: (err: any) => {
            console.error('[Pacote Brick]', err);
            setPackageBricksReady(true);
            setSnack('Não foi possível carregar o pagamento por cartão. Tente novamente ou use PIX.');
          },
          onSubmit: async (submitData: any) => {
            try {
              const formData = submitData?.formData || submitData;
              const authToken = localStorage.getItem('cust_token');
              const res = await axios.post(
                `${API}/public/${slug}/subscription-plans/${packageCheckoutPlan.id}/checkout/process-payment`,
                { formData },
                { headers: { Authorization: `Bearer ${authToken}` } }
              );
              const normalizedStatus = res.data.normalized_status;
              if (normalizedStatus === 'paid') {
                if (packageBricksControllerRef.current) { try { await packageBricksControllerRef.current.unmount(); } catch (_) {} packageBricksControllerRef.current = null; }
                // Confirma status REAL da assinatura antes de anunciar
                // sucesso — nunca só pelo rótulo do pagamento.
                await confirmPackageActiveOrPoll(res.data.payment_id, res.data.subscription_status, res.data.subscription_id);
                return;
              }
              if (normalizedStatus === 'pending') {
                setSnack('⏳ Pagamento em análise — avisaremos quando confirmar.');
                setPackageBricksReady(true);
                return;
              }
              setSnack('Cartão recusado. Confira os dados ou tente outro cartão.');
              throw new Error('Pagamento recusado');
            } catch (e: any) {
              setSnack(e.message === 'Pagamento recusado' ? 'Cartão recusado. Confira os dados ou tente outro cartão.' : (e.response?.data?.error || 'Erro ao processar pagamento.'));
              setPackageBricksReady(true);
              throw e;
            }
          },
        },
      };

      const controller = await bricksBuilder.create('cardPayment', 'mp-package-bricks-container', cardSettings);
      packageBricksControllerRef.current = controller;
    } catch (e: any) {
      console.error('[Pacote Brick init]', e);
      setPackageBricksError('Não foi possível carregar o formulário do cartão. Atualize a página ou use Pix.');
    }
  }

  useEffect(() => {
    if (packageCheckoutStep === 'card' && company?.settings?.mp_public_key) {
      if ((window as any).MercadoPago) {
        initPackageBricks(company.settings.mp_public_key);
      } else {
        const s = document.createElement('script');
        s.src = 'https://sdk.mercadopago.com/js/v2';
        s.onload = () => initPackageBricks(company.settings.mp_public_key);
        document.head.appendChild(s);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packageCheckoutStep]);

  useEffect(() => {
    return () => { if (packagePixPollRef.current) clearInterval(packagePixPollRef.current); };
  }, []);

  // Adendo 5.3.3 — reservar e pagar no local: MESMO padrão de autenticação
  // do checkout online (login do cliente já existente, nada novo) — só a
  // rota muda. Nunca chama Mercado Pago. Nasce sempre pending_local_payment
  // no backend (regra mais importante: reservar não é pagar).
  const [planReservingId, setPlanReservingId] = useState<number | null>(null);
  const startPlanLocalReservation = async (plan: any) => {
    if (!custUser) {
      setLoginMode('login');
      setLoginThenBook(false);
      setGoogleReturnPlanId(Number(plan.id));
      setLoginOpen(true);
      setSnack('Entre para reservar o pacote.');
      return;
    }
    const authToken = localStorage.getItem('cust_token');
    if (!authToken || authToken === 'null' || authToken === 'undefined') {
      setLoginMode('login');
      setLoginThenBook(false);
      setGoogleReturnPlanId(Number(plan.id));
      setLoginOpen(true);
      setSnack('Sua sessão expirou. Entre novamente para reservar o pacote.');
      return;
    }
    const planKey = Number(plan.id);
    if (planReservingId === planKey) return;
    setPlanReservingId(planKey);
    if (!planReserveRequestRef.current[planKey]) {
      planReserveRequestRef.current[planKey] = (window.crypto as any)?.randomUUID
        ? (window.crypto as any).randomUUID()
        : `r${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
    }
    try {
      const { data } = await axios.post(
        `${API}/public/${slug}/subscription-plans/${plan.id}/reserve-local-payment`,
        { request_id: planReserveRequestRef.current[planKey] },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      // Reservou (ou já estava reservado): a intenção foi atendida, próxima compra usa outra chave.
      delete planReserveRequestRef.current[planKey];
      setSnack(data?.message || 'Pacote reservado. Pagamento pendente no estabelecimento.');
      // Traz a reserva para a tela de forma permanente (não só no aviso passageiro).
      await reloadCustomerWallet();
      setTimeout(() => {
        try { document.querySelector('[data-testid="pending-package-card"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
      }, 250);
    } catch (e: any) {
      const body = e.response?.data;
      // Já reservado/pagando: a chave desta intenção não serve mais; mostra o que existe.
      if (e.response?.status === 409 && body?.existing_status) {
        delete planReserveRequestRef.current[planKey];
        await reloadCustomerWallet();
      }
      setSnack(body?.error || e.message || 'Não foi possível reservar o pacote agora.');
    } finally {
      setPlanReservingId(null);
    }
  };

  const searchNextSlots = async () => {
    if (!selected.length) return;
    setNextSlotsLoading(true);
    setShowInlineNext(true);
    setNextSlotsData([]);
    setInlineNextPage(2);
    const totalDuration = selected.reduce((sum: number, s: any) => sum + s.duration_min, 0);
    const proId = selPro?.id || 'any';
    const svc = selected[0];
    const results: {date:string; label:string; slots:string[]}[] = [];
    let d = addDays(startOfDay(new Date()), 1);
    let tries = 0;
    while (results.length < 5 && tries < 60) {
      tries++;
      const dateStr = format(d, 'yyyy-MM-dd');
      try {
        const { data } = await axios.get(`${API}/public/${slug}/availability`, {
          params: { date: dateStr, professional_id: proId, service_id: svc.id, duration_min: totalDuration }
        });
        let daySlots: string[] = [];
        if (data.slots) {
          daySlots = data.slots.filter((s: any) => s.available).map((s: any) => s.time);
        } else if (data.professionals) {
          const slotMap: Record<string,boolean> = {};
          data.professionals.forEach((p: any) => (p.slots||[]).forEach((s: any) => { if (s.available) slotMap[s.time] = true; }));
          daySlots = Object.keys(slotMap).sort();
        }
        if (daySlots.length > 0) {
          results.push({ date: dateStr, label: format(d, "EEE, dd 'de' MMMM", { locale: ptBR }), slots: daySlots });
        }
      } catch {}
      d = addDays(d, 1);
    }
    setNextSlotsData(results);
    setNextSlotsLoading(false);
  };

  useEffect(() => {
    if (selected.length > 0) loadAvailableDays(calMonth, selected, selPro);
    else setAvailableDays([]);
  }, [calMonth, selected]); // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-advance calendar to first month with available slots
  useEffect(() => {
    if (!availableDays.length) {
      // No slots this month — advance once to next month
      if (!autoAdvancedCalRef.current) {
        autoAdvancedCalRef.current = true;
        setCalMonth(prev => addMonths(prev, 1));
      }
      return;
    }
    autoAdvancedCalRef.current = true; // mark: found slots, stop advancing
    const currentMonthStr = format(calMonth, 'yyyy-MM');
    const hasInCurrentMonth = availableDays.some((d: string) => d.startsWith(currentMonthStr));
    if (!hasInCurrentMonth) {
      const first = availableDays[0];
      if (first) setCalMonth(new Date(first + 'T12:00:00'));
    }
  }, [availableDays]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDateSelect = (date: Date) => {
    setSelDate(date);
    loadSlots(date, selected, selPro);
  };

  const handleProSelect = (pro: any) => {
    setSelPro(pro);
    setProAnchor(null);
    if (selDate) loadSlots(selDate, selected, pro, selTime);
  };



  const openModal = () => {
    // Cobre a página imediatamente antes de qualquer animação do modal
    window.scrollTo({ top: 0, behavior: 'instant' });
    setStep('booking');
    setSelDate(null);
    setSlots([]);
    setSelTime('');
    setSelPro(null);
    setCalMonth(new Date());
    autoAdvancedCalRef.current = false;
    setShowInlineNext(false);
    setNextSlotsData([]);
    setInlineNextPage(2);
    setModalOpen(true);
  };

  const handleAgendarClick = () => {
    setPackageBookingSubscription(null);
    try {
      if ((window as any).fbq && selected.length > 0) {
        (window as any).fbq('track', 'ViewContent', {
          currency: 'BRL',
          value: totalPrice,
          content_name: selected.map((s: any) => s.name).join(' + '),
          content_type: 'service',
        });
      }
    } catch(_) {}
    trackGrowthEvent(slug, company?.growth_module_enabled, 'service_select', { service_id: selected[0]?.id });
    openModal();
  };

  // Piloto "Repetir": ?repeat=1&service=<id>&professional=<id> reaproveita o
  // serviço e o profissional de um atendimento anterior e abre DIRETO a escolha
  // de data/horário (modal normal de criação — mesmas regras de disponibilidade,
  // pagamento, pacote e confirmação). Cria um NOVO agendamento; nada é alterado
  // no histórico. Só dispara com repeat=1 (apenas o piloto gera esse link).
  const repeatHandledRef = React.useRef(false);
  useEffect(() => {
    if (!company || repeatHandledRef.current) return;
    const sp = new URLSearchParams(window.location.search);
    if (sp.get('repeat') !== '1') return;
    repeatHandledRef.current = true;
    const svcId = sp.get('service');
    const svc = svcId ? (company.services || []).find((s: any) => String(s.id) === String(svcId)) : null;
    if (!svc) { setSnack('O serviço do agendamento anterior não está mais disponível. Escolha outro serviço abaixo.'); return; }
    const proId = sp.get('professional');
    const pro = proId ? (company.professionals || []).find((p: any) => String(p.id) === String(proId)) : null;
    setSelected([svc]);
    setSelectedProducts([]);
    setSelectedBumps([]);
    openModal();
    if (pro) setSelPro(pro);
    else if (proId) setSnack('O profissional do agendamento anterior não está mais disponível. Você pode escolher outro.');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  const canContinue = selDate && !!selTime;

  const handleSubmit = async () => {
    if (!custUser && (!name.trim() || !phone.trim())) { setSnack('Preencha seu nome e WhatsApp.'); return; }
    const cleanPhoneDigits = clientWhatsappDigits(phone);
    if (!custUser && !isClientWhatsappComplete(phone)) {
      setSnack('WhatsApp inválido. Digite DDD + número completo.');
      return;
    }
    if (!custUser && company?.settings?.require_phone_confirm === true && clientWhatsappDigits(phone) !== clientWhatsappDigits(phone2)) {
      setSnack('Os números de WhatsApp não coincidem.');
      return;
    }
    setSubmitting(true);
    try {
      // Quando "Qualquer": manda 'any' para o backend escolher o 1º profissional disponível
      const proId = selPro?.id || 'any';
      // Coleta dados para Meta CAPI (EMQ)
      const _fbcCookie = document.cookie.match(/_fbc=([^;]+)/)?.[1];
      const _fbclid = new URLSearchParams(window.location.search).get('fbclid');
      const _fbp = document.cookie.match(/_fbp=([^;]+)/)?.[1];
      const _authToken = localStorage.getItem('cust_token');
      const { data } = await axios.post(`${API}/public/${slug}/bookings`, {
        service_ids: selected.map((s: any) => s.id),
        professional_id: proId,
        date: format(selDate!, 'yyyy-MM-dd'),
        time: selTime,
        customer_name: custUser ? custUser.name : name.trim(),
        // Se logado: não envia phone (identificação via JWT token no header)
        customer_phone: custUser ? undefined : phone.replace(/\D/g, ''),
        customer_id: custUser?.id || undefined,
        customer_email: custUser?.email || (customerEmail.trim() || undefined),
        fbc: _fbcCookie || (_fbclid ? `fb.1.${Date.now()}.${_fbclid}` : undefined),
        fbp: _fbp || undefined,
        // Bumps selecionados — backend revalida e recalcula
        selected_bumps: selectedBumps.map((b: any) => b._bumpType === 'manual' ? { type: 'manual', name: b.name, description: b.description || '', details: b.details || '', price: b.price, original_price: b.original_price ?? null, button_text: b.button_text || '', image_url: b.image_url || '' } : { type: b._bumpType, id: b.id }),
        // Informações para o atendimento — backend revalida/snapshota a pergunta,
        // não confia no texto enviado aqui (só no question_id + answer).
        intake_answers: intakeSavedAnswers || [],
        // Módulo Crescimento (piloto) — correlaciona o booking_created
        // autoritativo (gravado só pelo backend) com o funil anônimo desta
        // mesma sessão. O backend ignora estes campos se a empresa não
        // estiver no piloto.
        ...(company?.growth_module_enabled ? getGrowthIdsForBooking(slug) : {}),
        // Piloto de Crédito — decisão explícita do cliente; o servidor sempre
        // recalcula o valor real a partir do saldo no banco e da força da
        // sessão (F8), nunca confia neste booleano sozinho.
        use_credit: !!(company?.credit_feature_enabled && custUser?.auth_strength === 'strong' && useCreditBalance),
        // "Reservar e pagar no local": agendar a partir de uma reserva ainda NÃO paga
        // escolhe o pacote explicitamente — o servidor só usa reserva pendente com
        // esta escolha e, se não cobrir, recusa (nunca vira cobrança avulsa em silêncio).
        ...(packageBookingSubscription && packageBookingSubscription.status === 'pending_local_payment'
          ? { package_subscription_id: Number(packageBookingSubscription.id) }
          : {}),
      }, custUser && _authToken ? { headers: { Authorization: `Bearer ${_authToken}` } } : {});
      const customerToken = getCustomerToken(data);
      const bookingCustomer = data.customer || (custUser ? custUser : {
        name: name.trim(),
        phone: cleanPhoneDigits,
        email: undefined,
      });
      setBookingResult({ ...data, customer_token: customerToken, customer: bookingCustomer, customer_phone: bookingCustomer?.phone || cleanPhoneDigits });
      if (packageBookingSubscription) reloadCustomerWallet();
      if (bookingCustomer) {
        saveCustomer(bookingCustomer, customerToken, slug);
        setCustUser(bookingCustomer);
      }
      localStorage.setItem('cust_phone', String(bookingCustomer?.phone || cleanPhoneDigits || '').replace(/\D/g, ''));
      // Facebook Pixel
      try {
        if ((window as any).fbq) {
          (window as any).fbq("track", "Schedule", {}, { eventID: data?.capi_event_id || "booking_"+data?.id });
          (window as any).fbq("track", "Lead", {}, { eventID: "lead_"+data?.id });
        }
      } catch (_) {}

      // Pagamento obrigatório — checkout transparente
      const payRequired = company?.settings?.payment_required;
      const mpPublicKey = company?.settings?.mp_public_key;
      const amountDue = Math.max(0, Number(data?.amount_due || 0));
      // Calcular valor real do sinal (payment_partial). Com crédito envolvido
      // (data.credit_applied > 0), o servidor já manda o valor certo pronto
      // em deposit_due (crédito abateu o sinal real por real) — nunca
      // recalcular a % aqui de novo, senão o crédito "valeria mais" do que
      // deveria (ver PublicController.createBooking, comentário sobre D3).
      let depositAmount = amountDue;
      if (Number(data?.credit_applied || 0) > 0) {
        depositAmount = Math.max(0, Number(data?.deposit_due ?? amountDue));
      } else if (company?.settings?.payment_partial) {
        if (company.settings.payment_partial_type === 'fixed') {
          depositAmount = Math.min(Number(company.settings.payment_partial_fixed || 0), amountDue);
        } else {
          depositAmount = Math.min(+(amountDue * (company.settings.payment_partial_pct || 30) / 100).toFixed(2), amountDue);
        }
      }

      // Pagar no local: ignora MP, confirma diretamente
      const cashEnabled = company?.settings?.mp_cash_enabled;
      if (cashEnabled && payMethodSel === 'cash') {
        if (data.id) {
          axios.put(API + "/public/" + slug + "/bookings/" + data.id + "/confirm", { token: data.token }).catch(() => {});
        }
        setStep('done');
        return;
      }

      // depositAmount (não amountDue) decide se abre o checkout do gateway:
      // com crédito cobrindo o sinal inteiro, pode sobrar amountDue>0 (resto
      // pro fechamento) com nada a cobrar agora — nunca abrir o Mercado Pago
      // para R$0.
      if (payRequired && mpPublicKey && depositAmount > 0) {
        trackGrowthEvent(slug, company?.growth_module_enabled, 'payment_start', { service_id: selected[0]?.id });
        setPayAmount(depositAmount);
        setPendingBookingId(data.id);
        setPendingBookingToken(data.token);
        setPendingServiceName(selected.map((s: any) => s.name).join(' + '));
        setBricksReady(false);
        bricksInitRef.current = false;
        const totalSecs = Math.max(30, Number(company?.settings?.payment_expire_minutes || 30)) * 60;
        setPayCountdown(totalSecs);
        setPayTotalSeconds(totalSecs);
        setStep('payment');
        if (countdownRef.current) clearInterval(countdownRef.current);
        countdownRef.current = setInterval(() => {
          setPayCountdown(prev => {
            if (prev <= 1) {
              clearInterval(countdownRef.current);
              axios.delete(`${API}/public/${slug}/bookings/${data.id}`, { data: { token: data.token } }).catch(() => {});
              setPayModal(false);
              setSnack('⏰ Tempo esgotado! O agendamento foi cancelado. Tente novamente.');
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
        return;
      }

      // No payment required — confirma apenas quando ainda estiver pendente
      if (data.id && amountDue > 0) {
        axios.put(API + "/public/" + slug + "/bookings/" + data.id + "/confirm", { token: data.token }).catch(() => {});
      }
      setStep('done');
    } catch (e: any) {
      setSnack(e.response?.data?.error || 'Horário não disponível. Tente outro.');
      if (e.response?.data?.code === 'package_not_covering') reloadCustomerWallet();
      trackGrowthEvent(slug, company?.growth_module_enabled, 'booking_error', {
        service_id: selected[0]?.id,
        error_type: e.response?.data?.code || (e.response?.status ? `http_${e.response.status}` : 'network'),
      });
      // Piloto (prazo mínimo em minutos): o horário selecionado ficou
      // indisponível entre a listagem e o envio. Recarrega só a lista de
      // horários — nunca limpa nome/WhatsApp/serviços já preenchidos.
      if (e.response?.data?.code === 'slot_unavailable' && selDate) {
        loadSlots(selDate, selected, selPro);
      }
    } finally { setSubmitting(false); }
  };

  const [forgotOpen, setForgotOpen] = React.useState(false);
  const [forgotEmail, setForgotEmail] = React.useState('');
  const [forgotSent, setForgotSent] = React.useState(false);
  const [forgotLoading, setForgotLoading] = React.useState(false);
  const [forgotError, setForgotError] = React.useState('');

  const handleForgotCustomer = async () => {
    if (!forgotEmail) return;
    setForgotLoading(true);
    setForgotError('');
    try {
      await fetch('/api/auth/forgot-password', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: forgotEmail }) });
      setForgotSent(true);
    } catch(e) {
      setForgotError('Erro ao enviar. Tente novamente.');
    } finally {
      setForgotLoading(false);
    }
  };

  const resetLoginForm = () => {
    setLoginEmail(''); setLoginPassword(''); setLoginName('');
    setLoginPhone(''); setLoginError(''); setLoginShowPwd(false);
  };

  const openPackageBooking = (subscription: any) => {
    const remaining = Array.isArray(subscription?.items)
      ? subscription.items.filter((it: any) => Math.max(0, Number(it?.quantity_total || 0) - Number(it?.quantity_used || 0)) > 0)
      : [];

    // Atalho: se só há 1 item elegível, pula o picker
    if (remaining.length === 1) {
      const onlyItem = remaining[0];
      const serviceId = Number(onlyItem?.service_id || onlyItem?.service?.id || 0);
      if (serviceId) {
        const svc = (company?.services || []).find((s: any) => Number(s.id) === serviceId);
        if (svc) {
          setSelected([svc]);
          setSelectedProducts([]);
          setSelectedBumps([]);
          setPackageBookingSubscription(subscription);
          setPackageSelectionIds([serviceId]);
          openModal();
          return;
        }
      }
    }

    // Caso geral: abre o picker para o cliente escolher
    setPackagePickerPlan(subscription);
    setPackageSelectionIds([]);
    setPackagePickerOpen(true);
  };

  const togglePackageSelection = (item: any) => {
    const serviceId = Number(item?.service_id || item?.service?.id || 0);
    if (!serviceId) return;
    if (getSubscriptionRemaining(item) <= 0) return;

    setPackageSelectionIds((prev) => {
      if (prev.includes(serviceId)) return prev.filter((id) => id !== serviceId);
      return [...prev, serviceId];
    });
  };

  const continuePackageBooking = () => {
    if (!packageSelectionIds.length) {
      setSnack('Selecione pelo menos um item do seu saldo para continuar.');
      return;
    }

    const selectedServices = packageSelectionIds
      .map((serviceId) => (company?.services || []).find((service: any) => Number(service.id) === Number(serviceId)))
      .filter(Boolean);

    if (!selectedServices.length) {
      setSnack('Não foi possível localizar os serviços desse pacote para abrir a agenda.');
      return;
    }

    setSelected(selectedServices);
    setSelectedProducts([]);
    setSelectedBumps([]);
    setPackageBookingSubscription(packagePickerPlan);
    setPackagePickerOpen(false);
    openModal();
  };



  // ── Google OAuth: iniciar fluxo redirect ─────────────────────────────────
  const handleGoogleLogin = () => {
    setGoogleLoading(true);
    setLoginError('');
    // Adendo 5.4.1 — leva o pacote pretendido pro backend (que valida e
    // assina no state) só quando o login começou a partir de uma compra de
    // pacote; login normal continua sem nenhum parâmetro extra.
    const returnQs = googleReturnPlanId ? `?tab=pacotes&pacote=${googleReturnPlanId}` : '';
    window.location.href = `${API}/public/${slug}/customers/google/start${returnQs}`;
  };

  // ── Fallback pós-MP: ao voltar de checkout de pacote com ?payment=success,
  //    força refetch das assinaturas do cliente algumas vezes (caso webhook atrase)
  useEffect(() => {
    if (!custUser) return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('payment') !== 'success') return;
    if (params.get('tab') !== 'subscriptions') return;

    let attempts = 0;
    const maxAttempts = 6; // ~30s
    const interval = setInterval(() => {
      attempts++;
      const tok = localStorage.getItem('cust_token');
      if (!tok) { clearInterval(interval); return; }
      axios.get(`${API}/public/${slug}/customers/subscriptions`, {
        headers: { Authorization: `Bearer ${tok}` }
      }).then(({ data }) => {
        const rows = applyCustomerWallet(data);
        const recent = rows.find((r: any) => r.status === 'active' && r.source === 'public_checkout');
        if (recent || attempts >= maxAttempts) {
          clearInterval(interval);
          if (recent) {
            setSnack('Pacote ativado com sucesso! ✓');
            // limpa o ?payment=success da URL para não disparar de novo
            try {
              const url = new URL(window.location.href);
              url.searchParams.delete('payment');
              window.history.replaceState({}, '', url.toString());
            } catch {}
          }
        }
      }).catch(() => {
        if (attempts >= maxAttempts) clearInterval(interval);
      });
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [custUser, slug]);

  // ── Completar cadastro Google com nome + WhatsApp ─────────────────────────
  const handleGoogleComplete = async () => {
    if (!googlePendingName.trim()) { setGooglePendingPhoneError('Informe seu nome.'); return; }
    const cleanPhone = googlePendingPhone.replace(/\D/g, '');
    if (cleanPhone.length < 10) { setGooglePendingPhoneError('WhatsApp inválido.'); return; }
    setGoogleLoading(true);
    setGooglePendingPhoneError('');
    try {
      const { data } = await axios.post(`${API}/public/${slug}/customers/google/complete`, {
        pending_token: googlePendingToken,
        name: googlePendingName,
        phone: cleanPhone,
      });
      afterLogin(data.customer, data.token);
      setGooglePending(false);
    } catch (e: any) {
      if (e?.response?.data?.error === 'phone_conflict') {
        const d = e.response.data;
        setGooglePhoneConflict(true);
        setGoogleConflictOldName(d.old_customer_name || '');
        setGoogleConflictOldHasPassword(!!d.old_has_password);
        setGooglePendingPhoneError('');
      } else {
        setGooglePendingPhoneError(e?.response?.data?.error || 'Erro ao criar conta.');
      }
    } finally { setGoogleLoading(false); }
  };

  // ── Vincular conta antiga via senha ───────────────────────────────────────
  const handleGoogleLink = async () => {
    if (googleConflictOldHasPassword && !googleConflictPassword) {
      setGoogleConflictError('Informe a senha da conta antiga.'); return;
    }
    setGoogleLoading(true);
    setGoogleConflictError('');
    try {
      const { data } = await axios.post(`${API}/public/${slug}/customers/google/link`, {
        pending_token: googlePendingToken,
        phone: googlePendingPhone,
        ...(googleConflictOldHasPassword ? { password: googleConflictPassword } : {}),
      });
      afterLogin(data.customer, data.token);
      setGooglePending(false);
      setGooglePhoneConflict(false);
    } catch (e: any) {
      setGoogleConflictError(e?.response?.data?.error || 'Erro ao vincular conta.');
    } finally { setGoogleLoading(false); }
  };

  // ── Vincular conta encontrada por e-mail (sempre exige senha) ─────────────
  const handleGoogleEmailLink = async () => {
    if (!googleConflictPassword) { setGoogleConflictError('Informe sua senha.'); return; }
    setGoogleLoading(true);
    setGoogleConflictError('');
    try {
      const { data } = await axios.post(`${API}/public/${slug}/customers/google/link`, {
        pending_token: googlePendingToken,
        password: googleConflictPassword,
      });
      afterLogin(data.customer, data.token);
      setGoogleEmailNeedsPassword(false);
    } catch (e: any) {
      setGoogleConflictError(e?.response?.data?.error || 'Erro ao vincular conta.');
    } finally { setGoogleLoading(false); }
  };

  const afterLogin = (customer: any, token: string) => {
    saveCustomer(customer, token, slug);
    setCustUser(customer);
    setLoginOpen(false);
    resetLoginForm();
    if (loginThenBook) {
      setLoginThenBook(false);
      setTimeout(openModal, 150);
    }
  };

  const handleLogin = async () => {
    if (!loginEmail || !loginPassword) { setLoginError('Preencha e-mail/telefone e senha.'); return; }
    setLoginLoading(true);
    setLoginError('');
    try {
      const raw = loginEmail.trim();
      const isPhone = /^[\d\s()+-]+$/.test(raw) && raw.replace(/\D/g,'').length >= 10;
      const body: any = { password: loginPassword };
      if (isPhone) {
        let ph = raw.replace(/\D/g,'');
        if (ph.length === 10) ph = ph.slice(0,2) + '9' + ph.slice(2);
        body.phone = ph;
      } else {
        body.email = raw.toLowerCase();
      }
      const { data } = await axios.post(`${API}/public/${slug}/customers/login`, body);
      afterLogin(data.customer, data.token);
    } catch (e: any) {
      setLoginError(e.response?.data?.error || 'Dados inválidos ou senha incorreta.');
    } finally { setLoginLoading(false); }
  };

  const handleRegister = async () => {
    if (!loginName || !loginPassword) { setLoginError('Preencha nome e senha.'); return; }
    if (!loginEmail && !loginPhone) { setLoginError('Informe WhatsApp ou e-mail.'); return; }
    // Validar: se loginEmail parecer telefone, rejeitar
    const emailVal = loginEmail.trim();
    if (emailVal && /^[\d\s()+-]+$/.test(emailVal)) {
      setLoginError('Use o campo WhatsApp para o telefone. O e-mail deve conter @.');
      return;
    }
    if (emailVal && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
      setLoginError('E-mail inválido.');
      return;
    }
    setLoginLoading(true);
    setLoginError('');
    try {
      const cleanPhone = loginPhone.replace(/\D/g, '');
      const { data } = await axios.post(`${API}/public/${slug}/customers/register`, {
        name: loginName,
        phone: cleanPhone || undefined,
        email: emailVal || undefined,
        password: loginPassword
      });
      afterLogin(data.customer, data.token);
    } catch (e: any) {
      setLoginError(e.response?.data?.error || 'Erro ao cadastrar.');
    } finally { setLoginLoading(false); }
  };

  const copyAddress = () => {
    if (!company?.address) return;
    navigator.clipboard.writeText(company.address).then(() => setSnack('Endereço copiado!'));
  };

  const sharePage = () => {
    if (navigator.share) {
      navigator.share({ title: company?.name, url: window.location.href });
    } else {
      navigator.clipboard.writeText(window.location.href).then(() => setSnack('Link copiado!'));
    }
  };

  const monthStart = startOfMonth(calMonth);
  const monthEnd = endOfMonth(calMonth);
  const allDays = eachDayOfInterval({ start: monthStart, end: monthEnd });
  const startPad = monthStart.getDay();
  const filteredServices = (company?.services || [])
    .slice().sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0))
    .filter((s: any) => s.name.toLowerCase().includes(search.toLowerCase()));
  const professionals = company?.professionals || [];
  const products = company?.products || [];
  const hasProducts = products.length > 0;
  const subscriptionPlans = company?.subscription_plans || [];
  const hasSubscriptions = subscriptionPlans.length > 0;
  // Adendo 5.3.3 — quais formas de pagamento de pacote a empresa aceita
  // hoje (vem pronto do backend público, nunca calculado aqui).
  const packagePaymentMethods = company?.subscription_payment_methods || { online: false, local: false, inline: false };
  const [planChoiceOpenId, setPlanChoiceOpenId] = useState<number | null>(null);
  const visibleTabs = ['Serviços', ...(hasProducts ? ['Produtos'] : []), ...(hasSubscriptions ? ['Pacotes'] : [])];
  const subscriptionsTabIndex = hasSubscriptions ? (hasProducts ? 2 : 1) : -1;
  const infoTabIndex = visibleTabs.length;
  const activeCustomerSubscriptions = customerSubscriptions.filter((row: any) => row.status === 'active');
  const getSubscriptionTypeLabel = (kind: string) => kind === 'recurring' ? 'Assinatura mensal' : 'Pacote avulso';
  const getSubscriptionItemLabel = (item: any) => item?.service?.name || item?.title || 'Item incluso';
  const getSubscriptionTitle = (plan: any) => plan?.public_title || plan?.name || 'Pacote';
  const getSubscriptionSubtitle = (plan: any) => plan?.public_subtitle || plan?.description || '';
  const getSubscriptionRemaining = (item: any) => Math.max(0, Number(item?.quantity_total || 0) - Number(item?.quantity_used || 0));
  // Adendo 5.4.3 — a fórmula antiga somava +1 a mais (um pacote que vence
  // hoje mostrava "1 dia restante" em vez de "vence hoje"; um que vence em
  // 27 dias mostrava "28 dias"). Recalcula "hoje" na hora (não usa a
  // constante `today` do topo do módulo, que fica presa na data do carregamento
  // da página — uma aba aberta durante a virada do dia mostraria dias errados).
  const getSubscriptionDaysLeft = (endDate?: string) => {
    if (!endDate) return 0;
    const todayFresh = startOfDay(new Date());
    const end = startOfDay(parseISO(`${endDate}T12:00:00`));
    if (isNaN(end.getTime())) return 0;
    return Math.round((end.getTime() - todayFresh.getTime()) / 86400000);
  };
  // Estado visual por prazo (Adendo 5.4.3 — Item 2, verbatim): >7 dias
  // neutro; ≤7 dias alerta; vence hoje; vencido nunca aparece aqui (o
  // endpoint já só devolve pacotes com end_date >= hoje).
  const getSubscriptionUrgency = (daysLeft: number) => {
    if (daysLeft <= 0) return { label: 'Vence hoje', warn: true };
    if (daysLeft <= 7) return { label: `Faltam ${daysLeft} dia${daysLeft === 1 ? '' : 's'}`, warn: true };
    return { label: `Faltam ${daysLeft} dias`, warn: false };
  };
  // Adendo 5.4.3.2 — decisão de produto (após o incidente do agrupamento):
  // cada instância de pacote continua sendo mostrada SEPARADAMENTE, sem
  // mesclar visualmente duas ativações do mesmo plano. Nada de soma ou
  // prorrogação automática de validade — isso fica para uma regra própria
  // de renovação, futura. O comportamento atual (2 cartões iguais quando o
  // dono autoriza duas ativações) é aceitável por ora.
  //
  // Causa raiz do incidente (P0, 2026-08-30 22:56–02:03 UTC): a versão
  // anterior desta seção usava `new Map(...)` para agrupar por plano — mas
  // este arquivo já importa um ÍCONE chamado `Map` de @mui/icons-material
  // (linha ~14, usado noutro lugar da página). Dentro deste módulo, esse
  // import SOMBREIA o `Map` global do JavaScript: `new Map()` executava na
  // real "new <ÍconeMap>()", que não é construtor — TypeError imediato, em
  // TODO carregamento da página (a lista roda mesmo sem cliente logado),
  // para qualquer empresa. Corrigido não reintroduzindo `new Map` nesta
  // página; se agrupamento voltar no futuro, usar objeto plano ou renomear
  // o import do ícone (ex.: `Map as MapIcon`).
  const packagePickerItems = Array.isArray(packagePickerPlan?.items) ? packagePickerPlan.items.filter((item: any) => getSubscriptionRemaining(item) > 0) : [];
  const selectedPackageServices = packageSelectionIds
    .map((serviceId) => (company?.services || []).find((service: any) => Number(service.id) === Number(serviceId)))
    .filter(Boolean);
  const selectedPackageDuration = selectedPackageServices.reduce((sum: number, service: any) => sum + Number(service.duration_min || 0), 0);

  useEffect(() => {
    const tab = String(new URLSearchParams(window.location.search).get('tab') || '').toLowerCase();
    if (!hasSubscriptions || !tab) return;
    if (tab.includes('pacot') || tab.includes('assin') || tab.includes('sub')) {
      setActiveTab(subscriptionsTabIndex);
    }
  }, [hasSubscriptions, subscriptionsTabIndex]);

  // Adendo 5.3.2 — Item 8: link direto para um pacote (?pacote=123). O
  // pacote já chega em subscriptionPlans só quando publicado, ativo e da
  // empresa certa (o backend filtra isso no GET público) — então basta
  // procurar o id aqui. Se não encontrar (interno, excluído, de outra
  // empresa, ou o parâmetro nem existir), a vitrine normal aparece sem
  // nenhum erro. Funciona depois de reload e de link compartilhado porque
  // só depende da URL, sem estado guardado em nenhum outro lugar.
  const highlightPlanId = Number(new URLSearchParams(window.location.search).get('pacote')) || null;
  const [planNotFoundNotice, setPlanNotFoundNotice] = useState(false);
  const planRefs = useRef<Record<string, HTMLDivElement | null>>({});

  useEffect(() => {
    if (!highlightPlanId || !hasSubscriptions) return;
    setActiveTab(subscriptionsTabIndex);
    const found = subscriptionPlans.some((p: any) => Number(p.id) === highlightPlanId);
    if (!found) { setPlanNotFoundNotice(true); return; }
    const el = planRefs.current[highlightPlanId];
    if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'center' }), 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [highlightPlanId, hasSubscriptions, subscriptionPlans.length]);

  // Descrição do pacote recolhida (3 linhas) com "Ver mais/menos" — puramente
  // visual, não mexe em nenhum dado. descOverflowing decide se o controle
  // aparece (só quando o texto realmente estoura 3 linhas). Usa ResizeObserver
  // (não uma medição única) porque a largura real do bloco só se estabiliza
  // depois da imagem/fonte carregar — uma medição de um instante só (RAF logo
  // após montar) podia rodar cedo demais e nunca marcar overflow, deixando o
  // "Ver mais" sem aparecer. O observer refaz a medição toda vez que a caixa
  // muda de tamanho — MAS só enquanto o texto está recolhido: expandido
  // (display:'block', sem clamp) o próprio elemento nunca "estoura" a si
  // mesmo, então remedir nesse estado sempre daria overflow=false e o botão
  // ("Ver menos") sumiria assim que o usuário clicasse em "Ver mais". A ref
  // guarda o valor síncrono de "está expandido" para o callback do observer
  // (que roda fora do ciclo do React) consultar. IMPORTANTE: a ref é escrita
  // diretamente dentro do onClick (toggleExpandedPlanDesc), não por um
  // useEffect companion em cima de expandedPlanDesc — um useEffect só roda
  // DEPOIS do commit, e o ResizeObserver (disparado pela própria mudança de
  // display/altura) podia rodar antes desse effect, lendo a ref ainda com o
  // valor antigo — corrida real, já observada em produção antes deste ajuste.
  const [expandedPlanDesc, setExpandedPlanDesc] = useState<Record<string, boolean>>({});
  const [descOverflowing, setDescOverflowing] = useState<Record<string, boolean>>({});
  const planDescRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const expandedPlanDescRef = useRef<Record<string, boolean>>({});
  const toggleExpandedPlanDesc = (id: string | number) => {
    setExpandedPlanDesc((prev) => {
      const next = { ...prev, [id]: !prev[id] };
      expandedPlanDescRef.current = next;
      return next;
    });
  };

  useEffect(() => {
    if (typeof ResizeObserver === 'undefined') return;
    const observers: ResizeObserver[] = [];
    Object.entries(planDescRefs.current).forEach(([id, el]) => {
      if (!el) return;
      const check = () => {
        if (expandedPlanDescRef.current[id]) return; // recolhido é a única medição confiável
        const isOverflowing = el.scrollHeight > el.clientHeight + 1;
        setDescOverflowing((prev) => (prev[id] === isOverflowing ? prev : { ...prev, [id]: isOverflowing }));
      };
      check();
      const ro = new ResizeObserver(check);
      ro.observe(el);
      observers.push(ro);
    });
    return () => observers.forEach((ro) => ro.disconnect());
  }, [subscriptionPlans, activeTab]);


  useEffect(() => {
    if (loading || !company) return;
    if (step !== 'payment' || payMethodSel !== 'card') return;
    const pubKey = company?.settings?.mp_public_key;
    if (!pubKey || !pendingBookingId) return;
    if (bricksInitRef.current) return;

    let cancelled = false;
    let sdkTimer: any = null;
    let frame: any = null;
    bricksInitRef.current = true;
    setBricksError('');
    setBricksReady(false);

    const failSdkLoad = () => {
      if (cancelled) return;
      setBricksReady(true);
      setBricksError('Não foi possível carregar o Mercado Pago neste navegador. Atualize a página ou use Pix.');
      setSnack('Não foi possível carregar o cartão. Tente novamente ou use PIX.');
      bricksInitRef.current = false;
    };

    const startBricks = () => {
      if (!cancelled) initBricks(pubKey);
    };

    frame = window.requestAnimationFrame(() => {
      if ((window as any).MercadoPago) {
        startBricks();
        return;
      }

      const existing = document.querySelector('script[src="https://sdk.mercadopago.com/js/v2"]');
      const armTimeout = () => {
        sdkTimer = window.setTimeout(() => {
          if (!(window as any).MercadoPago) failSdkLoad();
        }, 10000);
      };

      if (existing) {
        armTimeout();
        existing.addEventListener('load', () => {
          if (sdkTimer) window.clearTimeout(sdkTimer);
          if ((window as any).MercadoPago) startBricks();
          else failSdkLoad();
        }, { once: true });
        existing.addEventListener('error', failSdkLoad, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://sdk.mercadopago.com/js/v2';
      script.async = true;
      armTimeout();
      script.onload = () => {
        if (sdkTimer) window.clearTimeout(sdkTimer);
        if ((window as any).MercadoPago) startBricks();
        else failSdkLoad();
      };
      script.onerror = failSdkLoad;
      document.head.appendChild(script);
    });

    return () => {
      cancelled = true;
      if (sdkTimer) window.clearTimeout(sdkTimer);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [loading, company, step, payMethodSel, pendingBookingId, payAmount, bricksRetryKey]);

  // ── Mercado Pago Device ID (security.js) — carrega assim que a empresa é
  //    carregada (não só no checkout) para dar tempo de gerar
  //    window.MP_DEVICE_SESSION_ID, usado no header X-meli-session-id (anti-fraude)
  useEffect(() => {
    if (!company?.settings?.mp_public_key) return;
    if (document.getElementById('mp-security-js')) return;
    const s = document.createElement('script');
    s.id = 'mp-security-js';
    s.src = 'https://www.mercadopago.com/v2/security.js';
    s.setAttribute('view', 'checkout');
    s.async = true;
    document.head.appendChild(s);
  }, [company]);

  // Avaliação proativa (Parte 1, rodada 3) — busca o atendimento completed
  // mais recente sem avaliação e, se existir, mostra o modal. Precisa vir
  // antes dos `return` condicionais abaixo (regra dos Hooks: mesma ordem em
  // todo render) — por isso lê `company?.settings` direto em vez da const
  // `proactiveReviewPilot`, que só é declarada depois.
  useEffect(() => {
    if (company?.settings?.proactive_review_pilot !== true || !custUser) return;
    const authToken = localStorage.getItem('cust_token');
    if (!authToken) return;
    let cancelled = false;
    axios.get(`${API}/public/${slug}/reviews/pending`, { headers: { Authorization: `Bearer ${authToken}` } })
      .then(({ data }) => {
        if (cancelled || !data?.booking) return;
        const skipKey = `reviewSkip_${data.booking.id}`;
        if (sessionStorage.getItem(skipKey)) return;
        setPendingReview(data.booking);
        setPendingReviewOpen(true);
      })
      .catch(() => {});
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company?.settings?.proactive_review_pilot, custUser?.id, slug]);

  // Upsell pós-agendamento (Parte 2, rodada 3) — busca a oferta elegível
  // assim que a confirmação real (não a prévia) é exibida. Mesma razão
  // acima: lê company?.settings direto, precisa vir antes dos returns.
  useEffect(() => {
    if (company?.settings?.confirmation_ui_v2_pilot !== true || step !== 'done' || !bookingResult?.id) return;
    const authToken = bookingResult?.customer_token || localStorage.getItem('cust_token');
    if (!authToken) return;
    let cancelled = false;
    axios.get(`${API}/public/${slug}/bookings/${bookingResult.id}/upsell`, { headers: { Authorization: `Bearer ${authToken}` } })
      .then(({ data }) => { if (!cancelled) setUpsellOffer(data?.offer || null); })
      .catch(() => {});
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company?.settings?.confirmation_ui_v2_pilot, step, bookingResult?.id]);

  if (loading) return (
    <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center', minHeight:'100vh', bgcolor:'#f5f5f5' }}>
      <CircularProgress sx={{ color: '#c9a227' }} />
    </Box>
  );

  if (!company) return (
    <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center', minHeight:'100vh' }}>
      <Typography color="text.secondary">Estabelecimento não encontrado.</Typography>
    </Box>
  );

  const waPhone = company.phone ? company.phone.replace(/\D/g,'') : '';
  const avgRating = reviews.length > 0 ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length) : null;
  const ratingLabel = avgRating ? (avgRating >= 4.5 ? 'Excelente' : avgRating >= 4 ? 'Muito bom' : avgRating >= 3 ? 'Bom' : 'Regular') : null;
  const accentColor = company?.settings?.brand_color || '#c9a227';
  // ── Dark mode (Phase 1: preview via ?preview_dark=1) ─────────────────────
  const previewDark = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('preview_dark') === '1';
  const isDark = previewDark || company?.settings?.public_dark_mode === true;
  const T: DarkTheme = isDark ? DARK_THEME : null;
  // ─────────────────────────────────────────────────────────────────────────
  const showBanner = company?.settings?.show_banner !== false && !!company?.cover_url;
  const isPreview = new URLSearchParams(window.location.search).get('preview') === 'true';
  // Visual novo do menu/barra de prévia — padrão GLOBAL desde a liberação de
  // 05/08/2026. Fallback individual: settings.legacy_client_ui=true faz uma
  // empresa específica voltar à UI antiga sem afetar as demais.
  // (o estado testConfirmOpen fica lá em cima, junto dos outros useState,
  // pra não violar a regra dos Hooks — este componente tem um return
  // condicional antes deste ponto.)
  const pilotUI = company?.settings?.legacy_client_ui !== true;
  // Piloto visual da tela de confirmação (Parte 5 da auditoria 09/08/2026).
  // Opt-in explícito por empresa — ausência ou qualquer valor != true mantém
  // a tela antiga. Hoje só company_id 7 (slug barbeariara) tem a flag ligada.
  const confirmationV2Pilot = company?.settings?.confirmation_ui_v2_pilot === true;
  // Avaliação proativa (Parte 1, rodada 3) — opt-in por empresa, mesma
  // convenção da flag acima. Hoje só company_id 7.
  const proactiveReviewPilot = company?.settings?.proactive_review_pilot === true;
  // Piloto do novo seletor de forma de pagamento (lista compacta + selo "Recomendado") na etapa Confirmar. Decidido SÓ pelo id da
  // empresa carregada na página (config/paymentSelectorFlags.ts): nunca pelo usuário logado nem por parâmetro da URL.
  const paymentSelectorB = isPaymentSelectorBOn(company?.id);

  const skipPendingReview = () => {
    if (pendingReview) {
      sessionStorage.setItem(`reviewSkip_${pendingReview.id}`, '1');
      const authToken = localStorage.getItem('cust_token');
      if (authToken) {
        axios.post(`${API}/public/${slug}/reviews/skip`, { booking_id: pendingReview.id },
          { headers: { Authorization: `Bearer ${authToken}` } }).catch(() => {});
      }
    }
    setPendingReviewOpen(false);
  };

  const submitPendingReview = async (rating: number, comment: string) => {
    if (!pendingReview) return;
    setPendingReviewSubmitting(true);
    try {
      const authToken = localStorage.getItem('cust_token');
      await axios.post(`${API}/public/${slug}/reviews`, { booking_id: pendingReview.id, rating, comment },
        { headers: { Authorization: `Bearer ${authToken}` } });
      setPendingReviewOpen(false);
      setSnack('Obrigado pela sua avaliação!');
    } catch (err: any) {
      setSnack(err?.response?.data?.error || 'Não foi possível enviar a avaliação agora.');
    } finally {
      setPendingReviewSubmitting(false);
    }
  };

  const acceptUpsellOffer = async () => {
    if (!upsellOffer || !bookingResult?.id || upsellAccepting) return;
    setUpsellAccepting(true);
    try {
      const authToken = bookingResult?.customer_token || localStorage.getItem('cust_token');
      const idempotencyKey = `${bookingResult.id}-${upsellOffer.service_upsell_id}-${(window.crypto as any)?.randomUUID ? (window.crypto as any).randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2)}`;
      const { data } = await axios.post(
        `${API}/public/${slug}/bookings/${bookingResult.id}/upsell/accept`,
        { idempotency_key: idempotencyKey },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      if (data?.accepted) {
        setUpsellAccepted({ item_name: data.item_name, item_price: Number(data.item_price) });
        setUpsellOffer(null);
      }
    } catch (err: any) {
      setSnack(err?.response?.data?.error || 'Não foi possível adicionar agora.');
    } finally {
      setUpsellAccepting(false);
    }
  };
  const handleAddToCalendar = () => {
    try {
      const title = `Agendamento - ${selected.map((s: any) => s.name).join(' + ')}`;
      const dateObj = selDate ? new Date(selDate) : new Date();
      const [h, m] = String(selTime || '09:00').split(':').map(Number);
      dateObj.setHours(h || 9, m || 0, 0, 0, 0);
      const totalMinutes = selected.reduce((acc: number, s: any) => acc + Number(s.duration || s.duration_minutes || s.duration_min || 30), 0) || 30;
      const endObj = new Date(dateObj.getTime() + totalMinutes * 60000);
      const fmt = (d: Date) => d.toISOString().replace(/[-:]|\.\d{3}/g, '');
      const details = [
        company?.name ? `Estabelecimento: ${company.name}` : '',
        selPro?.name ? `Profissional: ${selPro.name}` : '',
        selected.length ? `Servico: ${selected.map((s: any) => s.name).join(' + ')}` : '',
        selectedBumps.length ? `Extras: ${selectedBumps.map((b: any) => b.name).join(', ')}` : '',
      ].filter(Boolean).join('\n');
      const params = new URLSearchParams({
        action: 'TEMPLATE',
        text: title,
        dates: `${fmt(dateObj)}/${fmt(endObj)}`,
        details,
      });
      if (company?.address) params.set('location', company.address);
      window.open(`https://calendar.google.com/calendar/render?${params.toString()}`, '_blank', 'noopener,noreferrer');
    } catch (_) {
      setSnack('Nao foi possivel abrir o calendario agora.');
    }
  };

  async function initBricks(pubKey: string) {
    try {
      const container = document.getElementById('mp-bricks-container');
      if (!container) {
        bricksInitRef.current = false;
        return;
      }
      container.innerHTML = '';
      setBricksError('');
      setBricksReady(false);
      const mp = new (window as any).MercadoPago(pubKey, { locale: 'pt-BR' });
      const bricksBuilder = mp.bricks();

      // Config de parcelas e desconto PIX das settings da empresa
      const maxInstallments = company?.settings?.mp_max_installments || 12;
      const pixDiscount = company?.settings?.mp_pix_discount || 0; // %
      // Calcular valor do sinal localmente (idêntico ao confirm step)
      const _svcTotal = selected.reduce((a: number, s: any) => a + Number(s.price), 0);
      let bricksAmount = _svcTotal;
      if (company?.settings?.payment_partial) {
        if (company.settings.payment_partial_type === 'fixed') {
          bricksAmount = Math.min(Number(company.settings.payment_partial_fixed || 0), _svcTotal);
        } else {
          bricksAmount = Math.min(+(_svcTotal * (company.settings.payment_partial_pct || 30) / 100).toFixed(2), _svcTotal);
        }
      }
      const pixAmount = pixDiscount > 0 ? +(bricksAmount * (1 - pixDiscount / 100)).toFixed(2) : bricksAmount;
      const pixEnabled = company?.settings?.mp_pix_enabled !== false;
      const cardEnabled = company?.settings?.mp_card_enabled !== false;
      const primaryMethod = company?.settings?.mp_primary_method || 'pix';

      if (!cardEnabled) {
        setBricksReady(true);
        setBricksError('Pagamento por cartão não está habilitado para este estabelecimento.');
        return;
      }

      const cardSettings = {
        initialization: {
          amount: bricksAmount,
          payer: {
            email: custUser?.email || '',
            firstName: custUser?.name?.split(' ')[0] || '',
            lastName: custUser?.name?.split(' ').slice(1).join(' ') || '',
          },
        },
        customization: {
          paymentMethods: {
            minInstallments: 1,
            maxInstallments: Number(maxInstallments),
          },
          visual: {
            style: { theme: 'default' },
          },
        },
        callbacks: {
          onReady: () => { setBricksReady(true); },
          onError: (err: any) => {
            console.error('[MP Bricks]', err);
            setBricksReady(true);
            setSnack('Não foi possível carregar o pagamento por cartão. Tente novamente ou use PIX.');
          },
          onSubmit: async (submitData: any) => {
            try {
              const formData = submitData?.formData || submitData;
              const res = await axios.post(`${API}/public/${slug}/process-payment`, {
                formData,
                booking_id: pendingBookingId,
                service_name: pendingServiceName,
                device_id: await getMpDeviceId(),
              });

              const mpStatus = res.data.status;
              const normalizedStatus = res.data.normalized_status;

              if (mpStatus === 'approved' || normalizedStatus === 'paid') {
                if (bricksControllerRef.current) { try { await bricksControllerRef.current.unmount(); } catch(_){} bricksControllerRef.current = null; }
                if (countdownRef.current) clearInterval(countdownRef.current);
                setPayModal(false);
                setSnack('✅ Pagamento aprovado! Agendamento confirmado.');
                setStep('done');
                return;
              }

              if (mpStatus === 'pending' || mpStatus === 'in_process' || normalizedStatus === 'pending') {
                if (bricksControllerRef.current) { try { await bricksControllerRef.current.unmount(); } catch(_){} bricksControllerRef.current = null; }
                if (countdownRef.current) clearInterval(countdownRef.current);
                setPayModal(false);
                setSnack('⏳ Aguardando pagamento — seu agendamento será confirmado em breve.');
                setStep('done');
                return;
              }

              setSnack('Cartão recusado. Confira os dados ou tente outro cartão.');
              throw new Error('Pagamento recusado');
            } catch (e: any) {
              setSnack(e.message === 'Pagamento recusado' ? 'Cartão recusado. Confira os dados ou tente outro cartão.' : (e.response?.data?.error || 'Erro ao processar pagamento.'));
              setBricksReady(true);
              throw e;
            }
          },
        },
      };

      const controller = await Promise.race([
        bricksBuilder.create('cardPayment', 'mp-bricks-container', cardSettings),
        new Promise((_, reject) => setTimeout(() => reject(new Error('Tempo esgotado ao carregar o cartão')), 12000)),
      ]);
      bricksControllerRef.current = controller;
    } catch (e: any) {
      console.error('[MP Bricks init]', e);
      setBricksReady(true);
      setBricksError('Não foi possível carregar o formulário do cartão. Atualize a página ou use Pix.');
      setSnack('Não foi possível carregar o cartão. Tente novamente ou use PIX.');
      bricksInitRef.current = false; // permite retry
    }
  }

  return (

    <Box sx={{ minHeight: '100vh', bgcolor: T?.bg ?? '#fff', pb: selected.length > 0 ? 14 : 4, paddingTop: isPreview ? 'env(safe-area-inset-top, 0px)' : undefined }}>

      {/* ===== POP-UP DE COMUNICADO ===== */}
      {(() => {
        const annPopup = company?.settings?.announcements?.popup;
        if (!annPopupOpen || !annPopup?.enabled || !popupHasContent(annPopup)) return null;
        const accentBtn = accentColor || '#1a1a1a';
        function closePopup() {
          setAnnPopupOpen(false);
          const freq = annPopup.frequency || 'once';
          const key = 'ann_popup_' + slug;
          if (freq === 'once') localStorage.setItem(key, '1');
          if (freq === 'session') sessionStorage.setItem(key, '1');
        }
        function handlePopupCta() {
          if (annPopup.cta_type === 'booking') { closePopup(); setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 200); }
          else if (annPopup.cta_type === 'whatsapp' && waPhone) { window.open('https://wa.me/55' + waPhone, '_blank'); }
          else if (annPopup.cta_type === 'external' && annPopup.cta_url) { window.open(annPopup.cta_url, '_blank'); }
          else { closePopup(); }
        }
        return (
          <Dialog open={annPopupOpen} onClose={closePopup} maxWidth="xs" fullWidth
            PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden', m: 2 } }}>
            <Box sx={{ position: 'relative' }}>
              <IconButton onClick={closePopup} size="small"
                sx={{ position: 'absolute', top: 8, right: 8, zIndex: 10, bgcolor: 'rgba(0,0,0,0.35)', color: '#fff', '&:hover': { bgcolor: 'rgba(0,0,0,0.55)' }, width: 28, height: 28 }}>
                <Close sx={{ fontSize: 16 }} />
              </IconButton>
              {annPopup.image_url && (
                <Box sx={{ width: '100%', aspectRatio: '16/9', overflow: 'hidden', bgcolor: '#1a1a1a' }}>
                  <img src={annPopup.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                </Box>
              )}
              <Box sx={{ p: 2.5 }}>
                {annPopup.title && (
                  <Typography sx={{ fontWeight: 800, fontSize: 17, color: '#0f172a', mb: 0.8, lineHeight: 1.3 }}>{annPopup.title}</Typography>
                )}
                {annPopup.body && (
                  <Typography sx={{ fontSize: 14, color: '#374151', lineHeight: 1.65, mb: (annPopup.cta_type && annPopup.cta_type !== 'none' && annPopup.cta_label) ? 2 : 0 }}>{annPopup.body}</Typography>
                )}
                {annPopup.cta_type && annPopup.cta_type !== 'none' && annPopup.cta_label && (
                  <Button onClick={handlePopupCta} fullWidth variant="contained" disableElevation
                    sx={{ borderRadius: 2, fontWeight: 800, textTransform: 'none', fontSize: 14, py: 1.2, bgcolor: accentBtn, '&:hover': { bgcolor: accentBtn, filter: 'brightness(0.9)' } }}>
                    {annPopup.cta_label}
                  </Button>
                )}
              </Box>
            </Box>
          </Dialog>
        );
      })()}

      {/* ===== STICKY TOP BAR ===== */}
      <Box sx={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
        // Respeita a safe-area do topo (Dynamic Island /
        // notch / status bar do iPhone e PWA standalone). Sem isso o "Entrar"/menu
        // ficam atrás da barra do iOS. env() é 0 onde não há notch, então não muda
        // nada no desktop. Gated no pilotUI = nenhuma outra empresa é afetada.
        height: pilotUI ? 'calc(52px + env(safe-area-inset-top, 0px))' : 52,
        pt: pilotUI ? 'env(safe-area-inset-top, 0px)' : 0,
        boxSizing: 'border-box',
        bgcolor: stickyHeader ? (isDark ? 'rgba(15,15,15,0.97)' : 'rgba(255,255,255,0.97)') : 'transparent',
        backdropFilter: stickyHeader ? 'blur(12px)' : 'none',
        borderBottom: stickyHeader ? `1px solid ${isDark ? T?.border : 'rgba(0,0,0,0.06)'}` : 'none',
        transition: 'all 0.25s ease',
        display: 'flex', alignItems: 'center', px: 2,
      }}>
        {stickyHeader && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1, minWidth: 0 }}>
            <Avatar src={company.logo_url_thumb || company.logo_url}
              sx={{ width: 30, height: 30, bgcolor: '#1a1a1a', fontWeight: 700, fontSize: 13 }}>
              {company.name?.[0]}
            </Avatar>
            <Typography fontWeight={800} fontSize={15} noWrap sx={{ color: T?.textPrimary ?? '#1a1a1a' }}>{company.name}</Typography>
          </Box>
        )}

        <Box sx={{ ml: 'auto', display: 'flex', gap: 0.5 }}>
          {custUser ? (
            pilotUI ? (
              <ClientMenuV2
                custUser={custUser}
                stickyHeader={stickyHeader}
                accentColor={accentColor}
                textColor={stickyHeader ? (isDark ? (T?.textPrimary ?? '#f1f5f9') : '#1a1a1a') : '#fff'}
                hoverBg={isDark ? 'rgba(255,255,255,0.08)' : '#f5f5f5'}
                slug={slug}
              />
            ) : (
            <>
              <Box onClick={e => setUserMenuAnchor(e.currentTarget)}
                sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer',
                  borderRadius: 2, px: 1, py: 0.4,
                  bgcolor: stickyHeader ? 'transparent' : 'rgba(0,0,0,0.35)',
                  '&:hover': { bgcolor: stickyHeader ? '#f5f5f5' : 'rgba(0,0,0,0.5)' }
                }}>
                <Avatar src={custUser.photo_url || undefined} sx={{ width: 30, height: 30, bgcolor: accentColor, fontSize: 13, fontWeight: 700 }}>
                  {custUser.name?.[0]}
                </Avatar>
                <Typography fontSize={12} fontWeight={600}
                  color={stickyHeader ? '#1a1a1a' : '#fff'} noWrap maxWidth={60}>
                  {custUser.name?.split(' ')[0]}
                </Typography>
                <ExpandMore sx={{ fontSize: 14, color: stickyHeader ? '#bbb' : 'rgba(255,255,255,0.7)' }} />
              </Box>
              <Menu anchorEl={userMenuAnchor} open={Boolean(userMenuAnchor)}
                onClose={() => setUserMenuAnchor(null)}
                PaperProps={{ sx: { borderRadius: 2, mt: 0.5, minWidth: 0, boxShadow: '0 8px 32px rgba(0,0,0,0.12)' } }}>
                <MenuItem dense onClick={() => { setUserMenuAnchor(null); window.location.href = window.location.origin + '/meus-agendamentos?s=' + encodeURIComponent(slug); }}>
                  <EventNote sx={{ fontSize: 16, mr: 1.5, color: '#555' }} />
                  <Typography fontSize={13} fontWeight={500}>Meus Agendamentos</Typography>
                </MenuItem>
                <Divider sx={{ borderColor: T?.border }} />
                <MenuItem dense onClick={() => { setUserMenuAnchor(null); clearCustomer(); setCustUser(null); }}>
                  <Logout sx={{ fontSize: 16, mr: 1.5, color: '#e53935' }} />
                  <Typography fontSize={13} color="error">Sair</Typography>
                </MenuItem>
              </Menu>
            </>
            )
          ) : (
            <Button size="small"
              onClick={() => { setLoginThenBook(false); setLoginMode('login'); setLoginOpen(true); }}
              sx={{
                textTransform: 'none', fontSize: 12, fontWeight: 700,
                borderRadius: 2, px: 1.5, py: 0.5,
                // Piloto: alvo de toque mínimo 44x44 (iOS HIG). Outras empresas: minWidth 0 como antes.
                minWidth: pilotUI ? 44 : 0, minHeight: pilotUI ? 44 : undefined,
                bgcolor: (stickyHeader || !showBanner) ? '#1a1a1a' : 'rgba(255,255,255,0.15)',
                color: '#fff',
                border: (stickyHeader || !showBanner) ? 'none' : '1px solid rgba(255,255,255,0.4)',
                '&:hover': { bgcolor: (stickyHeader || !showBanner) ? '#333' : 'rgba(255,255,255,0.25)' }
              }}>
              Entrar
            </Button>
          )}
        </Box>
      </Box>

      {/* ===== BARRA DE COMUNICADO ===== */}
      {(() => {
        const annBar = company?.settings?.announcements?.bar;
        if (!annBar?.enabled || !barHasText(annBar) || annBarClosed) return null;
        const now = new Date();
        if (annBar.starts_at && new Date(annBar.starts_at) > now) return null;
        if (annBar.ends_at && new Date(annBar.ends_at) < now) return null;
        const bgColor = annBar.bg_color || '#1a1a1a';
        const txtColor = annBar.text_color || '#ffffff';
        function handleBarCta() {
          if (annBar.cta_type === 'booking') { window.scrollTo({ top: 500, behavior: 'smooth' }); }
          else if (annBar.cta_type === 'whatsapp' && waPhone) { window.open('https://wa.me/55' + waPhone, '_blank'); }
          else if (annBar.cta_type === 'external' && annBar.cta_url) { window.open(annBar.cta_url, '_blank'); }
        }
        return (
          <Box sx={{ bgcolor: bgColor, px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, flexWrap: 'wrap', position: 'relative', minHeight: 40 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: txtColor, textAlign: 'center', flex: 1, minWidth: 0, pr: 3 }}>{annBar.text}</Typography>
            {annBar.cta_type && annBar.cta_type !== 'none' && annBar.cta_label && (
              <Box onClick={handleBarCta} sx={{ px: 1.5, py: 0.35, borderRadius: 1, border: '1.5px solid ' + txtColor, cursor: 'pointer', flexShrink: 0, '&:hover': { opacity: 0.82 } }}>
                <Typography sx={{ fontSize: 11, fontWeight: 700, color: txtColor, whiteSpace: 'nowrap' }}>{annBar.cta_label}</Typography>
              </Box>
            )}
            <Box onClick={() => setAnnBarClosed(true)} sx={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', display: 'flex', alignItems: 'center', color: txtColor, opacity: 0.65, '&:hover': { opacity: 1 } }}>
              <Close sx={{ fontSize: 16 }} />
            </Box>
          </Box>
        );
      })()}

      {/* ===== HERO / COVER ===== */}
      <Box ref={heroRef} sx={{ position: 'relative', maxWidth: 640, mx: 'auto' }}>
        {/* Cover image */}
        {showBanner && (
          <Box sx={{ width:'100%', height:200, position:'relative', overflow:'hidden', bgcolor:'#1a1a1a' }}>
            {(company.cover_url || company.logo_url) ? (
              <img src={company.cover_url_md || company.logo_url_md || company.cover_url || company.logo_url} alt=""
                fetchPriority="high"
                style={{ width:'100%', height:'100%', objectFit:'cover', filter:'brightness(0.55)' }} />
            ) : (
              <Box sx={{ width:'100%', height:'100%', background:'linear-gradient(135deg, #0d1b2e 0%, #1a2a3a 50%, #0d1b2e 100%)' }} />
            )}
            <Box sx={{ position:'absolute', bottom:0, left:0, right:0, height:'55%', background:'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)' }} />
          </Box>
        )}

        {/* Avatar + nome — layout condicional por banner */}
        {showBanner ? (
          /* Banner mode — logo centralizado saindo do banner, nome centralizado abaixo */
          <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', pb:1 }}>
            {(() => {
              const logoSz = company?.settings?.hero_logo_size_px || 150;
              const logoShape = company?.settings?.hero_logo_shape || 'circle';
              const logoBr = logoShape === 'circle' ? '50%' : `${Math.round(logoSz * 0.31)}px`;
              const sizeMap: Record<string,string> = { small:'1.05rem', medium:'1.25rem', large:'1.45rem', xlarge:'1.7rem' };
              const weightMap: Record<string,number> = { normal:500, bold:700, black:900 };
              const fs = sizeMap[company?.settings?.hero_name_size] || '1.5rem';
              const fw = weightMap[company?.settings?.hero_name_weight] || 800;
              return (
                <>
                  <Avatar src={company.logo_url_md || company.logo_url}
                    sx={{ width: logoSz, height: logoSz, bgcolor:'#1a1a1a', fontWeight:800,
                      fontSize: Math.round(logoSz*0.38),
                      border:`3px solid ${accentColor}`,
                      boxShadow:`0 8px 24px rgba(0,0,0,0.3)`,
                      borderRadius: logoBr,
                      mt: `-${Math.round(logoSz/2)}px`,
                      position:'relative', zIndex:10,
                    }}>
                    {company.name?.[0]}
                  </Avatar>
                  {company?.settings?.show_company_name !== false && (
                    <Typography sx={{ fontWeight: fw, fontSize: fs, color: T?.textPrimary ?? '#0f172a', lineHeight:1.2, letterSpacing:'-0.02em', textAlign:'center', mt:1.5, px:2 }}>
                      {company.name}
                    </Typography>
                  )}
                  {avgRating && company?.settings?.show_reviews !== false && (
                    <Box onClick={() => setShowReviewsModal(true)} sx={{ display:'inline-flex', alignItems:'center', gap:0.75, mt:0.5, cursor:'pointer' }}>
                      <Star sx={{ fontSize:12, color:'#fbbf24' }} />
                      <Typography fontSize={13} sx={{ color: T?.textSecondary ?? '#64748b', textDecoration:'underline', textUnderlineOffset:2 }}>{avgRating.toFixed(1)} · {reviews.length} avaliações</Typography>
                    </Box>
                  )}
                </>
              );
            })()}
          </Box>
        ) : (
          <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', pt:3.5, pb:2, px:2, bgcolor: T?.bg ?? '#fff' }}>
            {(() => {
              const logoSz = company?.settings?.hero_logo_size_px || 150;
              const logoShape = company?.settings?.hero_logo_shape || 'circle';
              const logoBr = logoShape === 'circle' ? '50%' : `${Math.round(logoSz * 0.31)}px`;
              return (
                <Avatar src={company.logo_url_md || company.logo_url}
                  sx={{
                    width: logoSz, height: logoSz, bgcolor:'#1a1410', fontWeight:800,
                    fontSize: Math.round(logoSz * 0.38),
                    border:`3px solid ${accentColor}`,
                    boxShadow:`0 12px 24px -8px rgba(26,20,16,0.4)`,
                    borderRadius: logoBr, mb:1.5,
                  }}>
                  {company.name?.[0]}
                </Avatar>
              );
            })()}
            {company?.settings?.show_company_name !== false && (() => {
              const sizeMap: Record<string,string> = { small: '1.05rem', medium: '1.25rem', large: '1.45rem', xlarge: '1.7rem' };
              const weightMap: Record<string,number> = { normal: 500, bold: 700, black: 900 };
              const fs = sizeMap[company?.settings?.hero_name_size] || '1.375rem';
              const fw = weightMap[company?.settings?.hero_name_weight] || 700;
              return (
                <Typography sx={{ color: T?.textPrimary ?? '#0f172a', textAlign:'center', fontSize: fs, fontWeight: fw, lineHeight: 1.2, letterSpacing:'-0.02em', mb: avgRating ? 0.5 : 0 }}>
                  {company.name}
                </Typography>
              );
            })()}
            {avgRating && company?.settings?.show_reviews !== false && (
              <Box onClick={() => setShowReviewsModal(true)} sx={{ display:'inline-flex', alignItems:'center', gap:0.75, mb:0.5, cursor:'pointer' }}>
                <Star sx={{ fontSize:12, color:'#fbbf24' }} />
                <Typography fontSize={13} sx={{ color: T?.textSecondary ?? '#64748b', textDecoration:'underline', textUnderlineOffset:2 }}>{avgRating.toFixed(1)} · {reviews.length} avaliações</Typography>
              </Box>
            )}
          </Box>
        )}

        {/* ===== HEADLINE + QUICK ACTIONS ===== */}
        <Box sx={{ px:2.5, pt:0.5, pb:0 }}>
          {company?.settings?.show_hero_headline !== false && (
            <Box sx={{ mb:2.5, textAlign:'center' }}>
              {(() => {
                const renderHL = (text: string) => {
                  // Parseia >palavra< para colorir com accentColor
                  const parts = text.split(/(>[^<]+<)/g);
                  return parts.map((p, i) => {
                    if (p.startsWith('>') && p.endsWith('<')) {
                      return <Box key={i} component="span" sx={{ color: accentColor, whiteSpace:'nowrap' }}>{p.slice(1,-1)}</Box>;
                    }
                    return <span key={i}>{p}</span>;
                  });
                };
                const hl = company?.settings?.hero_headline || '';
                const hlSizeMap: Record<string,string> = { sm:'1.1rem', md:'1.3rem', lg:'1.5rem', xl:'1.8rem' };
                const hlWeightMap: Record<string,number> = { normal:400, bold:700 };
                const hlFs = hlSizeMap[company?.settings?.hero_headline_size] || '1.5rem';
                const hlFw = hlWeightMap[company?.settings?.hero_headline_weight] || 700;
                return (
                  <Typography sx={{ fontSize: hlFs, fontWeight: hlFw, letterSpacing:'-0.025em', lineHeight:1.15, color: T?.textPrimary ?? '#0f172a', mb:0.75 }}>
                    {hl ? renderHL(hl) : <>Reserve seu horário em{' '}<Box component="span" sx={{ color: accentColor, whiteSpace:'nowrap' }}>3 toques</Box></>}
                  </Typography>
                );
              })()}
              <Typography sx={{ fontSize:14, color: T?.textSecondary ?? '#64748b', lineHeight:1.45, maxWidth:280, mx:'auto' }}>
                Atendimento confirmado na hora. Sem fila no WhatsApp.
              </Typography>
            </Box>
          )}
          {/* Quick Actions — botões configuráveis individualmente */}
          {(() => {
            const showWa  = company?.settings?.show_btn_whatsapp  !== false;
            const showDir = company?.settings?.show_btn_directions !== false;
            const showInf = company?.settings?.show_btn_info       !== false;
            if (!showWa && !showDir && !showInf) return null;
            const btnSx: any = { display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:0.75, cursor:'pointer',
              bgcolor: T?.surfaceAlt ?? '#f8fafc', border: `1px solid ${T?.border ?? '#e2e8f0'}`, borderRadius:'12px',
              px:0.5, py:0, minHeight:72, flex:1, transition:'all 0.2s', '&:active':{ bgcolor: T?.surface ?? '#f1f5f9' } };
            return (
              <Box sx={{ display:'flex', gap:1, mb:3, alignItems:'stretch' }}>
                {showWa && waPhone && (
                  <Box component="a" href={`https://wa.me/55${waPhone}`} target="_blank" rel="noopener noreferrer"
                    sx={{ ...btnSx, textDecoration:'none' }}>
                    <WhatsApp sx={{ fontSize:20, color: accentColor }} />
                    <Typography fontSize={12} fontWeight={500} sx={{ color: T?.textSecondary ?? '#475569', lineHeight:1.25 }} textAlign="center">WhatsApp</Typography>
                  </Box>
                )}
                {showDir && (company?.settings?.google_maps_url || company.address) && (
                  <Box component="a"
                    href={company?.settings?.google_maps_url || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(company.address)}`}
                    target="_blank" rel="noopener noreferrer"
                    sx={{ ...btnSx, textDecoration:'none' }}>
                    <NearMe sx={{ fontSize:20, color: accentColor }} />
                    <Typography fontSize={12} fontWeight={500} sx={{ color: T?.textSecondary ?? '#475569', lineHeight:1.25, whiteSpace:'nowrap' }} textAlign="center">Como chegar</Typography>
                  </Box>
                )}
                {showInf && (
                  <Box onClick={() => setActiveTab(infoTabIndex)} sx={btnSx}>
                    <Info sx={{ fontSize:20, color: accentColor }} />
                    <Typography fontSize={12} fontWeight={500} sx={{ color: T?.textSecondary ?? '#475569', lineHeight:1.25 }} textAlign="center">Informações</Typography>
                  </Box>
                )}
              </Box>
            );
          })()}
        </Box>

        {/* TAB BAR - underline style */}
        <Box sx={{ display:'flex', borderBottom: `1px solid ${T?.border ?? '#f1f5f9'}`, px:2, gap:0.5 }}>
          {visibleTabs.map((label, i) => (
            <Box key={label} onClick={() => setActiveTab(i)}
              sx={{
                flex:1, py:1.2, textAlign:'center', cursor:'pointer', position:'relative',
                color: activeTab === i ? (T?.textPrimary ?? '#0f172a') : (T?.textSecondary ?? '#64748b'),
                fontWeight: activeTab === i ? 700 : 500,
                fontSize:14, transition:'color 0.2s',
                '&::after': {
                  content:'""', position:'absolute', bottom:0, left:'15%', right:'15%',
                  height: activeTab === i ? '2px' : 0,
                  bgcolor: T?.textPrimary ?? '#0f172a', borderRadius:1, display:'block',
                },
              }}>
              {label}
            </Box>
          ))}
        </Box>
      </Box>

      {/* ===== CONTENT AREA ===== */}
      <Box sx={{
        maxWidth: 640,
        mx: 'auto',
        mt: 1,
        minHeight: {
          xs: activeTab === 0 && (company?.services || []).length <= 2 ? '46vh' : 'auto',
          sm: activeTab === 0 && (company?.services || []).length <= 2 ? '34vh' : 'auto',
        },
      }}>

        {/* Aviso discreto de saldo de pacote — liberação gradual desde 5.4.3, fora da aba Pacotes */}
        {company?.packages_v2_enabled === true && custUser && activeCustomerSubscriptions.length > 0 && activeTab !== subscriptionsTabIndex && (
          <Box
            onClick={() => {
              if (activeCustomerSubscriptions.length === 1) {
                openPackageBooking(activeCustomerSubscriptions[0]);
              } else if (subscriptionsTabIndex >= 0) {
                setActiveTab(subscriptionsTabIndex);
              }
            }}
            sx={{
              display: 'flex', alignItems: 'center', gap: 1.2, cursor: 'pointer',
              bgcolor: T?.surfaceAlt ?? '#f8fbff',
              border: `1px solid ${T?.border ?? '#dbeafe'}`,
              borderRadius: 2.5, px: 1.5, py: 1, mb: 2,
              transition: 'filter 0.2s', '&:active': { filter: 'brightness(0.97)' },
            }}
          >
            <Box sx={{
              width: 30, height: 30, borderRadius: 1.5, flexShrink: 0,
              bgcolor: T?.bg ?? '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <EventNote sx={{ fontSize: 16, color: accentColor }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography fontSize={12.5} fontWeight={800} sx={{ color: T?.textPrimary ?? '#111827', lineHeight: 1.3 }}>
                Você tem saldo disponível no seu pacote
              </Typography>
              <Typography fontSize={11.5} fontWeight={700} sx={{ color: accentColor, mt: 0.15 }}>
                Agendar usando meu saldo
              </Typography>
            </Box>
            <ChevronRight sx={{ fontSize: 20, color: T?.textSecondary ?? '#94a3b8', flexShrink: 0 }} />
          </Box>
        )}

        {/* Aviso permanente da reserva "pagar no local" — fora da aba Pacotes */}
        {custUser && pendingReservations.length > 0 && activeTab !== subscriptionsTabIndex && (
          <Box
            data-testid="pending-package-banner"
            onClick={() => {
              const target = pendingReservations.find((r: any) => r.can_schedule === true);
              if (pendingReservations.length === 1 && target) openPackageBooking(target);
              else if (subscriptionsTabIndex >= 0) setActiveTab(subscriptionsTabIndex);
              else if (target) openPackageBooking(target);
            }}
            sx={{
              display: 'flex', alignItems: 'center', gap: 1.2, cursor: 'pointer',
              bgcolor: T ? 'rgba(251,191,36,0.10)' : '#fffbeb',
              border: `1px solid ${T ? 'rgba(251,191,36,0.45)' : '#fcd34d'}`,
              borderRadius: 2.5, px: 1.5, py: 1, mb: 2,
              transition: 'filter 0.2s', '&:active': { filter: 'brightness(0.97)' },
            }}
          >
            <Box sx={{ width: 30, height: 30, borderRadius: 1.5, flexShrink: 0, bgcolor: T?.bg ?? '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <EventNote sx={{ fontSize: 16, color: T ? '#fbbf24' : '#b45309' }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography fontSize={12.5} fontWeight={800} sx={{ color: T?.textPrimary ?? '#111827', lineHeight: 1.3 }}>
                Pacote reservado. Pagamento pendente no estabelecimento.
              </Typography>
              <Typography fontSize={11.5} fontWeight={700} sx={{ color: accentColor, mt: 0.15 }}>
                {pendingReservations.some((r: any) => r.can_schedule === true) ? 'Agendar serviços' : 'Ver minha reserva'}
              </Typography>
            </Box>
            <ChevronRight sx={{ fontSize: 20, color: T?.textSecondary ?? '#94a3b8', flexShrink: 0 }} />
          </Box>
        )}

        {/* --- TAB: SERVIÇOS --- */}
        {activeTab === 0 && (
          <Box>
            {/* Category chips filter */}
            {(() => {
              const _catSavedOrder: string[] = company?.settings?.category_order || [];
              const _rawSvcCats = Array.from(new Set((company?.services || []).map((s: any) => s.category).filter(Boolean))) as string[];
              const _ordSvcCats = _catSavedOrder.length > 0
                ? [..._catSavedOrder.filter((c: string) => _rawSvcCats.includes(c)), ..._rawSvcCats.filter((c: string) => !_catSavedOrder.includes(c))]
                : _rawSvcCats;
              const allCats = ['Todos', ..._ordSvcCats];
              return (
                <Box sx={{ position:'relative', mb:2 }}>
                  <Box sx={{ display:'flex', gap:0.8, overflowX:'auto', px:2, pb:1,
                    '&::-webkit-scrollbar':{ display:'none' },
                    scrollbarWidth:'none',
                    msOverflowStyle:'none',
                  }}>
                    {allCats.map((cat: string) => (
                      <Box key={cat} onClick={() => setSearch(cat === 'Todos' ? '' : cat)}
                        sx={{
                          px:1.8, py:0.9, borderRadius:99, flexShrink:0, cursor:'pointer', fontSize:13, fontWeight:600,
                          bgcolor: (cat === 'Todos' && !search) || search === cat ? (isDark ? accentColor : '#0f172a') : (T?.surfaceAlt ?? '#f1f5f9'),
                          color: (cat === 'Todos' && !search) || search === cat ? '#fff' : (T?.textSecondary ?? '#475569'),
                          transition:'all 0.18s',
                          '&:hover': { bgcolor: (cat === 'Todos' && !search) || search === cat ? (isDark ? accentColor : '#1e293b') : (T?.border ?? '#e2e8f0') },
                          whiteSpace:'nowrap',
                        }}>
                        {cat}
                      </Box>
                    ))}
                  </Box>
                  {/* Fade + dots indicator: só mostra se tiver mais de 4 categorias */}
                  {allCats.length > 4 && (
                    <>
                      <Box sx={{ position:'absolute', right:0, top:0, bottom:0, width:40,
                        background: isDark ? 'linear-gradient(to left, rgba(15,15,15,1) 40%, rgba(15,15,15,0))' : 'linear-gradient(to left, rgba(255,255,255,1) 40%, rgba(255,255,255,0))',
                        pointerEvents:'none', zIndex:1 }} />
                      <Box sx={{ display:'flex', justifyContent:'center', gap:0.5, mt:0.2 }}>
                        {[0,1].map(i => (
                          <Box key={i} sx={{ width: i===0 ? 14 : 5, height:4, borderRadius:99,
                            bgcolor: i===0 ? (T?.textPrimary ?? '#0f172a') : (T?.border ?? '#cbd5e1'), transition:'all .3s' }} />
                        ))}
                      </Box>
                    </>
                  )}
                </Box>
              );
            })()}

            {/* Services list */}
            {(() => {
              const allServicesFiltered = (company?.services || [])
                .slice().sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0))
                .filter((s: any) => !search || s.category === search || s.name.toLowerCase().includes(search.toLowerCase()));
              const showCategories = !search; // Todos = agrupado por categoria; categoria específica = lista plana
              const grouped: Record<string, any[]> = {};
              const catKeys: string[] = [];
              if (showCategories) {
                allServicesFiltered.forEach((s: any) => {
                  const cat = (s.category || 'Geral') as string;
                  if (!grouped[cat]) { grouped[cat] = []; catKeys.push(cat); }
                  grouped[cat].push(s);
                });
                // Apply category_order if set in settings
                const _bpCatOrder: string[] = company?.settings?.category_order || [];
                if (_bpCatOrder.length > 0) {
                  catKeys.sort((a: string, b: string) => {
                    const ia = _bpCatOrder.indexOf(a);
                    const ib = _bpCatOrder.indexOf(b);
                    if (ia === -1 && ib === -1) return 0;
                    if (ia === -1) return 1;
                    if (ib === -1) return -1;
                    return ia - ib;
                  });
                }
              }

              const renderItem = (s: any, idx: number, list: any[]) => {
                const isSelected = !!selected.find((x: any) => x.id === s.id);
                const pixDiscount = company?.settings?.mp_pix_discount || 0;
                const pixPrice = pixDiscount > 0 ? Number((Number(s.price) * (1 - pixDiscount/100)).toFixed(0)) : null;
                const serviceDescription = String(s.description || '').trim();
                // Category icon colors
                const catBg: Record<string,string> = { 'Barba':'#dcfce7','Combos':'#fef3c7','Extras':'#fce7f3','default':'#ede9fe' };
                const catIc: Record<string,string> = { 'Barba':'#059669','Combos':'#d97706','Extras':'#c026d3','default': accentColor };
                const bg = catBg[s.category] || catBg.default;
                const ic = catIc[s.category] || accentColor;
                return (
                  <Box key={s.id} onClick={() => toggleService(s)}
                    sx={{
                      display:'flex', alignItems:'center', gap:1.5,
                      bgcolor: isSelected ? `${accentColor}0f` : (T?.bg ?? '#fff'),
                      border: `1px solid ${isSelected ? accentColor : (T?.border ?? '#e2e8f0')}`,
                      borderRadius:'16px', p:'14px', mb:1.25,
                      boxShadow: isSelected ? `0 0 0 1px ${accentColor}` : 'none',
                      cursor:'pointer', transition:'all 0.18s',
                      overflow:'hidden',
                      '&:hover': { border:`1.5px solid ${accentColor}80`, bgcolor: isSelected ? `${accentColor}18` : (T?.surfaceAlt ?? '#fafafa') },
                    }}>
                    {/* Icon — só aparece quando show_service_photos está ativo */}
                    {company?.settings?.show_service_photos !== false && (
                      <Box sx={{ width:46, height:46, borderRadius:1.5, flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center',
                        background: isSelected ? 'white' : bg, overflow:'hidden' }}>
                        {s.image_url ? (
                          <img src={s.image_url_thumb || s.image_url} alt={s.name} loading="lazy" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:6 }} />
                        ) : (
                          <ServiceIcon size={22} color={isSelected ? accentColor : ic} businessType={company?.settings?.business_type} defaultServiceIcon={company?.settings?.default_service_icon} />
                        )}
                      </Box>
                    )}
                    {/* Info */}
                    <Box sx={{ flex:1, minWidth:0, overflow:'hidden' }}>
                      <Typography sx={{ fontWeight:600, fontSize:15, color: T?.textPrimary ?? '#0f172a', lineHeight:1.2, mb:'2px', fontFamily:'Inter,-apple-system,BlinkMacSystemFont,sans-serif', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{s.name}</Typography>
                      <Box sx={{ display:'flex', alignItems:'center', gap:0.5, mt:0.4, flexWrap:'nowrap' }}>
                        <AccessTime sx={{ fontSize:12, color: T?.textSecondary ?? '#64748b', flexShrink:0 }} />
                        <Typography sx={{ fontSize:12, color: T?.textSecondary ?? '#64748b', fontFamily:'Inter,-apple-system,sans-serif' }} flexShrink={0}>{s.duration_min} min</Typography>
                        {s.category && (
                          <>
                            <Typography sx={{ fontSize:12, color: T?.textSecondary ?? '#64748b', fontFamily:'Inter,-apple-system,sans-serif' }} flexShrink={0}>·</Typography>
                            <Typography sx={{ fontSize:12, color: T?.textSecondary ?? '#64748b', fontFamily:'Inter,-apple-system,sans-serif', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', flexShrink:1 }}>{s.category}</Typography>
                          </>
                        )}
                      </Box>
                      {serviceDescription && (
                        <Typography
                          sx={{
                            mt:0.65,
                            fontSize:11.5,
                            lineHeight:1.35,
                            color: T?.textSecondary ?? '#64748b',
                            fontFamily:'Inter,-apple-system,sans-serif',
                            display: isSelected ? 'block' : '-webkit-box',
                            WebkitLineClamp: isSelected ? 'unset' : 2,
                            WebkitBoxOrient:'vertical',
                            overflow:'hidden',
                          }}
                        >
                          {serviceDescription}
                        </Typography>
                      )}
                    </Box>
                    {/* Price */}
                    <Box sx={{ textAlign:'right', flexShrink:0 }}>
                      <Typography sx={{ fontWeight:700, fontSize:17, color: T?.textPrimary ?? '#0f172a', lineHeight:1.1, letterSpacing:'-0.01em' }}>
                        R$ {Number(s.price).toFixed(0)}
                      </Typography>
                      {pixPrice && (
                        <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.4, bgcolor:'#d1fae5', borderRadius:0.8, px:0.8, py:0.3, mt:0.5 }}>
                          <Typography sx={{ fontSize:11, fontWeight:700, color:'#059669' }}>
                            Pix R$ {pixPrice}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                );
              };

              if (showCategories) {
                return (
                  <Box sx={{ px:2 }}>
                    {allServicesFiltered.length === 0 && (
                      <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:3, boxShadow:'0 2px 16px rgba(0,0,0,0.06)', py:5, textAlign:'center' }}>
                        <Typography sx={{ color: T?.textSecondary }} color="text.secondary" fontSize={14}>Nenhum serviço encontrado.</Typography>
                      </Box>
                    )}
                    {catKeys.map((cat) => (
                      <Box key={cat} sx={{ mb: 2.5 }}>
                        <Typography sx={{ fontSize:11, fontWeight:700, color:'#94A3B8', textTransform:'uppercase', letterSpacing:1, mb:1.2, px:0.5 }}>
                          {cat}
                        </Typography>
                        {grouped[cat].map((s: any, idx: number) => renderItem(s, idx, grouped[cat]))}
                      </Box>
                    ))}
                  </Box>
                );
              }

              return (
                <Box sx={{ px:2, overflow:'hidden' }}>
                  {allServicesFiltered.length === 0 && (
                    <Box py={5} textAlign="center">
                      <Typography sx={{ color: T?.textSecondary }} color="text.secondary" fontSize={14}>Nenhum serviço encontrado.</Typography>
                    </Box>
                  )}
                  {allServicesFiltered.map((s: any, idx: number) => renderItem(s, idx, allServicesFiltered))}
                </Box>
              );
            })()}

            {selected.length > 0 && (
              <Box sx={{ mt:2, mx:2, p:2, bgcolor: T?.bg ?? '#fff', borderRadius:3, boxShadow:'0 2px 16px rgba(0,0,0,0.06)' }}>
                <Typography fontWeight={700} fontSize={13} sx={{ color: T?.textSecondary ?? '#888' }} mb={1}>
                  Selecionados ({selected.length})
                </Typography>
                {selected.map(s => (
                  <Box key={s.id} sx={{ display:'flex', alignItems:'center', gap:1, mb:0.8 }}>
                    <CheckCircle sx={{ fontSize:15, color:accentColor }} />
                    <Typography fontSize={13} flex={1} fontWeight={600} sx={{ color: T?.textPrimary }}>{s.name}</Typography>
                    <Typography fontSize={13} sx={{ color: T?.textSecondary }} color="text.secondary">
                      R$ {Number(s.price).toFixed(2).replace('.', ',')}
                    </Typography>
                    <IconButton size="small" onClick={() => removeService(s.id)} sx={{ p:0.3 }}>
                      <Close sx={{ fontSize:14, color:'#bbb' }} />
                    </IconButton>
                  </Box>
                ))}
                <Divider sx={{ my:1.5, borderColor: T?.border }} />
                <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <Typography fontSize={13} fontWeight={800} sx={{ color: T?.textPrimary }}>Total</Typography>
                  <Typography fontSize={15} fontWeight={900} sx={{ color: T?.textPrimary ?? '#1a1a1a' }}>
                    R$ {selected.reduce((acc, s) => acc + Number(s.price), 0).toFixed(2).replace('.', ',')}
                  </Typography>
                </Box>
              </Box>
            )}

            {/* Informações úteis (resumo: horários + localização) */}
            {company?.settings?.show_services_info_section !== false && ((company?.settings?.working_hours?.length > 0) || ((company.address || company?.settings?.google_maps_url) && company.settings?.show_address !== false)) && (
              <Box sx={{ mt:2.5, mx:2, display:'flex', flexDirection:'column', gap:1.5 }}>
                <Typography fontWeight={800} fontSize={14} sx={{ color: T?.textPrimary ?? "#1a1a1a", letterSpacing:'-0.01em' }}>
                  Atendimento e localização
                </Typography>

                {/* Horários (resumo) */}
                {company?.settings?.working_hours?.length > 0 && (
                  <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:3, p:2, boxShadow:'0 2px 16px rgba(0,0,0,0.06)' }}>
                    <Box sx={{ display:'flex', alignItems:'center', gap:1.25, mb:1.75 }}>
                      <Box sx={{ width:32, height:32, borderRadius:2, bgcolor:`${accentColor}1a`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                        <AccessTime sx={{ fontSize:17, color: accentColor }} />
                      </Box>
                      <Typography fontWeight={800} fontSize={15} sx={{ color: T?.textPrimary ?? "#1a1a1a", letterSpacing:'-0.01em' }}>Horários de Atendimento</Typography>
                    </Box>
                    {[
                      { key:1, label:'Segunda-feira' }, { key:2, label:'Terça-feira' },
                      { key:3, label:'Quarta-feira' }, { key:4, label:'Quinta-feira' },
                      { key:5, label:'Sexta-feira' }, { key:6, label:'Sábado' }, { key:0, label:'Domingo' }
                    ].map(({ key, label }) => {
                      const wh = company.settings.working_hours.find((w: any) => w.day_of_week === key);
                      const isToday = new Date().getDay() === key;
                      return (
                        <Box key={key} sx={{
                          display:'flex', justifyContent:'space-between', alignItems:'center',
                          py:0.8, borderBottom:`1px solid ${T?.border ?? '#f5f5f5'}`,
                          bgcolor: isToday ? `${accentColor}22` : 'transparent',
                          px: isToday ? 1 : 0, mx: isToday ? -1 : 0,
                          borderRadius: isToday ? 1 : 0,
                        }}>
                          <Typography fontSize={13} fontWeight={isToday ? 700 : 400}
                            sx={{ color: wh?.open ? (T?.textPrimary ?? '#1a1a1a') : (T?.textSecondary ?? undefined) }}>
                            {label} {isToday && <Typography component="span" fontSize={10} sx={{ bgcolor:accentColor, color:'#fff', px:0.8, py:0.2, borderRadius:1, ml:0.5, fontWeight:700 }}>Hoje</Typography>}
                          </Typography>
                          <Typography fontSize={13} fontWeight={wh?.open ? 700 : 400}
                            sx={{ color: wh?.open ? (isToday ? accentColor : (T?.textPrimary ?? '#1a1a1a')) : (T?.textSecondary ?? undefined) }}>
                            {wh?.open ? `${wh.start_time} – ${wh.end_time}` : 'Fechado'}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                )}

                {/* Localização (resumo) */}
                {(company.address || company?.settings?.google_maps_url) && company.settings?.show_address !== false && (
                  <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:3, overflow:'hidden', boxShadow:'0 2px 16px rgba(0,0,0,0.06)' }}>
                    <Box sx={{ display:'flex', alignItems:'center', gap:1.25, px:2, pt:2, pb:1.5 }}>
                      <Box sx={{ width:32, height:32, borderRadius:2, bgcolor:`${accentColor}1a`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                        <Place sx={{ fontSize:17, color: accentColor }} />
                      </Box>
                      <Typography fontWeight={800} fontSize={15} sx={{ color: T?.textPrimary ?? "#1a1a1a", letterSpacing:'-0.01em' }}>Localização</Typography>
                    </Box>

                    {company.address && (
                      <Box sx={{ px:2, pb:2 }}>
                        <Box
                          component="iframe"
                          title="Mapa da localização"
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          src={`https://www.google.com/maps?q=${encodeURIComponent(company.address)}&output=embed`}
                          sx={{ width:'100%', height:230, border:0, display:'block', borderRadius:2.5 }}
                        />
                      </Box>
                    )}

                    <Box sx={{ px:2, pb:2, display:'flex', flexDirection:'column', gap:1.25 }}>
                      <Box
                        component="a"
                        href={company?.settings?.google_maps_url || ("https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(company.address))}
                        target="_blank" rel="noopener noreferrer"
                        sx={{
                          display:'flex', alignItems:'center', justifyContent:'center', gap:1,
                          py:1.5, borderRadius:2.5, textDecoration:'none',
                          bgcolor: accentColor,
                          color: '#fff',
                          fontWeight:800, fontSize:13.5,
                          boxShadow:`0 4px 16px ${accentColor}55`,
                          '&:visited': { color: '#fff' },
                          '&:active': { color: '#fff' },
                          '&:hover': { filter:'brightness(0.92)' },
                          transition:'filter 0.15s',
                        }}>
                        <NearMe sx={{ fontSize:17 }} />
                        Abrir no Maps
                      </Box>

                      {company.address && (
                        <Box onClick={copyAddress} sx={{
                          display:'flex', alignItems:'center', gap:1.25, p:1.5, borderRadius:2.5, cursor:'pointer',
                          bgcolor: T?.surfaceAlt ?? '#f8fafc', border:`1px solid ${T?.border ?? '#eef2f7'}`,
                          transition:'border-color 0.15s',
                          '&:hover': { borderColor: `${accentColor}55` },
                        }}>
                          <Place sx={{ fontSize:18, color:'#e53935', flexShrink:0 }} />
                          <Typography fontSize={13} flex={1} sx={{ color: T?.textPrimary ?? '#334155', lineHeight:1.45 }}>{company.address}</Typography>
                          <CopyAll sx={{ fontSize:16, color: T?.textSecondary ?? '#94a3b8', flexShrink:0 }} />
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        )}

        {/* --- TAB: PRODUTOS --- */}
        {hasProducts && activeTab === 1 && (
          <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:3, overflow:'hidden', boxShadow:'0 2px 16px rgba(0,0,0,0.06)' }}>
            <Box sx={{ px:2, py:1.5, borderBottom: `1px solid ${T?.border ?? '#f5f5f5'}`, display:'flex', alignItems:'center', gap:1 }}>
              <ShoppingBag sx={{ fontSize:16, color:accentColor }} />
              <Typography fontWeight={800} fontSize={14} sx={{ color: T?.textPrimary ?? '#1a1a1a' }}>Produtos disponíveis</Typography>
              <Box sx={{ ml:'auto', bgcolor:'#fff3e0', borderRadius:5, px:1.2, py:0.3, border:'1px solid #ffe0b2' }}>
                <Typography sx={{ fontSize:10, fontWeight:800, color:'#e65100', textTransform:'uppercase', letterSpacing:0.5 }}>
                  Aproveite!
                </Typography>
              </Box>
            </Box>
            {products.map((p: any, idx: number) => {
              const isProdSel = selectedProducts.some((x: any) => x.id === p.id);
              const toggleProduct = () => {
                setSelectedProducts(prev =>
                  isProdSel ? prev.filter((x: any) => x.id !== p.id) : [...prev, p]
                );
              };
              return (
                <Box key={p.id} onClick={toggleProduct}
                  sx={{
                    display:'flex', alignItems:'center', cursor:'pointer',
                    borderBottom: idx < products.length - 1 ? `1px solid ${T?.border ?? '#f5f5f5'}` : 'none',
                    minWidth:0, position:'relative',
                    bgcolor: isProdSel ? `${accentColor}08` : 'transparent',
                    border: isProdSel ? `1.5px solid ${accentColor}40` : '1.5px solid transparent',
                    borderRadius: idx === 0 ? '0' : '0',
                    transition:'all 0.15s',
                    '&:hover': { bgcolor: isProdSel ? `${accentColor}12` : (T?.surfaceAlt ?? '#fafafa') },
                  }}>
                  <Box sx={{ width:72, height:72, flexShrink:0, bgcolor: T?.surface ?? '#f8f8f8', display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden' }}>
                    {p.image_url
                      ? <img src={p.image_url_md || p.image_url} alt={p.name} loading="lazy" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                      : <ShoppingBag sx={{ fontSize:24, color:'#ddd' }} />}
                  </Box>
                  <Box sx={{ flex:1, px:1.5, py:1.2, minWidth:0, overflow:'hidden' }}>
                    <Typography fontWeight={700} fontSize={14} sx={{ color: isProdSel ? accentColor : (T?.textPrimary ?? '#1a1a1a') }} noWrap>{p.name}</Typography>
                    {p.description && (
                      <Typography variant="caption" color="text.secondary" mt={0.3} lineHeight={1.35}
                        sx={{
                          color: T?.textSecondary,
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          wordBreak: 'break-word',
                        }}>
                        {p.description}
                      </Typography>
                    )}
                    <Typography fontSize={14} fontWeight={900} sx={{ color: isProdSel ? accentColor : (T?.textPrimary ?? '#1a1a1a') }} mt={0.5}>
                      R$ {Number(p.price).toFixed(2).replace('.', ',')}
                    </Typography>
                  </Box>
                  <Box sx={{ pr:1.5, flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', width:32, height:32 }}>
                    <Box sx={{
                      width:22, height:22, borderRadius:'50%',
                      border: `2px solid ${isProdSel ? accentColor : (T?.border ?? '#ddd')}`,
                      bgcolor: isProdSel ? accentColor : 'transparent',
                      display:'flex', alignItems:'center', justifyContent:'center',
                      transition:'all 0.15s',
                    }}>
                      {isProdSel && <Box sx={{ width:8, height:8, borderRadius:'50%', bgcolor:'#fff' }} />}
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}

        {/* --- TAB: ASSINATURAS --- */}
        {hasSubscriptions && activeTab === subscriptionsTabIndex && (
          <Box sx={{ display:'flex', flexDirection:'column', gap:1.5 }}>
            <Box sx={{
              bgcolor: T?.bg ?? '#fff',
              borderRadius:3,
              overflow:'hidden',
              border:`1px solid ${T?.border ?? '#edf2f7'}`,
              boxShadow:'0 14px 34px rgba(15,23,42,0.06)'
            }}>
              <Box sx={{ px:2, pt:1.8, pb:1.5, borderBottom:`1px solid ${T?.border ?? '#f1f5f9'}` }}>
                <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:0.6 }}>
                  <Box sx={{
                    width:28, height:28, borderRadius:1.5,
                    bgcolor: T?.surfaceAlt ?? '#eff6ff',
                    display:'flex', alignItems:'center', justifyContent:'center'
                  }}>
                    <EventNote sx={{ fontSize:16, color:accentColor }} />
                  </Box>
                  <Typography fontWeight={900} fontSize={15} sx={{ color: T?.textPrimary ?? "#111827" }}>
                    Pacotes
                  </Typography>
                </Box>
                <Typography fontSize={12.5} sx={{ color: T?.textSecondary ?? "#64748b" }} lineHeight={1.5}>
                  Escolha um pacote e finalize a compra quando quiser.
                </Typography>

                {/* Rodada 5.3 — explicação curta de como o pacote funciona,
                    antes da lista de pacotes. */}
                <Box sx={{ display:'flex', flexDirection:{ xs:'column', sm:'row' }, gap:{ xs:0.6, sm:1.4 }, mt:1.2 }}>
                  {[
                    'Compre o pacote.',
                    'Agende normalmente.',
                    'Use seu saldo nos atendimentos.',
                  ].map((txt, i) => (
                    <Box key={i} sx={{ display:'flex', alignItems:'center', gap:0.6 }}>
                      <Box sx={{
                        width:16, height:16, borderRadius:'50%', flexShrink:0,
                        bgcolor: T?.surfaceAlt ?? '#eff6ff', color: accentColor,
                        display:'flex', alignItems:'center', justifyContent:'center',
                        fontSize:9.5, fontWeight:800,
                      }}>
                        {i + 1}
                      </Box>
                      <Typography fontSize={11.5} sx={{ color: T?.textSecondary ?? '#64748b' }}>{txt}</Typography>
                    </Box>
                  ))}
                </Box>
              </Box>

              {custUser && (
                <Box sx={{ p:1.2, pb:0 }}>
                  {/* "Reservar e pagar no local" — a reserva pendente fica SEMPRE visível
                      aqui (inclusive após recarregar a página), com o caminho para
                      agendar os serviços. Não é saldo pago: o pacote só é ativado
                      quando o estabelecimento confirma o pagamento. */}
                  {!customerSubscriptionsLoading && pendingReservations.length > 0 && (
                    <Box data-testid="pending-package-reservations" sx={{ display:'flex', flexDirection:'column', gap:1, mb:1.2 }}>
                      {pendingReservations.map((row: any) => {
                        const remainingItems = Array.isArray(row.items) ? row.items.filter((item: any) => getSubscriptionRemaining(item) > 0) : [];
                        const planTitle = row.subscription_plan?.public_title || row.plan_name || 'Pacote';
                        const endBr = String(row.end_date || '').split('-').reverse().join('/');
                        const todayIso = format(new Date(), 'yyyy-MM-dd');
                        const canSchedule = row.can_schedule === true;
                        const hasReservedItems = Array.isArray(row.items) && row.items.length > 0;
                        const cantReason = hasReservedItems && Number(row.remaining_total || 0) <= 0
                          ? 'Todos os serviços do pacote já estão agendados.'
                          : hasReservedItems && String(row.end_date || '') < todayIso
                            ? 'O prazo para agendar antes da confirmação terminou. Quando o estabelecimento confirmar o pagamento, você poderá agendar os serviços.'
                            : 'No momento, o agendamento antes do pagamento não está disponível. Fale com o estabelecimento.';
                        return (
                          <Box key={row.id} data-testid="pending-package-card" sx={{
                            border:`1px solid ${T ? 'rgba(251,191,36,0.45)' : '#fcd34d'}`,
                            borderRadius:3,
                            bgcolor: T ? 'rgba(251,191,36,0.10)' : '#fffbeb',
                            p:1.4
                          }}>
                            <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:1, mb:0.6 }}>
                              <Typography fontWeight={900} fontSize={14.5} sx={{ color: T?.textPrimary ?? '#111827', minWidth:0 }}>
                                {planTitle}
                              </Typography>
                              <Chip
                                label="Pagamento pendente"
                                size="small"
                                sx={{ bgcolor: T ? 'rgba(251,191,36,0.22)' : '#fef3c7', color: T ? '#fbbf24' : '#b45309', fontWeight:800, height:22, fontSize:10.5, flexShrink:0 }}
                              />
                            </Box>
                            <Typography fontSize={13} fontWeight={800} sx={{ color: T?.textPrimary ?? '#111827', mb:0.4 }}>
                              Pacote reservado. Pagamento pendente no estabelecimento.
                            </Typography>
                            <Typography fontSize={12.3} sx={{ color: T?.textSecondary ?? '#64748b', mb:1, lineHeight:1.5 }}>
                              O pacote só fica ativo quando o estabelecimento confirmar o pagamento.{canSchedule ? ' Enquanto isso, você já pode agendar os serviços incluídos.' : ''}
                            </Typography>
                            {remainingItems.length > 0 && (
                              <Box sx={{ display:'flex', flexDirection:'column', gap:0.4, mb:1 }}>
                                {remainingItems.slice(0, 5).map((item: any) => (
                                  <Typography key={item.id} fontSize={12.4} sx={{ color: T?.textSecondary ?? '#475569' }}>
                                    <Box component="span" sx={{ fontWeight:900, color: T?.textPrimary ?? '#111827' }}>{getSubscriptionRemaining(item)}x</Box>
                                    {' '}{getSubscriptionItemLabel(item)}
                                  </Typography>
                                ))}
                              </Box>
                            )}
                            {canSchedule ? (
                              <>
                                <Button
                                  fullWidth
                                  variant="contained"
                                  onClick={() => openPackageBooking(row)}
                                  sx={{ bgcolor: accentColor, '&:hover': { filter:'brightness(0.94)' }, textTransform:'none', fontWeight:800, borderRadius:2 }}
                                >
                                  Agendar serviços
                                </Button>
                                {endBr && (
                                  <Typography fontSize={11.3} sx={{ color: T?.textSecondary ?? '#64748b', mt:0.7, textAlign:'center' }}>
                                    Agende até {endBr}. A validade do pacote passa a contar quando o pagamento for confirmado.
                                  </Typography>
                                )}
                              </>
                            ) : (
                              <Typography fontSize={12} fontWeight={700} sx={{ color: T ? '#fbbf24' : '#b45309' }}>
                                {cantReason}
                              </Typography>
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                  {customerSubscriptionsLoading ? (
                    <Box sx={{ display:'flex', justifyContent:'center', py:2 }}>
                      <CircularProgress size={24} sx={{ color: accentColor }} />
                    </Box>
                  ) : activeCustomerSubscriptions.length > 0 ? (
                    <Box sx={{
                      border:`1px solid ${T?.border ?? '#dbeafe'}`,
                      borderRadius:3,
                      bgcolor: T?.surfaceAlt ?? '#f8fbff',
                      p:1.2,
                      mb:1.2
                    }}>
                      <Typography fontWeight={900} fontSize={14} sx={{ color: T?.textPrimary ?? "#111827", mb:0.35 }}>
                        Seu saldo ativo fica aqui
                      </Typography>
                      <Typography fontSize={12.3} sx={{ color: T?.textSecondary ?? "#64748b", mb:1.1, lineHeight:1.5 }}>
                        Escolha o que vai usar hoje no pacote, e a agenda já calcula o tempo automaticamente antes de mostrar os horários.
                      </Typography>

                      <Box sx={{ display:'flex', flexDirection:'column', gap:1 }}>
                        {activeCustomerSubscriptions.map((row: any) => {
                          const remainingItems = Array.isArray(row.items) ? row.items.filter((item: any) => getSubscriptionRemaining(item) > 0) : [];
                          const daysLeft = getSubscriptionDaysLeft(row.end_date);
                          const urgency = getSubscriptionUrgency(daysLeft);
                          const planTitle = row.subscription_plan?.public_title || row.plan_name || 'Pacote ativo';
                          const urgencyColor = urgency.warn ? (T ? '#fbbf24' : '#b45309') : (T?.textSecondary ?? '#64748b');

                          return (
                            <Box key={row.id} sx={{
                              border:`1px solid ${T?.border ?? '#e2e8f0'}`,
                              borderRadius:2.5,
                              bgcolor: T?.bg ?? '#fff',
                              p:1.2
                            }}>
                              <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:1, mb:0.8 }}>
                                <Box sx={{ minWidth:0 }}>
                                  <Typography fontWeight={900} fontSize={14} sx={{ color: T?.textPrimary ?? "#111827" }}>
                                    {planTitle}
                                  </Typography>
                                  <Typography fontSize={12} sx={{ color: urgencyColor, fontWeight: urgency.warn ? 800 : 400, mt:0.25 }}>
                                    {urgency.label}
                                  </Typography>
                                </Box>

                                <Chip
                                  label={`${remainingItems.length} item(ns) com saldo`}
                                  size="small"
                                  sx={{ bgcolor: T ? 'rgba(34,197,94,0.18)' : '#dcfce7', color: T ? '#4ade80' : '#16a34a', fontWeight:800, height:22, fontSize:10.5 }}
                                />
                              </Box>

                              <Box sx={{ display:'flex', flexDirection:'column', gap:0.5, mb:1 }}>
                                {remainingItems.slice(0, 4).map((item: any) => (
                                  <Typography key={item.id} fontSize={12.4} sx={{ color: T?.textSecondary ?? "#475569" }}>
                                    <Box component="span" sx={{ fontWeight:900, color: T?.textPrimary ?? '#111827' }}>
                                      {getSubscriptionRemaining(item)}x
                                    </Box>
                                    {' '}
                                    {getSubscriptionItemLabel(item)}
                                  </Typography>
                                ))}
                              </Box>

                              <Button
                                fullWidth
                                variant="contained"
                                onClick={() => openPackageBooking(row)}
                                sx={{
                                  bgcolor: accentColor,
                                  '&:hover': { filter:'brightness(0.94)' },
                                  textTransform:'none',
                                  fontWeight:800,
                                  borderRadius:2
                                }}
                              >
                                Agendar com saldo
                              </Button>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  ) : null}
                </Box>
              )}

              {planNotFoundNotice && (
                <Box sx={{ mx:1.2, mb:0.5, p:1.2, borderRadius:2, bgcolor: isDark ? '#1f2937' : '#f1f5f9', border:`1px solid ${T?.border ?? '#e6edf5'}` }}>
                  <Typography sx={{ fontSize:12.5, color: isDark ? '#e5e7eb' : '#475569' }}>
                    O pacote desse link não está disponível — pode ter sido removido da vitrine. Veja os pacotes atuais abaixo.
                  </Typography>
                </Box>
              )}
              <Box sx={{ display:'flex', flexDirection:'column', gap:1.15, p:1.2 }}>
                {subscriptionPlans.map((plan: any) => {
                  const planItems = Array.isArray(plan.items) ? plan.items : [];
                  // Rodada 5.3 — total de serviços e economia, só quando o
                  // cálculo é real: soma o preço ATUAL de cada serviço
                  // incluído (company.services, já carregado) x quantidade;
                  // só mostra "economize" se resolveu o preço de TODOS os
                  // itens (nunca subestima por item não encontrado) e o
                  // resultado é positivo.
                  const totalUnits = planItems.reduce((s: number, it: any) => s + Number(it.quantity || 0), 0);
                  const allPricesFound = planItems.length > 0 && planItems.every((it: any) =>
                    (company?.services || []).some((sv: any) => Number(sv.id) === Number(it.service_id || it.service?.id))
                  );
                  const regularTotal = allPricesFound
                    ? planItems.reduce((s: number, it: any) => {
                        const sv = (company?.services || []).find((x: any) => Number(x.id) === Number(it.service_id || it.service?.id));
                        return s + Number(sv?.price || 0) * Number(it.quantity || 0);
                      }, 0)
                    : 0;
                  const savings = allPricesFound ? regularTotal - Number(plan.price || 0) : 0;
                  // Descrição "real" = plan.description (o texto de marketing, o
                  // que o dono escreve com capricho) — NUNCA plan.public_subtitle,
                  // que em vários pacotes reais (ex.: Vinicius) é só um resumo
                  // curtinho tipo "4 cortes" enquanto description tem o texto
                  // completo. getSubscriptionSubtitle() prioriza subtitle e por
                  // isso escondia a description real nesses casos — aqui não usamos
                  // mais essa função para decidir nem para exibir o bloco de
                  // descrição. Quando description está vazia (não apenas curta —
                  // vazia mesmo), tratamos como "sem descrição": o resumo
                  // (public_subtitle, se existir) sobe para o cabeçalho ao lado do
                  // preço, em vez de abrir uma seção de descrição praticamente vazia.
                  const realDescriptionText = String(plan.description || '').trim();
                  const hasRealDescription = realDescriptionText.length > 0;
                  const summaryText = String(plan.public_subtitle || '').trim();
                  // Preço + validade + economia — a mesma linha aparece no
                  // cabeçalho (pacote sem descrição, ao lado da imagem) ou no
                  // corpo (pacote com descrição, depois dela), nunca nos dois.
                  const priceRow = (
                    <Box sx={{ display:'flex', alignItems:'center', gap:1, flexWrap:'wrap' }}>
                      <Typography fontSize={22} fontWeight={900} sx={{ color: T?.textPrimary ?? "#0f172a", letterSpacing:'-0.01em' }}>
                        R$ {Number(plan.price || 0).toFixed(2).replace('.', ',')}
                      </Typography>
                      <Box sx={{
                        display:'inline-flex', alignItems:'center', gap:0.55, px:1, py:0.55, borderRadius:999,
                        bgcolor: T?.surfaceAlt ?? '#f8fafc', border:`1px solid ${T?.border ?? '#e2e8f0'}`
                      }}>
                        <CalendarMonth sx={{ fontSize:14, color: T?.textSecondary ?? '#64748b' }} />
                        <Typography fontSize={12} fontWeight={700} sx={{ color: T?.textSecondary ?? "#64748b" }}>
                          {plan.validity_days} dias
                        </Typography>
                      </Box>
                      {savings > 0 && company?.show_package_savings !== false && (
                        <Box sx={{ display:'inline-flex', alignItems:'center', px:1, py:0.55, borderRadius:999, bgcolor: T ? 'rgba(34,197,94,0.16)' : '#dcfce7' }}>
                          <Typography fontSize={12} fontWeight={800} sx={{ color: T ? '#4ade80' : '#16a34a' }}>
                            Economize R$ {savings.toFixed(2).replace('.', ',')}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  );
                  return (
                    <Box key={plan.id} ref={(el: HTMLDivElement | null) => { planRefs.current[plan.id] = el; }} sx={{
                      border: Number(plan.id) === highlightPlanId ? '2px solid #2563EB' : `1px solid ${T?.border ?? '#e6edf5'}`,
                      borderRadius:3,
                      overflow:'hidden',
                      bgcolor: T?.bg ?? '#fff',
                      boxShadow: Number(plan.id) === highlightPlanId ? '0 6px 24px rgba(37,99,235,0.18)' : '0 6px 20px rgba(15,23,42,0.04)'
                    }}>
                      {/* Topo do card: quadrado 1:1 de tamanho FIXO (imagem real com
                          object-fit:cover, ou placeholder com ícone quando o pacote
                          não tem imagem — nunca inventamos uma foto) + título + selo.
                          Tamanho fixo de propósito: um grid de 1 linha faria as duas
                          colunas ficarem com a MESMA altura — como o título aqui é só
                          1 linha curta (a descrição virou seção própria abaixo), a
                          imagem esticaria para acompanhar essa altura mínima e ficava
                          enorme/no topo do card com espaço vazio ao lado. Com tamanho
                          fixo e alignItems:'flex-start' a imagem/placeholder nunca
                          cresce além do quadrado, e a linha do cabeçalho fica só tão
                          alta quanto o título precisa — igual com ou sem imagem. */}
                      <Box sx={{ display:'flex', alignItems:'flex-start', gap:1.25, p:1.5, pb:0.9 }}>
                        <Box sx={{
                          width:{ xs:88, sm:100 }, height:{ xs:88, sm:100 }, flexShrink:0,
                          borderRadius:2, overflow:'hidden', position:'relative',
                          bgcolor: isDark ? (T?.surfaceAlt ?? '#111111') : '#fff',
                          display:'flex', alignItems:'center', justifyContent:'center',
                        }}>
                          {plan.public_image_url ? (
                            <img
                              src={plan.public_image_url_md || plan.public_image_url}
                              alt={getSubscriptionTitle(plan)}
                              loading="lazy"
                              style={{ width:'100%', height:'100%', objectFit:'cover', objectPosition:'center' }}
                              onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            />
                          ) : (
                            <Box sx={{
                              width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center',
                              background: isDark ? 'linear-gradient(160deg, #171717 0%, #0b0b0d 100%)' : 'linear-gradient(160deg, #ffffff 0%, #f1f5f9 100%)'
                            }}>
                              <EventNote sx={{ fontSize:30, color: isDark ? '#e5e7eb' : '#64748b' }} />
                            </Box>
                          )}
                        </Box>
                        <Box sx={{ flex:1, display:'flex', flexDirection:'column', gap:0.8, minWidth:0 }}>
                          <Box sx={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:1 }}>
                            <Typography fontWeight={900} fontSize={16} sx={{ color: T?.textPrimary ?? "#111827", lineHeight:1.18, minWidth:0 }}>
                              {getSubscriptionTitle(plan)}
                            </Typography>
                            <Chip
                              label={getSubscriptionTypeLabel(plan.kind)}
                              size="small"
                              sx={{
                                height: 24, fontSize: 10.5, fontWeight: 800,
                                bgcolor: T ? 'rgba(148,163,184,0.2)' : '#f1f5f9',
                                color: T ? '#cbd5e1' : '#475569',
                                flexShrink: 0
                              }}
                            />
                          </Box>
                          {/* Sem descrição real: sobe o resumo (quando existir) +
                              preço/validade/economia para preencher o espaço ao
                              lado da imagem, em vez de deixar em branco. */}
                          {!hasRealDescription && (
                            <Box sx={{ display:'flex', flexDirection:'column', gap:0.6 }}>
                              {summaryText && (
                                <Typography sx={{ fontSize:12.5, color: T?.textSecondary ?? "#64748b", lineHeight:1.4 }}>
                                  {summaryText}
                                </Typography>
                              )}
                              {priceRow}
                            </Box>
                          )}
                        </Box>
                      </Box>

                      {/* Corpo do card: com descrição real, ela ocupa uma seção
                          própria de largura total (com preço/validade/economia
                          logo depois dela); sem descrição real, o corpo só tem
                          itens/CTA — preço já subiu para o cabeçalho acima. */}
                      <Box sx={{ px:1.5, pb:1.5 }}>
                        {hasRealDescription && (
                          <>
                            <Box sx={{ mb:1.1 }}>
                              <Typography
                                ref={(el: HTMLDivElement | null) => { planDescRefs.current[plan.id] = el; }}
                                sx={{
                                  fontSize:12.5,
                                  color: T?.textSecondary ?? "#64748b",
                                  lineHeight:1.55,
                                  letterSpacing:0,
                                  whiteSpace:'pre-line',
                                  ...(expandedPlanDesc[plan.id]
                                    ? { display:'block' }
                                    : { display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden' }),
                                }}
                              >
                                {realDescriptionText}
                              </Typography>
                              {descOverflowing[plan.id] && (
                                <Typography
                                  component="button"
                                  type="button"
                                  onClick={(e: any) => {
                                    e.stopPropagation();
                                    toggleExpandedPlanDesc(plan.id);
                                  }}
                                  sx={{
                                    mt:0.4, p:0, border:'none', background:'none', cursor:'pointer',
                                    fontSize:12.5, fontWeight:800, lineHeight:1.4,
                                    color: accentColor ?? '#2563EB',
                                    '&:hover': { textDecoration:'underline' },
                                  }}
                                >
                                  {expandedPlanDesc[plan.id] ? 'Ver menos' : 'Ver mais'}
                                </Typography>
                              )}
                            </Box>
                            <Box sx={{ mb:1.15 }}>{priceRow}</Box>
                          </>
                        )}

                          {totalUnits > 0 && (
                            <Typography fontSize={11.5} fontWeight={700} sx={{ color: T?.textSecondary ?? '#94a3b8', mb:0.8 }}>
                              {totalUnits} {totalUnits === 1 ? 'atendimento incluído' : 'atendimentos incluídos'}
                            </Typography>
                          )}

                          {planItems.length > 0 ? (
                            <Box sx={{ display:'flex', flexDirection:'column', gap:0.65 }}>
                              {planItems.slice(0, 4).map((item: any) => (
                                <Box key={item.id} sx={{ display:'flex', alignItems:'center', gap:0.8 }}>
                                  <CheckCircle sx={{ fontSize:15, color:accentColor, flexShrink:0 }} />
                                  <Typography fontSize={12.8} sx={{ color: T?.textSecondary ?? "#475569", lineHeight:1.4 }}>
                                    <Box component="span" sx={{ fontWeight:900, color: T?.textPrimary ?? '#111827' }}>
                                      {Number(item.quantity || 0)}x
                                    </Box>
                                    {' '}
                                    {getSubscriptionItemLabel(item)}
                                  </Typography>
                                </Box>
                              ))}
                              {planItems.length > 4 && (
                                <Typography fontSize={12} fontWeight={700} sx={{ color: T?.textSecondary ?? "#94a3b8", pl:2.9 }}>
                                  +{planItems.length - 4} outro(s) incluído(s)
                                </Typography>
                              )}
                            </Box>
                          ) : null}

                          {(() => {
                            const btnSx = {
                              mt:1.35,
                              bgcolor: T ? '#e2e8f0' : '#0f172a',
                              color: T ? '#0f172a' : '#fff',
                              '&:hover': { bgcolor: T ? '#cbd5e1' : '#111827' },
                              textTransform:'none',
                              fontWeight:800,
                              borderRadius:2
                            };
                            const isThisReserving = planReservingId === Number(plan.id);
                            const isThisChecking = planCheckoutLoadingId === Number(plan.id);
                            // "Reservar e pagar no local": pacote que a cliente já reservou
                            // (e o limite não permite outro) não oferece comprar de novo —
                            // mostra o estado e o caminho para agendar. Só para reserva no
                            // LOCAL; Pix/cartão em andamento seguem como sempre.
                            const reservedBlock = (blockedPlans || []).find((b: any) => Number(b.plan_id) === Number(plan.id) && b.status === 'pending_local_payment');
                            if (reservedBlock) {
                              const reservation = pendingReservations.find((r: any) => Number(r.id) === Number(reservedBlock.subscription_id));
                              return (
                                <Box data-testid="plan-already-reserved" sx={{ mt:1.35 }}>
                                  <Box sx={{ p:1.1, borderRadius:2, bgcolor: T ? 'rgba(251,191,36,0.10)' : '#fffbeb', border:`1px solid ${T ? 'rgba(251,191,36,0.45)' : '#fcd34d'}` }}>
                                    <Typography fontSize={12.6} fontWeight={800} sx={{ color: T ? '#fbbf24' : '#b45309', lineHeight:1.4 }}>
                                      Você já reservou este pacote. Pagamento pendente no estabelecimento.
                                    </Typography>
                                  </Box>
                                  {reservation?.can_schedule === true && (
                                    <Button fullWidth variant="contained" onClick={() => openPackageBooking(reservation)} sx={btnSx}>
                                      Agendar serviços
                                    </Button>
                                  )}
                                </Box>
                              );
                            }
                            if (!packagePaymentMethods.online && !packagePaymentMethods.local) {
                              return (
                                <Button fullWidth disabled variant="outlined" sx={{ mt:1.35, textTransform:'none', fontWeight:700, borderRadius:2 }}>
                                  Indisponível no momento
                                </Button>
                              );
                            }
                            if (packagePaymentMethods.online && !packagePaymentMethods.local) {
                              return (
                                <Button fullWidth variant="contained" disabled={isThisChecking} onClick={() => startPlanCheckout(plan)} sx={btnSx}>
                                  {isThisChecking ? <CircularProgress size={18} color="inherit" /> : 'Comprar e pagar agora'}
                                </Button>
                              );
                            }
                            if (!packagePaymentMethods.online && packagePaymentMethods.local) {
                              return (
                                <Button fullWidth variant="contained" disabled={isThisReserving} onClick={() => startPlanLocalReservation(plan)} sx={btnSx}>
                                  {isThisReserving ? <CircularProgress size={18} color="inherit" /> : 'Reservar e pagar no local'}
                                </Button>
                              );
                            }
                            // Ambos disponíveis — "Quero este pacote" abre a escolha.
                            if (planChoiceOpenId !== Number(plan.id)) {
                              return (
                                <Button fullWidth variant="contained" onClick={() => setPlanChoiceOpenId(Number(plan.id))} sx={btnSx}>
                                  Quero este pacote
                                </Button>
                              );
                            }
                            return (
                              <Box sx={{ display:'flex', flexDirection:'column', gap:0.7, mt:1.35 }}>
                                <Button fullWidth variant="contained" disabled={isThisChecking} onClick={() => startPlanCheckout(plan)} sx={{ ...btnSx, mt:0 }}>
                                  {isThisChecking ? <CircularProgress size={18} color="inherit" /> : 'Pagar agora'}
                                </Button>
                                <Button fullWidth variant="outlined" disabled={isThisReserving} onClick={() => startPlanLocalReservation(plan)} sx={{ textTransform:'none', fontWeight:800, borderRadius:2 }}>
                                  {isThisReserving ? <CircularProgress size={18} /> : 'Reservar e pagar no local'}
                                </Button>
                              </Box>
                            );
                          })()}
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>
        )}

        {/* --- CHECKOUT INTERNO DE PACOTES (piloto isolado, 13/09/2026) --- */}
        {(() => {
          const pkgAccent = company?.settings?.brand_color || '#c9a227';
          // Contraste simples (luminância relativa) — texto escuro sobre
          // cor clara, texto claro sobre cor escura. Nunca fixo em branco.
          const pkgAccentIsLight = (() => {
            const hex = String(pkgAccent).replace('#', '');
            if (hex.length !== 6) return false;
            const r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
            return (0.299 * r + 0.587 * g + 0.114 * b) > 170;
          })();
          const pkgAccentText = pkgAccentIsLight ? '#1a1a1a' : '#ffffff';
          const modalBg = T?.surface ?? '#fff';
          const modalText = T?.textPrimary ?? '#111827';
          const modalTextMuted = T?.textSecondary ?? '#64748b';
          const modalBorder = T?.border ?? '#e2e8f0';
          const totalAtendimentos = Array.isArray(packageCheckoutPlan?.items)
            ? packageCheckoutPlan.items.reduce((s: number, it: any) => s + Number(it.quantity || 0), 0)
            : null;

          const PackageSummary = () => (
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', mb: 2.5, pb: 2, borderBottom: `1px solid ${modalBorder}` }}>
              {packageCheckoutPlan?.public_image_url ? (
                <Box component="img" src={packageCheckoutPlan.public_image_url}
                  sx={{ width: 56, height: 56, borderRadius: 2, objectFit: 'cover', flexShrink: 0, border: `1px solid ${modalBorder}` }} />
              ) : (
                <Box sx={{ width: 56, height: 56, borderRadius: 2, flexShrink: 0, bgcolor: `${pkgAccent}1a`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CalendarMonth sx={{ fontSize: 26, color: pkgAccent }} />
                </Box>
              )}
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontWeight: 800, fontSize: 15.5, color: modalText, lineHeight: 1.25, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                  {packageCheckoutPlan?.public_title || packageCheckoutPlan?.name}
                </Typography>
                <Typography sx={{ fontSize: 13, color: modalTextMuted, mt: 0.3 }}>
                  R$ {Number(packageCheckoutPlan?.price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  {' · '}{packageCheckoutPlan?.validity_days || 30} dias
                  {totalAtendimentos ? ` · ${totalAtendimentos} atendimento${totalAtendimentos > 1 ? 's' : ''}` : ''}
                </Typography>
              </Box>
            </Box>
          );

          const showBackArrow = packageCheckoutStep === 'pix' || packageCheckoutStep === 'card';

          return (
            <Dialog open={!!packageCheckoutPlan} onClose={closePackageCheckout} fullWidth maxWidth="xs"
              sx={{ '& .MuiDialog-paper': { bgcolor: modalBg, backgroundImage: 'none' } }}>
              <Box sx={{ p: 3, pt: 2 }}>
                {/* Cabeçalho de navegação — seta só em Pix/cartão, X sempre visível.
                    Área de toque generosa (44x44) pro celular. */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: showBackArrow ? 'space-between' : 'flex-end', mb: 0.5, mx: -1 }}>
                  {showBackArrow ? (
                    <IconButton onClick={backToChoosePayment} aria-label="Voltar às formas de pagamento" sx={{ width: 44, height: 44, color: modalTextMuted }}>
                      <ChevronLeft />
                    </IconButton>
                  ) : <span />}
                  <IconButton onClick={closePackageCheckout} aria-label="Fechar" sx={{ width: 44, height: 44, color: modalTextMuted }}>
                    <Close />
                  </IconButton>
                </Box>

                <PackageSummary />

                {packageCheckoutStep === 'choose' && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2 }}>
                    {!packageCheckoutEmailValid && (
                      <TextField
                        size="small" fullWidth required autoFocus
                        label="Seu e-mail para o recibo do pagamento"
                        placeholder="voce@exemplo.com"
                        value={packageEmailOverride}
                        onChange={(e) => setPackageEmailOverride(e.target.value)}
                        sx={{
                          mb: 0.3,
                          '& .MuiOutlinedInput-root': { color: modalText, '& fieldset': { borderColor: modalBorder }, '&.Mui-focused fieldset': { borderColor: pkgAccent } },
                          '& .MuiInputLabel-root.Mui-focused': { color: pkgAccent },
                        }}
                      />
                    )}
                    <Button fullWidth variant="contained" disabled={!packageCheckoutEmailValid} onClick={startPackagePix}
                      sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2, bgcolor: pkgAccent, color: pkgAccentText, '&:hover': { bgcolor: pkgAccent, filter: 'brightness(0.94)' } }}>
                      Pagar com Pix
                    </Button>
                    <Button fullWidth variant="outlined" disabled={!packageCheckoutEmailValid} onClick={() => setPackageCheckoutStep('card')}
                      sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2, color: pkgAccent, borderColor: pkgAccent, '&:hover': { borderColor: pkgAccent, bgcolor: `${pkgAccent}0d` } }}>
                      Pagar com cartão
                    </Button>
                  </Box>
                )}

                {packageCheckoutStep === 'pix' && (
                  <Box sx={{ textAlign: 'center' }}>
                    {packagePixLoading && <CircularProgress size={28} sx={{ color: pkgAccent }} />}
                    {packagePixData && (
                      <>
                        {packagePixData.qr_code_base64 && (
                          // Fundo SEMPRE branco — QR code precisa de contraste
                          // real mesmo com o app no tema escuro.
                          <Box sx={{ display: 'inline-block', bgcolor: '#ffffff', p: 1.5, borderRadius: 2, border: `1px solid ${modalBorder}`, mb: 1.5 }}>
                            <Box component="img" src={`data:image/png;base64,${packagePixData.qr_code_base64}`} sx={{ width: 180, height: 180, display: 'block' }} />
                          </Box>
                        )}
                        <Typography sx={{ fontSize: 11.5, color: modalTextMuted, mb: 0.5 }}>Pix Copia e Cola</Typography>
                        <Box sx={{ bgcolor: isDark ? (T?.surfaceAlt ?? '#222') : '#f8fafc', color: modalText, borderRadius: 1.5, p: 1, mb: 1.5, wordBreak: 'break-all', fontSize: 11, fontFamily: 'monospace', border: `1px solid ${modalBorder}` }}>
                          {packagePixData.qr_code}
                        </Box>
                        <Button size="small" onClick={() => { navigator.clipboard?.writeText(packagePixData.qr_code); setSnack('Copiado!'); }} sx={{ color: pkgAccent }}>
                          Copiar código
                        </Button>
                        <Typography sx={{ fontSize: 13, fontWeight: 700, color: modalText, mt: 2 }}>Aguardando pagamento</Typography>
                        <Typography sx={{ fontSize: 12, color: modalTextMuted, mt: 0.5 }}>
                          Assim que o Pix for confirmado, seu pacote será liberado automaticamente.
                        </Typography>
                        <Typography sx={{ fontSize: 11, color: modalTextMuted, mt: 2 }}>
                          🔒 Pagamento seguro processado pelo Mercado Pago
                        </Typography>
                        <Button size="small" onClick={backToChoosePayment} sx={{ textTransform: 'none', color: modalTextMuted, mt: 0.5, fontSize: 12 }}>
                          ← Voltar às formas de pagamento
                        </Button>
                      </>
                    )}
                  </Box>
                )}

                {packageCheckoutStep === 'card' && (
                  <Box>
                    {!packageBricksReady && !packageBricksError && (
                      <Box sx={{ textAlign: 'center', py: 3 }}><CircularProgress size={26} sx={{ color: pkgAccent }} /></Box>
                    )}
                    {packageBricksError && <Typography sx={{ fontSize: 13, color: '#b91c1c', mb: 1 }}>{packageBricksError}</Typography>}
                    <div id="mp-package-bricks-container" />
                    <Typography sx={{ fontSize: 11, color: modalTextMuted, textAlign: 'center', mt: 1.5 }}>
                      🔒 Pagamento seguro processado pelo Mercado Pago
                    </Typography>
                    <Box sx={{ textAlign: 'center' }}>
                      <Button size="small" onClick={backToChoosePayment} sx={{ textTransform: 'none', color: modalTextMuted, mt: 0.5, fontSize: 12 }}>
                        ← Voltar às formas de pagamento
                      </Button>
                    </Box>
                  </Box>
                )}

                {packageCheckoutStep === 'done' && (
                  <Box sx={{ textAlign: 'center', py: 2 }}>
                    <Box sx={{ width: 48, height: 48, borderRadius: '50%', bgcolor: `${pkgAccent}1a`, display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 1.5 }}>
                      <CheckCircle sx={{ fontSize: 26, color: pkgAccent }} />
                    </Box>
                    <Typography sx={{ fontSize: 16, fontWeight: 800, color: modalText, mb: 0.5 }}>Pagamento aprovado</Typography>
                    <Typography sx={{ fontSize: 13.5, color: modalTextMuted, mb: 2 }}>
                      O pacote está ativo e pronto para usar.
                    </Typography>
                    {/* "Agendar agora" só existe aqui — este passo só é alcançado
                        depois de subscription_status==='active' confirmado no
                        banco (nunca em pending/rejected/expired/cancelled).
                        Reaproveita openPackageBooking, a MESMA função do aviso
                        "Agendar com saldo" — nenhuma lógica de agendamento nova. */}
                    <Button fullWidth variant="contained" onClick={openJustActivatedPackageBooking}
                      sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2, bgcolor: pkgAccent, color: pkgAccentText, '&:hover': { bgcolor: pkgAccent, filter: 'brightness(0.94)' } }}>
                      Agendar agora
                    </Button>
                    <Button fullWidth variant="text" onClick={closePackageCheckout} sx={{ textTransform: 'none', color: modalTextMuted, mt: 0.5 }}>
                      Agendar depois
                    </Button>
                  </Box>
                )}
              </Box>
            </Dialog>
          );
        })()}

        {/* --- TAB: INFORMAÇÕES --- */}
        {activeTab === infoTabIndex && (
          <Box sx={{ display:'flex', flexDirection:'column', gap:1.5 }}>

            {/* Sobre */}
            {company.description && (
              <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:3, p:2, boxShadow:'0 2px 16px rgba(0,0,0,0.06)' }}>
                <Box sx={{ display:'flex', alignItems:'center', gap:1.25, mb:1.5 }}>
                  <Box sx={{ width:32, height:32, borderRadius:2, bgcolor:`${accentColor}1a`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <Info sx={{ fontSize:17, color: accentColor }} />
                  </Box>
                  <Typography fontWeight={800} fontSize={15} sx={{ color: T?.textPrimary ?? "#1a1a1a", letterSpacing:'-0.01em' }}>Sobre Nós</Typography>
                </Box>
                <Typography variant="body2" sx={{ color: T?.textSecondary ?? '#64748b', whiteSpace:'pre-line', lineHeight:1.7 }}>
                  {company.description}
                </Typography>
              </Box>
            )}

            {/* Horários */}
            {company?.settings?.working_hours?.length > 0 && (
              <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:3, p:2, boxShadow:'0 2px 16px rgba(0,0,0,0.06)' }}>
                <Box sx={{ display:'flex', alignItems:'center', gap:1.25, mb:1.75 }}>
                  <Box sx={{ width:32, height:32, borderRadius:2, bgcolor:`${accentColor}1a`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <AccessTime sx={{ fontSize:17, color: accentColor }} />
                  </Box>
                  <Typography fontWeight={800} fontSize={15} sx={{ color: T?.textPrimary ?? "#1a1a1a", letterSpacing:'-0.01em' }}>Horários de Atendimento</Typography>
                </Box>
                {[
                  { key:1, label:'Segunda-feira' }, { key:2, label:'Terça-feira' },
                  { key:3, label:'Quarta-feira' }, { key:4, label:'Quinta-feira' },
                  { key:5, label:'Sexta-feira' }, { key:6, label:'Sábado' }, { key:0, label:'Domingo' }
                ].map(({ key, label }) => {
                  const wh = company.settings.working_hours.find((w: any) => w.day_of_week === key);
                  const isToday = new Date().getDay() === key;
                  return (
                    <Box key={key} sx={{
                      display:'flex', justifyContent:'space-between', alignItems:'center',
                      py:0.8, borderBottom:`1px solid ${T?.border ?? '#f5f5f5'}`,
                      bgcolor: isToday ? `${accentColor}22` : 'transparent',
                      px: isToday ? 1 : 0, mx: isToday ? -1 : 0,
                      borderRadius: isToday ? 1 : 0,
                    }}>
                      <Typography fontSize={13} fontWeight={isToday ? 700 : 400}
                        sx={{ color: wh?.open ? (T?.textPrimary ?? '#1a1a1a') : (T?.textSecondary ?? undefined) }}>
                        {label} {isToday && <Typography component="span" fontSize={10} sx={{ bgcolor:accentColor, color:'#fff', px:0.8, py:0.2, borderRadius:1, ml:0.5, fontWeight:700 }}>Hoje</Typography>}
                      </Typography>
                      <Typography fontSize={13} fontWeight={wh?.open ? 700 : 400}
                        sx={{ color: wh?.open ? (isToday ? accentColor : (T?.textPrimary ?? '#1a1a1a')) : (T?.textSecondary ?? undefined) }}>
                        {wh?.open ? `${wh.start_time} – ${wh.end_time}` : 'Fechado'}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            )}

            {/* Mapa + Endereço */}
            {(company.address || company?.settings?.google_maps_url) && company.settings?.show_address !== false && (
              <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:3, overflow:'hidden', boxShadow:'0 2px 16px rgba(0,0,0,0.06)' }}>
                <Box sx={{ display:'flex', alignItems:'center', gap:1.25, px:2, pt:2, pb:1.5 }}>
                  <Box sx={{ width:32, height:32, borderRadius:2, bgcolor:`${accentColor}1a`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <Place sx={{ fontSize:17, color: accentColor }} />
                  </Box>
                  <Typography fontWeight={800} fontSize={15} sx={{ color: T?.textPrimary ?? "#1a1a1a", letterSpacing:'-0.01em' }}>Localização</Typography>
                </Box>

                {company.address && (
                  <Box sx={{ px:2, pb:2 }}>
                    <Box
                      component="iframe"
                      title="Mapa da localização"
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      src={`https://www.google.com/maps?q=${encodeURIComponent(company.address)}&output=embed`}
                      sx={{ width:'100%', height:230, border:0, display:'block', borderRadius:2.5 }}
                    />
                  </Box>
                )}

                <Box sx={{ px:2, pb:2, display:'flex', flexDirection:'column', gap:1.25 }}>
                  <Box
                    component="a"
                    href={company?.settings?.google_maps_url || ("https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(company.address))}
                    target="_blank" rel="noopener noreferrer"
                    sx={{
                      display:'flex', alignItems:'center', justifyContent:'center', gap:1,
                      py:1.5, borderRadius:2.5, textDecoration:'none',
                      bgcolor: accentColor,
                      color: '#fff',
                      fontWeight:800, fontSize:13.5,
                      boxShadow:`0 4px 16px ${accentColor}55`,
                      '&:visited': { color: '#fff' },
                      '&:active': { color: '#fff' },
                      '&:hover': { filter:'brightness(0.92)' },
                      transition:'filter 0.15s',
                    }}>
                    <NearMe sx={{ fontSize:17 }} />
                    Abrir no Maps
                  </Box>

                  {company.address && (
                    <Box onClick={copyAddress} sx={{
                      display:'flex', alignItems:'center', gap:1.25, p:1.5, borderRadius:2.5, cursor:'pointer',
                      bgcolor: T?.surfaceAlt ?? '#f8fafc', border:`1px solid ${T?.border ?? '#eef2f7'}`,
                      transition:'border-color 0.15s',
                      '&:hover': { borderColor: `${accentColor}55` },
                    }}>
                      <Place sx={{ fontSize:18, color:'#e53935', flexShrink:0 }} />
                      <Typography fontSize={13} flex={1} sx={{ color: T?.textPrimary ?? '#334155', lineHeight:1.45 }}>{company.address}</Typography>
                      <CopyAll sx={{ fontSize:16, color: T?.textSecondary ?? '#94a3b8', flexShrink:0 }} />
                    </Box>
                  )}
                </Box>
              </Box>
            )}

            {/* Contato & Social */}
            {(company.phone || company.website || company.instagram || company.facebook) && (
              <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:3, p:2, boxShadow:'0 2px 16px rgba(0,0,0,0.06)' }}>
                <Box sx={{ display:'flex', alignItems:'center', gap:1.25, mb:1.5 }}>
                  <Box sx={{ width:32, height:32, borderRadius:2, bgcolor:`${accentColor}1a`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <Phone sx={{ fontSize:17, color: accentColor }} />
                  </Box>
                  <Typography fontWeight={800} fontSize={15} sx={{ color: T?.textPrimary ?? "#1a1a1a", letterSpacing:'-0.01em' }}>Contato</Typography>
                </Box>
                <Box sx={{ display:'flex', flexDirection:'column', gap:1 }}>
                {company.phone && (
                  <Box component="a" href={`tel:${company.phone.replace(/\D/g,'')}`}
                    sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.2, borderRadius:2.5, textDecoration:'none', color:'inherit',
                      bgcolor: T?.surfaceAlt ?? 'rgba(0,0,0,0.03)', transition:'background 0.15s',
                      '&:hover': { bgcolor: `${accentColor}14` } }}>
                    <Box sx={{ width:36, height:36, borderRadius:2, bgcolor:'#e8f5e9', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                      <Phone sx={{ fontSize:18, color:'#2e7d32' }} />
                    </Box>
                    <Box sx={{ flex:1, minWidth:0 }}>
                      <Typography fontSize={11} fontWeight={600} sx={{ color: T?.textSecondary ?? '#94a3b8', textTransform:'uppercase', letterSpacing:'0.04em' }}>Telefone</Typography>
                      <Typography fontSize={13.5} fontWeight={700} sx={{ color: T?.textPrimary ?? "#1a1a1a" }} noWrap>{company.phone}</Typography>
                    </Box>
                    <ChevronRight sx={{ fontSize:20, color: T?.textSecondary ?? '#cbd5e1', flexShrink:0 }} />
                  </Box>
                )}
                {waPhone && (
                  <Box component="a" href={`https://wa.me/55${waPhone}`} target="_blank" rel="noopener noreferrer"
                    sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.2, borderRadius:2.5, textDecoration:'none', color:'inherit',
                      bgcolor: T?.surfaceAlt ?? 'rgba(0,0,0,0.03)', transition:'background 0.15s',
                      '&:hover': { bgcolor: `${accentColor}14` } }}>
                    <Box sx={{ width:36, height:36, borderRadius:2, bgcolor:'#e8f5e9', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                      <WhatsApp sx={{ fontSize:18, color:'#25D366' }} />
                    </Box>
                    <Box sx={{ flex:1, minWidth:0 }}>
                      <Typography fontSize={11} fontWeight={600} sx={{ color: T?.textSecondary ?? '#94a3b8', textTransform:'uppercase', letterSpacing:'0.04em' }}>WhatsApp</Typography>
                      <Typography fontSize={13.5} fontWeight={700} sx={{ color: T?.textPrimary ?? "#1a1a1a" }} noWrap>Conversar agora</Typography>
                    </Box>
                    <ChevronRight sx={{ fontSize:20, color: T?.textSecondary ?? '#cbd5e1', flexShrink:0 }} />
                  </Box>
                )}
                {company.website && (
                  <Box component="a" href={company.website} target="_blank" rel="noopener noreferrer"
                    sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.2, borderRadius:2.5, textDecoration:'none', color:'inherit',
                      bgcolor: T?.surfaceAlt ?? 'rgba(0,0,0,0.03)', transition:'background 0.15s',
                      '&:hover': { bgcolor: `${accentColor}14` } }}>
                    <Box sx={{ width:36, height:36, borderRadius:2, bgcolor:"#e3f2fd", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}><Language sx={{ fontSize:18, color:"#1976d2" }} /></Box>
                    <Box sx={{ flex:1, minWidth:0 }}>
                      <Typography fontSize={11} fontWeight={600} sx={{ color: T?.textSecondary ?? '#94a3b8', textTransform:'uppercase', letterSpacing:'0.04em' }}>Site</Typography>
                      <Typography fontSize={13.5} fontWeight={700} sx={{ color: isDark ? '#90caf9' : '#1976d2' }} noWrap>
                        {company.website.replace(/^https?:\/\//, '')}
                      </Typography>
                    </Box>
                    <ChevronRight sx={{ fontSize:20, color: T?.textSecondary ?? '#cbd5e1', flexShrink:0 }} />
                  </Box>
                )}
                {company.instagram && (() => {
                  // Normalizador de Instagram — liberação global. Opt-out
                  // de emergência por empresa via
                  // settings.instagram_normalizer_disabled=true.
                  const instagramPilotActive = (company as any).settings?.instagram_normalizer_disabled !== true;

                  let instagramHref: string;
                  let instagramLabel: string;
                  if (!instagramPilotActive) {
                    const legacyHandle = company.instagram.replace(/^@/, '').replace(/\s+/g, '');
                    instagramHref = `https://instagram.com/${legacyHandle}`;
                    instagramLabel = `@${legacyHandle}`;
                  } else {
                    const normalized = normalizeInstagram(company.instagram);
                    if (!normalized) {
                      // Valor não interpretável com segurança — oculta o
                      // contato em vez de abrir um link quebrado.
                      console.warn('[BookingPage] Instagram em formato não reconhecido, contato ocultado (slug):', company.slug);
                      return null;
                    }
                    instagramHref = normalized.url;
                    instagramLabel = normalized.display;
                  }

                  return (
                    <Box component="a"
                      href={instagramHref}
                      target="_blank" rel="noopener noreferrer"
                      sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.2, borderRadius:2.5, textDecoration:'none', color:'inherit',
                        bgcolor: T?.surfaceAlt ?? 'rgba(0,0,0,0.03)', transition:'background 0.15s',
                        '&:hover': { bgcolor: `${accentColor}14` } }}>
                      <Box sx={{ width:36, height:36, borderRadius:2, bgcolor:"#fce4ec", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}><Instagram sx={{ fontSize:18, color:"#e91e63" }} /></Box>
                      <Box sx={{ flex:1, minWidth:0 }}>
                        <Typography fontSize={11} fontWeight={600} sx={{ color: T?.textSecondary ?? '#94a3b8', textTransform:'uppercase', letterSpacing:'0.04em' }}>Instagram</Typography>
                        <Typography fontSize={13.5} fontWeight={700} sx={{ color: isDark ? (T?.textPrimary ?? '#f1f5f9') : '#e91e63' }} noWrap>
                          {instagramLabel}
                        </Typography>
                      </Box>
                      <ChevronRight sx={{ fontSize:20, color: T?.textSecondary ?? '#cbd5e1', flexShrink:0 }} />
                    </Box>
                  );
                })()}
                {company.facebook && (
                  <Box sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.2, borderRadius:2.5,
                    bgcolor: T?.surfaceAlt ?? 'rgba(0,0,0,0.03)' }}>
                    <Box sx={{ width:36, height:36, borderRadius:2, bgcolor:"#e3f2fd", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}><Facebook sx={{ fontSize:18, color:"#1976d2" }} /></Box>
                    <Box sx={{ flex:1, minWidth:0 }}>
                      <Typography fontSize={11} fontWeight={600} sx={{ color: T?.textSecondary ?? '#94a3b8', textTransform:'uppercase', letterSpacing:'0.04em' }}>Facebook</Typography>
                      <Typography fontSize={13.5} fontWeight={700} sx={{ color: T?.textPrimary ?? "#1a1a1a" }} noWrap>{company.facebook}</Typography>
                    </Box>
                  </Box>
                )}
                </Box>
              </Box>
            )}

            {/* Profissionais */}
            {company.has_team !== false && professionals.length > 1 && (
              <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:3, p:2, boxShadow:'0 2px 16px rgba(0,0,0,0.06)' }}>
                <Box sx={{ display:'flex', alignItems:'center', gap:1.25, mb:2 }}>
                  <Box sx={{ width:32, height:32, borderRadius:2, bgcolor:`${accentColor}1a`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <PersonAdd sx={{ fontSize:17, color: accentColor }} />
                  </Box>
                  <Typography fontWeight={800} fontSize={15} sx={{ color: T?.textPrimary ?? "#1a1a1a", letterSpacing:'-0.01em' }}>Nossa Equipe</Typography>
                </Box>
                <Box sx={{ display:'flex', gap:2.5, overflowX:'auto', pb:0.5, '&::-webkit-scrollbar':{ height:3 }, '&::-webkit-scrollbar-thumb':{ bgcolor:'#ddd', borderRadius:2 } }}>
                  {professionals.map((p: any) => {
                    const pParts = (p.name || '').split(' ');
                    const pDisplay = pParts.slice(0,2).join(' ');
                    return (
                      <Box key={p.id} sx={{ textAlign:'center', flexShrink:0, width:80 }}>
                        <Avatar src={p.photo_url}
                          sx={{ width:80, height:80, mx:'auto', mb:1, bgcolor:'#1a1a1a', fontWeight:700, fontSize:26, border:`3px solid ${T?.border ?? '#f0f0f0'}`, boxShadow:'0 2px 8px rgba(0,0,0,0.1)' }}>
                          {p.name?.[0]}
                        </Avatar>
                        <Typography fontSize={12} fontWeight={700} lineHeight={1.2} sx={{ wordBreak:'break-word' }}>{pDisplay}</Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            )}

          </Box>
        )}

      </Box>

      {/* ===== FOOTER ===== */}
      <Box sx={{ mt: 6, py: 4, textAlign: 'center', color: '#aaa', px: 2 }}>
        <Typography fontSize={12} fontWeight={600} color="#374151">{company?.name} © {new Date().getFullYear()}</Typography>
        <Typography fontSize={11} color="#bbb" mt={0.3}>Todos os direitos reservados</Typography>
        <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
          <Typography component="span" fontSize={12}
            sx={{ textDecoration: 'underline', cursor: 'pointer', color: '#9ca3af', '&:hover': { color: '#374151' } }}
            onClick={() => {
              const txt = company?.settings?.terms_text;
              setTermsText(txt || getAutoTerms(company?.name || ''));
              setTermsOpen(true);
            }}>
            Termos de Uso
          </Typography>
          <Typography component="span" fontSize={12} color="#e5e7eb">|</Typography>
          <Typography component="span" fontSize={12}
            sx={{ textDecoration: 'underline', cursor: 'pointer', color: '#9ca3af', '&:hover': { color: '#374151' } }}
            onClick={() => {
              const txt = company?.settings?.privacy_text;
              setTermsText(txt || getAutoPrivacy(company?.name || ''));
              setTermsOpen(true);
            }}>
            Política de Privacidade
          </Typography>
        </Box>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5 }}>
          <Typography component="a" href="https://agendali.com.br" target="_blank" rel="noopener noreferrer"
            sx={{ fontSize: 11, color: '#c4b5fd', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 0.5, '&:hover': { color: '#7c3aed' }, transition: 'color 0.15s' }}>
            Feito com ❤️ por Agendali
          </Typography>
        </Box>
      </Box>

      {/* ===== BOTTOM BAR ===== */}
      {selected.length > 0 && !modalOpen && (
        <Slide in direction="up">
          <Box sx={{
            position:'fixed',
            // Piloto: quando a barra de prévia V2 está visível, sobe pra não
            // sobrepor o botão "Voltar ao painel". Fora do piloto/preview,
            // comportamento 100% igual ao original (bottom: 0).
            bottom: (isPreview && pilotUI) ? PREVIEW_BAR_HEIGHT : 0,
            left:0, right:0, zIndex:300,
            bgcolor: T?.bg ?? '#fff', borderTop: `1px solid ${T?.border ?? '#eee'}`,
            px:2, py:1.4, boxShadow:'0 -8px 32px rgba(0,0,0,0.12)',
            display:'flex', flexDirection:'row', alignItems:'center', gap:1.5,
          }}>
            {/* Avatares lado a lado com overlap */}
            <Box sx={{ display:'flex', flexDirection:'row', alignItems:'center', flexShrink:0 }}>
              {selected.slice(0,3).map((s: any, i: number) => (
                <Box key={s.id} sx={{
                  width:36, height:36, borderRadius:'50%', overflow:'hidden',
                  border: `2.5px solid ${T?.bg ?? '#fff'}`, marginLeft: i > 0 ? '-10px' : '0px',
                  bgcolor: T?.surface ?? '#f0f0f0', flexShrink:0, position:'relative',
                  zIndex: 3 - i,
                }}>
                  <ServiceThumb url={s.image_url_thumb || s.image_url} size={36} businessType={company?.settings?.business_type} defaultServiceIcon={company?.settings?.default_service_icon} />
                </Box>
              ))}
            </Box>
            {/* Texto */}
            <Box sx={{ flex:1, minWidth:0 }}>
              <Typography fontWeight={800} fontSize={14} sx={{ color: T?.textPrimary }}>
                {selected.length} serviço{selected.length > 1 ? 's' : ''}
              </Typography>
              <Typography variant="caption" sx={{ color:accentColor, cursor:'pointer', fontWeight:600 }} onClick={() => setSelected([])}>
                Limpar seleção
              </Typography>
            </Box>
            {/* Botão */}
            <Button variant="contained" onClick={handleAgendarClick}
              sx={{
                fontWeight:800, px:2.5, py:1.1, borderRadius:2.5,
                bgcolor:accentColor, '&:hover':{ filter:'brightness(0.88)' },
                textTransform:'none', fontSize:14, flexShrink:0,
                boxShadow:`0 4px 16px ${accentColor}55`,
              }}>
              Agendar →
            </Button>
          </Box>
        </Slide>
      )}

      {/* ===== COVER LAYER – aparece no mesmo frame que o modal abre, sem animação,
           impede flash do conteúdo da página durante a transição SlideUp ===== */}
      {modalOpen && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: T?.bg ?? '#fff',
          zIndex: 1299,
          pointerEvents: 'none',
        }} />
      )}

      {/* ===== BOOKING MODAL ===== */}
      <Dialog open={modalOpen && !(step === 'done' && confirmationV2Pilot)} onClose={() => setModalOpen(false)} fullWidth maxWidth="md" TransitionComponent={SlideUp}
        sx={{
          '& .MuiDialog-paper': {
            bgcolor: T?.bg ?? '#fff',
            width: { xs: '100vw', sm: 'auto' },
            maxWidth: { xs: '100vw', sm: '860px' },
            height: { xs: 'calc(100dvh - env(safe-area-inset-top, 0px))', sm: 'auto' },
            maxHeight: { xs: 'calc(100dvh - env(safe-area-inset-top, 0px))', sm: '92vh' },
            margin: { xs: 0, sm: '16px' },
            position: { xs: 'fixed', sm: 'relative' },
            left: { xs: 0, sm: 'auto' },
            right: { xs: 0, sm: 'auto' },
            bottom: { xs: 0, sm: 'auto' },
            top: { xs: 'env(safe-area-inset-top, 0px)', sm: 'auto' },
            borderRadius: { xs: '20px 20px 0 0', sm: '20px' },
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          },
          '& .MuiDialog-container': {
            alignItems: { xs: 'flex-end', sm: 'center' },
          },
        }}>
        <DialogContent ref={dialogContentRef} sx={{ p: 0, overflow: 'auto', flex: 1, display: 'flex', flexDirection: 'column', overscrollBehavior: 'contain', bgcolor: T?.bg ?? '#fff' }}>
          {step === 'booking' && (
            <>
              {/* ===== HEADER STICKY COM STEPS ===== */}
              <Box sx={{ position:'sticky', top:0, bgcolor: T?.bg ?? '#fff', zIndex:10, borderBottom: `1px solid ${T?.border ?? '#f0f0f0'}` }}>
                <Box sx={{ px:{ xs:2, sm:3 }, pt:2, pb:1, display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <Box>
                    <Typography fontSize={11} fontWeight={700} sx={{ color: accentColor, textTransform:'uppercase', letterSpacing:1, mb:0.3 }}>
                      Agendar · 1 de 3
                    </Typography>
                    <Typography fontWeight={900} fontSize={17} sx={{ color: T?.textPrimary ?? '#1a1a1a' }} lineHeight={1.2}>Quando e com quem?</Typography>
                  </Box>
                  <IconButton size="small" onClick={() => setModalOpen(false)} sx={{ mt:-0.5, color: T?.textSecondary ?? '#888' }}><Close /></IconButton>
                </Box>
                <Box sx={{ display:'flex', gap:0.5, px:{ xs:2, sm:3 }, pb:1.5 }}>
                  {[1,2,3].map(i => (
                    <Box key={i} sx={{ flex:1, height:3, borderRadius:2, bgcolor: i <= 1 ? accentColor : (T?.border ?? '#e0e0e0'), transition:'background 0.3s' }} />
                  ))}
                </Box>
              </Box>

              {/* ===== CALENDÁRIO ÚNICO COMPARTILHADO ===== */}
              {(() => {
                const workingHours = company?.settings?.working_hours || [];
                const isClosedDay = (date: Date) => {
                  if (workingHours.length === 0) return false;
                  const wh = workingHours.find((w: any) => w.day_of_week === date.getDay());
                  return wh ? !wh.open : false;
                };
                // Antecedência para Agendamento — trava o avanço de mês quando a
                // empresa configurou max_advance_days explicitamente. Só ajusta a
                // navegação; a garantia real de que datas fora da janela não
                // aparecem como disponíveis já vem do backend (available_days).
                const maxAdvRaw = company?.settings?.max_advance_days;
                const hasMaxAdv = maxAdvRaw !== undefined && maxAdvRaw !== null && maxAdvRaw !== '';
                const maxAllowedDate = hasMaxAdv ? addDays(new Date(), Number(maxAdvRaw) || 0) : null;
                const atMaxMonth = maxAllowedDate
                  ? (calMonth.getFullYear() > maxAllowedDate.getFullYear() ||
                     (calMonth.getFullYear() === maxAllowedDate.getFullYear() && calMonth.getMonth() >= maxAllowedDate.getMonth()))
                  : false;
                return (
                  <Box sx={{ px:{ xs:2, sm:3 }, pt:2, pb:1 }}>
                    {/* Cabeçalho do mês */}
                    <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:1.5 }}>
                      <IconButton size="small" onClick={() => setCalMonth(m => subMonths(m, 1))}
                        sx={{ bgcolor:`${accentColor}18`, color:accentColor, width:32, height:32, '&:hover':{ bgcolor:`${accentColor}30` } }}>
                        <ChevronLeft sx={{ fontSize:18 }} />
                      </IconButton>
                      <Typography fontWeight={800} fontSize={15} sx={{ textTransform:'capitalize', color: T?.textPrimary ?? '#1a1a1a', letterSpacing:0.3 }}>
                        {format(calMonth, "MMMM yyyy", { locale: ptBR })}
                      </Typography>
                      <IconButton size="small" disabled={atMaxMonth} onClick={() => setCalMonth(m => addMonths(m, 1))}
                        sx={{ bgcolor:`${accentColor}18`, color:accentColor, width:32, height:32, '&:hover':{ bgcolor:`${accentColor}30` },
                          '&.Mui-disabled': { bgcolor: '#f0f0f0', color: '#ccc' } }}>
                        <ChevronRight sx={{ fontSize:18 }} />
                      </IconButton>
                    </Box>
                    {/* Dias da semana */}
                    <Box sx={{ display:'grid', gridTemplateColumns:'repeat(7, 1fr)', mb:0.8 }}>
                      {WEEK_DAYS.map((d, idx) => {
                        const todayWeekDay = new Date().getDay();
                        const isCurrentDay = idx === todayWeekDay;
                        return (
                          <Box key={d} sx={{ display:'flex', flexDirection:'column', alignItems:'center', py:0.5 }}>
                            <Typography align="center" fontWeight={isCurrentDay ? 800 : 700} fontSize={10}
                              sx={{
                                color: isCurrentDay ? accentColor : '#aaa',
                                textTransform:'uppercase', letterSpacing:0.5,
                              }}>
                              {d}
                            </Typography>
                            {isCurrentDay && (
                              <Box sx={{ width:3, height:3, borderRadius:'50%', bgcolor: accentColor, mt:'2px' }} />
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                    {/* Grid de dias */}
                    <Box sx={{ display:'grid', gridTemplateColumns:'repeat(7, 1fr)', gap:{ xs:0.4, sm:0.8 } }}>
                      {Array.from({ length: startPad }).map((_, i) => <Box key={'p'+i} />)}
                      {allDays.map(day => {
                        const isPast = isBefore(day, today);
                        const isClosed = isClosedDay(day);
                        const dayStr = format(day, "yyyy-MM-dd");
                        const isAvail = availableDays.includes(dayStr);
                        const hasNoSlots = !isPast && !isClosed && availableDays.length > 0 && !isAvail;
                        const isDisabled = isPast || isClosed || hasNoSlots;
                        const isSel = selDate && isSameDay(day, selDate);
                        const isToday = isSameDay(day, new Date());
                        return (
                          <Box key={day.toISOString()} onClick={() => !isDisabled && handleDateSelect(day)}
                            sx={{
                              aspectRatio:'1', display:'flex', alignItems:'center', justifyContent:'center',
                              borderRadius:'50%', cursor: isDisabled ? 'default' : 'pointer',
                              bgcolor: isSel
                                ? accentColor
                                : (isAvail && !isClosed)
                                  ? `${accentColor}18`
                                  : 'transparent',
                              border: isToday && !isSel ? `2px solid ${accentColor}` : '2px solid transparent',
                              boxShadow: isSel ? `0 4px 12px ${accentColor}55` : 'none',
                              transition:'all 0.15s',
                              '&:hover': !isDisabled ? {
                                bgcolor: isSel ? accentColor : `${accentColor}30`,
                                transform:'scale(1.08)',
                              } : {},
                            }}>
                            <Typography
                              fontSize={13}
                              fontWeight={isSel ? 800 : (isAvail && !isClosed) ? 600 : 400}
                              sx={{
                                color: isSel ? '#fff'
                                  : isDisabled ? (isDark ? '#444' : '#d0d0d0')
                                  : (isAvail && !isClosed) ? accentColor
                                  : (isDark ? '#555' : '#bbb'),
                                lineHeight:1,
                                textDecoration: isDisabled && !isSel ? 'line-through' : 'none',
                                textDecorationColor: isDark ? '#555' : '#d8d8d8',
                                textDecorationThickness: '1px',
                              }}>
                              {format(day, 'd')}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                    {/* Legenda */}
                    <Box sx={{ display:'flex', gap:2, mt:1.5, justifyContent:'center' }}>
                      <Box sx={{ display:'flex', alignItems:'center', gap:0.5 }}>
                        <Box sx={{ width:8, height:8, borderRadius:'50%', bgcolor:`${accentColor}30`, border:`1.5px solid ${accentColor}` }} />
                        <Typography fontSize={10} sx={{ color: T?.textSecondary }} color="text.secondary">Disponível</Typography>
                      </Box>
                      <Box sx={{ display:'flex', alignItems:'center', gap:0.5 }}>
                        <Box sx={{ width:8, height:8, borderRadius:'50%', bgcolor:accentColor }} />
                        <Typography fontSize={10} sx={{ color: T?.textSecondary }} color="text.secondary">Selecionado</Typography>
                      </Box>
                    </Box>
                  </Box>
                );
              })()}

              {/* ===== HORÁRIO DE INÍCIO DO COMBO ===== */}
              {selDate && (
                <Box sx={{ px:2, pb:1 }}>
                  {slotsLoading ? (
                    <Box sx={{ display:'flex', justifyContent:'center', py:3 }}><CircularProgress size={22} /></Box>
                  ) : (() => {
                    const totalDuration = selected.reduce((sum: number, s: any) => sum + s.duration_min, 0);
                    const availSlots = slots.filter((s: any) => s.available);
                    return (
                      <Box sx={{ mt:2 }}>
                        {/* Duração total do combo */}
                        <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1.5 }}>
                          <Typography fontSize={12} sx={{ color: T?.textSecondary }} color="text.secondary">
                            {selected.length > 1 ? `Combo: ${selected.map((s: any) => s.name).join(' + ')} · ` : ''}{totalDuration}min total
                          </Typography>
                          {selTime && (
                            <Chip size="small"
                              label={`até ${(() => { const [h,m] = selTime.split(':').map(Number); const end = h*60+m+totalDuration; return `${String(Math.floor(end/60)).padStart(2,'0')}:${String(end%60).padStart(2,'0')}`; })()}`}
                              sx={{ fontSize:11, fontWeight:700, bgcolor:'#1a1a1a', color:'#fff', height:20 }}
                            />
                          )}
                        </Box>
                        {availSlots.length === 0 ? (
                          <Box sx={{ py:1.5 }}>
                            <Typography variant="caption" sx={{ color: T?.textSecondary }} color="text.secondary" display="block" mb={1.5}>
                              Nenhum horário disponível neste dia.
                            </Typography>
                            {!showInlineNext && (
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Button size="small" startIcon={nextSlotsLoading ? <CircularProgress size={14} /> : <SearchRounded sx={{ fontSize:16 }} />}
                                  onClick={searchNextSlots} disabled={nextSlotsLoading}
                                  sx={{ textTransform:'none', fontWeight:700, fontSize:12, color:accentColor, bgcolor:`${accentColor}12`, borderRadius:2, px:2, py:0.8, border:`1.5px solid ${accentColor}50`, '&:hover': { bgcolor:`${accentColor}25` } }}>
                                  {nextSlotsLoading ? 'Buscando...' : 'Buscar próximos horários disponíveis'}
                                </Button>
                                {company?.settings?.waitlist_enabled !== false && (
                                  <Button size="small" startIcon={<NotificationsActive sx={{ fontSize:14 }} />}
                                    onClick={() => {
                                        if (name) setWaitlistName(name);
                                        if (phone) setWaitlistPhone(phone);
                                        setWaitlistPeriod('qualquer');
                                        setWaitlistOpen(true);
                                      }}
                                    sx={{ textTransform:'none', fontWeight:700, fontSize:12, color:'#f59e0b', bgcolor:'#fff8e1', borderRadius:2, px:2, py:0.8, border:'1.5px dashed #f59e0b', '&:hover': { bgcolor:'#fef3c7' }, alignSelf:'flex-start' }}>
                                    Entrar na fila de espera
                                  </Button>
                                )}
                              </Box>
                            )}
                            {showInlineNext && nextSlotsLoading && (
                              <Box sx={{ display:'flex', alignItems:'center', gap:1, py:1 }}>
                                <CircularProgress size={16} sx={{ color:'#888' }} />
                                <Typography fontSize={12} color="text.secondary">Buscando horários...</Typography>
                              </Box>
                            )}
                            {showInlineNext && !nextSlotsLoading && nextSlotsData.length === 0 && (
                              <Box>
                                <Typography fontSize={12} color="text.secondary" mb={1.5}>Nenhum horário nos próximos 60 dias.</Typography>
                                <Box sx={{ p: 2, borderRadius: 2, bgcolor: T ? 'rgba(245,158,11,0.1)' : '#fff8e1', border: T ? '1.5px dashed rgba(245,158,11,0.5)' : '1.5px dashed #f59e0b', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <NotificationsActive sx={{ fontSize: 18, color: '#f59e0b' }} />
                                    <Typography fontSize={13} fontWeight={700} sx={{ color: T ? "#fde68a" : "#92400e" }}>Entrar na fila de espera</Typography>
                                  </Box>
                                  <Typography fontSize={12} sx={{ color: T ? "#fde68a" : "#92400e" }} lineHeight={1.5}>
                                    Cadastre seu contato e avisamos assim que um horário abrir. Você terá {15} minutos para confirmar.
                                  </Typography>
                                  {company?.settings?.waitlist_enabled !== false && (
                                    <Button size="small" variant="contained" startIcon={<PersonAdd sx={{ fontSize: 15 }} />}
                                      onClick={() => {
                                        if (name) setWaitlistName(name);
                                        if (phone) setWaitlistPhone(phone);
                                        setWaitlistPeriod('qualquer');
                                        setWaitlistOpen(true);
                                      }}
                                      sx={{ textTransform: 'none', fontWeight: 700, fontSize: 12, bgcolor: '#f59e0b', color: '#fff', borderRadius: 2, alignSelf: 'flex-start', '&:hover': { bgcolor: '#d97706' } }}>
                                      Quero ser avisado(a)
                                    </Button>
                                  )}
                                </Box>
                              </Box>
                            )}
                            {showInlineNext && !nextSlotsLoading && nextSlotsData.length > 0 && (
                              <Box sx={{ mt:1.5, display:'flex', flexDirection:'column', gap:2 }}>
                                {nextSlotsData.slice(0, inlineNextPage).map(({ date, label, slots: ds }) => (
                                  <Box key={date}>
                                    <Box sx={{ display:'flex', alignItems:'center', gap:0.8, mb:0.8 }}>
                                      <CalendarMonth sx={{ fontSize:14, color:accentColor }} />
                                      <Typography fontSize={12} fontWeight={800} color="#1a1a1a" sx={{ textTransform:'capitalize' }}>{label}</Typography>
                                    </Box>
                                    <Box sx={{ display:'flex', flexWrap:'wrap', gap:0.6 }}>
                                      {ds.slice(0, 6).map(time => (
                                        <Box key={time} onClick={() => { handleDateSelect(parseISO(date)); setSelTime(time); setShowInlineNext(false); setInlineNextPage(2); }}
                                          sx={{ px:1.5, py:0.6, borderRadius:1.5, fontSize:12, fontWeight:700, border:`1.5px solid ${accentColor}`, bgcolor:`${accentColor}10`, color:accentColor, cursor:'pointer', transition:'all 0.15s', '&:hover': { bgcolor:accentColor, color:'#fff' } }}>
                                          {time}
                                        </Box>
                                      ))}
                                    </Box>
                                  </Box>
                                ))}
                                <Box sx={{ display:'flex', alignItems:'center', gap:1.5, mt:0.5 }}>
                                  {inlineNextPage < nextSlotsData.length && (
                                    <Button size="small" startIcon={<SearchRounded sx={{ fontSize:14 }} />}
                                      onClick={() => setInlineNextPage(p => p + 2)}
                                      sx={{ textTransform:'none', fontWeight:700, fontSize:11, color:accentColor, bgcolor:`${accentColor}12`, borderRadius:2, px:1.5, py:0.6, border:`1.5px solid ${accentColor}50`, '&:hover': { bgcolor:`${accentColor}25` } }}>
                                      Ver mais horários
                                    </Button>
                                  )}
                                  <Typography fontSize={11} color="text.secondary" sx={{ cursor:'pointer', textDecoration:'underline' }}
                                    onClick={() => { setShowInlineNext(false); setInlineNextPage(2); }}>
                                    Fechar
                                  </Typography>
                                </Box>
                              </Box>
                            )}
                          </Box>
                        ) : (
                          <Box sx={{ display:'grid', gridTemplateColumns:{ xs: 'repeat(3, 1fr)', sm: 'repeat(4, 1fr)', md: 'repeat(5, 1fr)' }, gap:0.8 }}>
                            {availSlots.map((slot: any) => {
                              const isSel = selTime === slot.time;
                              return (
                                <Box key={slot.time} onClick={() => { setSelTime(slot.time); trackGrowthEvent(slug, company?.growth_module_enabled, 'slot_select', { service_id: selected[0]?.id, professional_id: selPro?.id || undefined }); }}
                                  sx={{
                                    py:0.7, borderRadius:1.5, fontSize:12, fontWeight:600, textAlign:'center',
                                    border: isSel ? `2px solid ${accentColor}` : `1.5px solid ${accentColor}40`,
                                    bgcolor: isSel ? accentColor : `${accentColor}08`,
                                    color: isSel ? '#fff' : accentColor,
                                    cursor:'pointer', transition:'all 0.15s',
                                    boxShadow: isSel ? `0 2px 8px ${accentColor}50` : 'none',
                                    '&:hover': { bgcolor: isSel ? accentColor : `${accentColor}20` },
                                  }}>
                                  {slot.time}
                                </Box>
                              );
                            })}
                          </Box>
                        )}
                      </Box>
                    );
                  })()}
                </Box>
              )}

              {/* ===== LISTA COMPACTA DE SERVIÇOS ===== */}
              <Box sx={{ borderBottom: `2px solid ${T?.border ?? '#f0f0f0'}` }}>
                {selected.map((svc) => (
                  <Box key={svc.id} sx={{ px:{ xs:2, sm:3 }, py:1.2, borderBottom: `1px solid ${T?.border ?? '#f5f5f5'}`, display:'flex', alignItems:'center', gap:1.5 }}>
                    <Box sx={{ width:36, height:36, borderRadius:1.5, overflow:'hidden', bgcolor: T?.surface ?? '#f5f5f5', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                      <ServiceThumb url={svc.image_url_thumb || svc.image_url} size={16} businessType={company?.settings?.business_type} defaultServiceIcon={company?.settings?.default_service_icon} />
                    </Box>
                    <Box sx={{ flex:1, minWidth:0 }}>
                      <Typography fontWeight={700} fontSize={13} noWrap sx={{ color: T?.textPrimary ?? '#1a1a1a' }}>{svc.name}</Typography>
                      <Typography variant="caption" sx={{ color: T?.textSecondary }} color="text.secondary">
                        {svc.duration_min}min · R$ {Number(svc.price).toFixed(2).replace('.', ',')}
                      </Typography>
                    </Box>
                    <IconButton size="small" onClick={() => removeService(svc.id)} sx={{ color: T?.textSecondary ?? '#bbb', p:0.3, flexShrink:0 }}>
                      <Close sx={{ fontSize:14 }} />
                    </IconButton>
                  </Box>
                ))}
                {/* Seletor único de profissional — respeita professional_ids do serviço */}
                {(() => {
                  // Profissionais elegíveis = interseção dos professional_ids dos serviços selecionados
                  // [] ou null em qualquer serviço = sem restrição para aquele serviço
                  const allowedPros: any[] = (() => {
                    let restrictedIds: number[] | null = null;
                    for (const svc of selected) {
                      const ids: number[] = (svc as any).professional_ids || [];
                      if (ids.length === 0) continue; // sem restrição nesse serviço
                      if (restrictedIds === null) { restrictedIds = [...ids]; }
                      else { restrictedIds = restrictedIds.filter((id: number) => ids.includes(id)); }
                    }
                    return restrictedIds === null
                      ? professionals
                      : professionals.filter((p: any) => (restrictedIds as number[]).includes(p.id));
                  })();
                  if (allowedPros.length <= 1) return null;
                  return (
                  <Box sx={{ px:{ xs:2, sm:3 }, pt:2, pb:2.5, borderTop:'1px solid #f0f0f0' }}>
                    <Typography fontSize={11} fontWeight={800} sx={{ color: T?.textSecondary ?? '#999', textTransform:'uppercase', letterSpacing:1, mb:1.5 }}>
                      Profissional
                    </Typography>
                    <Box sx={{ display:'flex', gap:1.5, overflowX:'auto', pb:0.5, '&::-webkit-scrollbar':{ height:3 }, '&::-webkit-scrollbar-thumb':{ bgcolor:'#ddd', borderRadius:2 } }}>
                      {/* Card "Qualquer" — só quando há mais de 1 profissional elegível */}
                      {allowedPros.length > 1 && (() => {
                        const isAny = !selPro;
                        return (
                          <Box onClick={() => handleProSelect(null)} sx={{
                            display:'flex', flexDirection:'column', alignItems:'center', gap:0.8,
                            px:1, py:1.5, borderRadius:3, cursor:'pointer', flexShrink:0,
                            border: isAny ? `2.5px solid ${accentColor}` : `2px solid ${T?.border ?? '#ebebeb'}`,
                            bgcolor: isAny ? `${accentColor}10` : (T?.surfaceAlt ?? '#fafafa'),
                            width:96, transition:'all 0.18s',
                            '&:hover': { borderColor: accentColor, bgcolor: `${accentColor}08` },
                          }}>
                            <Avatar sx={{ width:60, height:60, bgcolor: isAny ? accentColor : (T?.border ?? '#e0e0e0'), fontSize:24, boxShadow: isAny ? `0 0 0 3px ${accentColor}40` : 'none', transition:'box-shadow 0.18s' }}>
                              ✦
                            </Avatar>
                            <Typography fontSize={11} fontWeight={isAny ? 800 : 600} textAlign="center" lineHeight={1.2} sx={{ color: isAny ? accentColor : (T?.textPrimary ?? '#666'), width:'100%' }}>
                              Qualquer
                            </Typography>
                            {isAny && <Box sx={{ width:6, height:6, borderRadius:'50%', bgcolor:accentColor, mt:-0.3 }} />}
                          </Box>
                        );
                      })()}
                      {/* Cards dos profissionais — apenas os elegíveis para o serviço */}
                      {allowedPros.map((pro: any) => {
                        // Cards de profissional nunca desabilitados — sempre pode trocar de profissional
                        const isDisabled = false;
                        const isSel = selPro?.id === pro.id;
                        const nameParts = (pro.name || '').split(' ');
                        const displayName = nameParts.length >= 2
                          ? `${nameParts[0]} ${nameParts[1]}`
                          : nameParts[0];
                        return (
                          <Box key={pro.id} onClick={() => !isDisabled && handleProSelect(pro)} sx={{
                            display:'flex', flexDirection:'column', alignItems:'center', gap:0.8,
                            px:1, py:1.5, borderRadius:3, cursor: isDisabled ? 'not-allowed' : 'pointer', flexShrink:0,
                            border: isSel ? `2.5px solid ${accentColor}` : `2px solid ${T?.border ?? '#ebebeb'}`,
                            bgcolor: isSel ? `${accentColor}10` : (isDisabled ? (T?.surface ?? '#f5f5f5') : (T?.surfaceAlt ?? '#fafafa')),
                            opacity: isDisabled ? 0.45 : 1,
                            width:96, transition:'all 0.18s',
                            '&:hover': !isDisabled ? { borderColor: accentColor, bgcolor: `${accentColor}08` } : {},
                          }}>
                            <Avatar src={pro.photo_url} sx={{ width:60, height:60, fontSize:20, fontWeight:700, bgcolor:'#1a1a1a', boxShadow: isSel ? `0 0 0 3px ${accentColor}40` : 'none', transition:'box-shadow 0.18s' }}>
                              {pro.name?.[0]}
                            </Avatar>
                            <Typography fontSize={10.5} fontWeight={isSel ? 800 : 600} textAlign="center" lineHeight={1.15} sx={{ color: isSel ? accentColor : (T?.textPrimary ?? '#444'), width:'100%', wordBreak:'break-word', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden' }}>
                              {displayName}
                            </Typography>
                            {isSel && <Box sx={{ width:6, height:6, borderRadius:'50%', bgcolor:accentColor, mt:-0.3 }} />}
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                  );
                })()}
              </Box>

              {/* ===== BOTÃO CONTINUAR STICKY ===== */}
              <Box sx={{ p:2, pb: 'calc(16px + env(safe-area-inset-bottom, 0px))', position:'sticky', bottom:0, bgcolor: T?.bg ?? '#fff', borderTop: `1px solid ${T?.border ?? '#eee'}` }}>
                <Button fullWidth variant="contained" disabled={!canContinue}
                  onClick={() => { try { if ((window as any).fbq) { (window as any).fbq("track", "InitiateCheckout", { currency: "BRL", value: totalPrice, content_name: selected.map((s: any) => s.name).join(" + "), num_items: selected.length }); } } catch(_) {} setStep("data"); }}
                  sx={{ fontWeight:800, py:1.4, borderRadius:2.5,
                    bgcolor: selected.length > 0 ? accentColor : (T ? '#2a2a2a' : '#e2e8f0'),
                    color: selected.length > 0 ? '#fff' : (T ? '#aaaaaa' : '#94a3b8'),
                    '&:hover': { bgcolor: selected.length > 0 ? accentColor : (T ? '#333' : '#d1d5db'), filter: selected.length > 0 ? 'brightness(0.9)' : 'none' },
                    '&.Mui-disabled': { bgcolor: T ? '#2d2d2d' : '#e2e8f0', color: T ? '#888' : '#94a3b8', border: T ? '1px solid #444' : 'none', opacity: 1 },
                    textTransform:'none', fontSize:15,
                    boxShadow: selected.length > 0 ? `0 4px 14px ${accentColor}55` : 'none',
                    transition:'all 0.2s',
                  }}>
                  Continuar →
                </Button>
              </Box>
            </>
          )}

          {/* ===== STEP: SEUS DADOS ===== */}
          {step === 'data' && (
            <>
              {/* Header step 2/3 */}
              <Box sx={{ position:'sticky', top:0, bgcolor: T?.bg ?? '#fff', zIndex:10, borderBottom: `1px solid ${T?.border ?? '#f0f0f0'}` }}>
                <Box sx={{ px:{ xs:2, sm:3 }, pt:2, pb:1, display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                    <IconButton size="small" onClick={() => setStep('booking')} sx={{ color: T?.textSecondary ?? '#888', ml:-1 }}><ChevronLeft /></IconButton>
                    <Box>
                      <Typography fontSize={12} fontWeight={500} sx={{ color: accentColor }} mb={0.2}>
                        Agendar · 2 de 3
                      </Typography>
                      <Typography fontWeight={800} fontSize={16} sx={{ color: T?.textPrimary ?? '#1a1a1a' }} lineHeight={1.2}>Seus dados</Typography>
                    </Box>
                  </Box>
                  <IconButton size="small" onClick={() => setModalOpen(false)} sx={{ mt:-0.5, color: T?.textSecondary ?? '#888' }}><Close /></IconButton>
                </Box>
                <Box sx={{ display:'flex', gap:0.5, px:{ xs:2, sm:3 }, pb:1.5 }}>
                  {[1,2,3].map(i => (
                    <Box key={i} sx={{ flex:1, height:3, borderRadius:2, bgcolor: i <= 2 ? accentColor : (T?.border ?? '#e0e0e0'), transition:'background 0.3s' }} />
                  ))}
                </Box>
              </Box>

              <Box sx={{ px:{ xs:2.5, sm:4 }, py:2.5, display:'flex', flexDirection:'column', gap:2 }}>
                {!custUser ? (
                  <DataTabsInner
                    name={name} setName={setName}
                    phone={phone} setPhone={setPhone}
                    phone2={phone2} setPhone2={setPhone2}
                    notes={bookingNotes} setNotes={setBookingNotes}
                    accentColor={accentColor}
                    requirePhoneConfirm={company?.settings?.require_phone_confirm === true}
                    showNotes={company?.settings?.show_booking_notes !== false}
                    showTermsCheck={company?.settings?.show_terms_checkbox === true}
                    termsAccepted={termsAccepted}
                    setTermsAccepted={setTermsAccepted}
                    termsText={company?.settings?.terms_text}
                    onOpenTerms={() => { setTermsText(company?.settings?.terms_text || getAutoTerms(company?.name || '')); setTermsOpen(true); }}
                    onLoginClick={() => { setLoginMode('login'); setLoginOpen(true); }}
                    onRegisterClick={() => { setLoginMode('register'); setLoginOpen(true); }}
                    collectEmail={company?.settings?.collect_email === true}
                    email={customerEmail} setEmail={setCustomerEmail}
                    isDark={isDark} T={T}
                  />
                ) : (
                  <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', px:0.5, py:0.5 }}>
                    <Typography fontSize={13} fontWeight={600} sx={{ color: T?.textSecondary ?? '#475569' }}>
                      Olá, {custUser.name?.split(' ')[0]}
                    </Typography>
                    <Box component="button" onClick={() => { clearCustomer(); setCustUser(null); }}
                      sx={{ display:'flex', alignItems:'center', gap:0.4, background:'none', border: `1px solid ${T?.border ?? '#e5e7eb'}`, cursor:'pointer', color: T?.textSecondary ?? '#9ca3af', px:1, py:0.5, borderRadius:1.5, '&:hover': { color:'#ef4444', borderColor:'#fecaca', bgcolor:'#fef2f2' }, transition:'all 0.15s' }}>
                      <LogoutOutlined sx={{ fontSize:13 }} />
                      <Typography fontSize={11} fontWeight={600} color="inherit">Sair</Typography>
                    </Box>
                  </Box>
                )}

                {/* Informações para o atendimento — aparece para logado e não logado
                    (fora do ternário acima de propósito: DataTabsInner só renderiza
                    para quem não está logado, e a ficha precisa valer pros dois). */}
                {(() => {
                  const intakeQuestionsList = Array.isArray(company?.settings?.intake_form_questions) ? company.settings.intake_form_questions : [];
                  if (company?.settings?.intake_form_enabled !== true || intakeQuestionsList.length === 0) return null;
                  const answered = !!intakeSavedAnswers;
                  return (
                    <Box sx={{ borderRadius: 2, border: `1px solid ${T?.border ?? '#e5e7eb'}`, p: 1.5, bgcolor: T ? 'rgba(255,255,255,0.03)' : '#f8fafc' }}>
                      {!answered ? (
                        <>
                          <Typography fontSize={13} fontWeight={700} sx={{ color: T?.textPrimary ?? '#0f172a' }}>Informações para o atendimento</Typography>
                          <Typography fontSize={12} sx={{ color: T?.textSecondary ?? '#64748b', mt: 0.3, mb: 1 }}>Responda algumas perguntas rápidas antes de continuar.</Typography>
                          <Button size="small" variant="outlined"
                            onClick={() => { setIntakeDraftAnswers({}); setIntakeModalOpen(true); }}
                            sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 1.5, borderColor: accentColor, color: accentColor }}>
                            Responder perguntas
                          </Button>
                        </>
                      ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7 }}>
                            <CheckCircle sx={{ fontSize: 16, color: '#16A34A' }} />
                            <Typography fontSize={13} fontWeight={700} sx={{ color: T?.textPrimary ?? '#0f172a' }}>Informações respondidas</Typography>
                          </Box>
                          <Button size="small"
                            onClick={() => {
                              setIntakeDraftAnswers(Object.fromEntries((intakeSavedAnswers || []).map((a: any) => [a.question_id, a.answer])));
                              setIntakeModalOpen(true);
                            }}
                            sx={{ textTransform: 'none', fontWeight: 700, fontSize: 12.5, color: accentColor }}>
                            Editar respostas
                          </Button>
                        </Box>
                      )}
                    </Box>
                  );
                })()}

                <Button fullWidth variant="contained"
                  disabled={!custUser && (!name.trim() || phone.replace(/\D/g,'').length < 10 || (company?.settings?.require_phone_confirm === true && phone !== phone2 && !!phone2) || (company?.settings?.show_terms_checkbox === true && !termsAccepted) || (company?.settings?.collect_email === true && (!customerEmail.trim() || !customerEmail.includes('@')))) ||
                    (company?.settings?.intake_form_enabled === true && company?.settings?.intake_form_required === true && Array.isArray(company?.settings?.intake_form_questions) && company.settings.intake_form_questions.length > 0 && !intakeSavedAnswers)}
                  onClick={() => { setStep('confirm'); if (company?.settings?.mp_public_key && !(window as any).MercadoPago) { const s = document.createElement('script'); s.src = 'https://sdk.mercadopago.com/js/v2'; document.head.appendChild(s); } }}
                  sx={{ fontWeight:700, py:1.5, borderRadius:1.5, bgcolor: accentColor, '&:hover': { filter:'brightness(0.9)' }, textTransform:'none', fontSize:15, color:'#fff', mt:1,
                    '&.Mui-disabled': { bgcolor: T ? '#2d2d2d' : '#e2e8f0', color: T ? '#888' : '#94a3b8', border: T ? '1px solid #444' : 'none', opacity: 1 } }}>
                  Revisar agendamento →
                </Button>
              </Box>
            </>
          )}

          {step === 'confirm' && (
            <>
              {/* Header step 3/3 clean */}
              <Box sx={{ position:'sticky', top:0, bgcolor: T?.bg ?? '#fff', zIndex:10, borderBottom: `1px solid ${T?.border ?? '#f0f0f0'}` }}>
                <Box sx={{ px:{ xs:2, sm:3 }, pt:2, pb:1, display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                    <IconButton size="small" onClick={() => setStep(custUser ? 'booking' : 'data')} sx={{ color: T?.textSecondary ?? '#888', ml:-1 }}><ChevronLeft /></IconButton>
                    <Box>
                      <Typography fontSize={12} fontWeight={500} sx={{ color: accentColor }} mb={0.2}>Agendar · 3 de 3</Typography>
                      <Typography fontWeight={800} fontSize={16} sx={{ color: T?.textPrimary ?? '#1a1a1a' }} lineHeight={1.2}>Confirmar</Typography>
                    </Box>
                  </Box>
                  <IconButton size="small" onClick={() => setModalOpen(false)} sx={{ mt:-0.5, color: T?.textSecondary ?? '#888' }}><Close /></IconButton>
                </Box>
                <Box sx={{ display:'flex', gap:0.5, px:{ xs:2, sm:3 }, pb:1.5 }}>
                  {[1,2,3].map(i => (
                    <Box key={i} sx={{ flex:1, height:3, borderRadius:2, bgcolor: accentColor, transition:'background 0.3s' }} />
                  ))}
                </Box>
              </Box>

              <Box sx={{ px:{ xs:2.5, sm:4 }, py:2, display:'flex', flexDirection:'column', gap:2 }}>
                {packageBookingSubscription && (
                  <Alert severity={packageBookingSubscription.status === 'pending_local_payment' ? 'warning' : 'info'} sx={{ borderRadius:2 }}>
                    {packageBookingSubscription.status === 'pending_local_payment'
                      ? 'Este agendamento vai usar o seu pacote reservado. O pagamento do pacote continua pendente no estabelecimento — seu horário fica garantido desde já.'
                      : 'Este agendamento vai usar saldo do seu pacote. Escolha os itens desta visita e a duração será somada automaticamente.'}
                  </Alert>
                )}

                {/* Summary card dark gradient */}
                {(() => {
                  const serviceTotalRaw = selected.reduce((acc: number, s: any) => acc + Number(s.price), 0);
                  const bumpTotal = selectedBumps.reduce((acc: number, b: any) => acc + Number(b.price), 0);
                  // Fase 1: se cliente veio pelo fluxo "Agendar com saldo", os serviços selecionados
                  // já estão cobertos pelo pacote (o picker só listou itens com saldo > 0).
                  // Pagamento só se aplica a order_bumps (extras não cobertos).
                  const usingPackage = !!packageBookingSubscription;
                  const serviceTotal = usingPackage ? 0 : serviceTotalRaw;
                  const totalPrice = serviceTotal + bumpTotal;
                  const payRequired = company?.settings?.payment_required;
                  const mpPublicKey = company?.settings?.mp_public_key;
                  // hasPayment só fica true se ainda há valor real a cobrar (não apenas configuração da conta)
                  const hasPayment = !!(payRequired && mpPublicKey && totalPrice > 0);
                  let calcPay = totalPrice;
                  if (hasPayment && company?.settings?.payment_partial) {
                    if (company.settings.payment_partial_type === 'fixed') calcPay = Math.min(Number(company.settings.payment_partial_fixed || 0), totalPrice);
                    else calcPay = +(totalPrice * (company.settings.payment_partial_pct || 30) / 100).toFixed(2);
                  }
                  // Piloto de Crédito — estimativa client-side (F8: só sessão forte).
                  // Abate o valor a cobrar AGORA diretamente (real por real), nunca uma
                  // nova % sobre um total já reduzido — mesma regra do servidor, que
                  // sempre recalcula tudo de novo a partir do saldo real no banco.
                  const creditEnabledPublic = company?.credit_feature_enabled === true && custUser?.auth_strength === 'strong';
                  const creditAvailable = creditEnabledPublic ? Number(custUser?.credit_balance || 0) : 0;
                  const creditWillApply = creditEnabledPublic && creditAvailable > 0 && useCreditBalance && totalPrice > 0;
                  const creditAppliedEstimate = creditWillApply ? Math.min(creditAvailable, totalPrice) : 0;
                  if (creditAppliedEstimate > 0) {
                    calcPay = Math.max(0, +(calcPay - creditAppliedEstimate).toFixed(2));
                  }
                  // Pagar no local: não há cobrança antecipada — o sinal/restante de Pix/Cartão não se aplica
                  const isCashSelected = !!(company?.settings?.mp_cash_enabled && payMethodSel === 'cash');
                  const isPartial = hasPayment && !isCashSelected && company?.settings?.payment_partial && calcPay < totalPrice;
                  const pixEnabled = company?.settings?.mp_pix_enabled !== false;
                  const cardEnabled = company?.settings?.mp_card_enabled !== false;
                  const pixDiscount = company?.settings?.mp_pix_discount || 0;
                  const pixFinal = pixDiscount > 0 ? +(calcPay * (1 - pixDiscount/100)).toFixed(2) : calcPay;
                  const displayPay = payMethodSel === 'pix' ? pixFinal : calcPay;
                  const showOnlinePayment = hasPayment && !isCashSelected;
                  return (
                    <>
                      <Box sx={{ background:'linear-gradient(160deg, #0f172a 0%, #1e293b 100%)', borderRadius:'18px', p:2.5, position:'relative', overflow:'hidden', boxShadow:'0 4px 24px rgba(0,0,0,0.15)', '&::before': { content:'""', position:'absolute', inset:0, background:`radial-gradient(ellipse 60% 60% at 100% 0%, ${accentColor}40, transparent 60%)` } }}>
                        <Box sx={{ position:'relative' }}>
                          <Typography sx={{ fontSize:11, letterSpacing:'0.15em', textTransform:'uppercase', color:'#94a3b8', mb:1 }}>SUA RESERVA</Typography>
                          <Typography sx={{ fontSize:16, fontWeight:700, color:'white', mb:0.5, lineHeight:1.35 }}>{selected.map((s: any) => s.name).join(' · ')}</Typography>
                          <Typography sx={{ fontSize:13, color:'#cbd5e1', mb:2 }}>{selDate && format(selDate, "EEE, d 'de' MMM", { locale: ptBR })} · {selTime}{selPro ? ` · com ${selPro.name.split(' ')[0]}` : ''}</Typography>
                          <Box sx={{ height:'1px', bgcolor:'rgba(255,255,255,0.1)', mb:1.5 }} />
                          <Box sx={{ display:'flex', justifyContent:'space-between', py:0.4 }}>
                            <Typography sx={{ fontSize:13, color:'#94a3b8' }}>Serviços ({selected.length})</Typography>
                            <Typography sx={{ fontSize:13, color:'white' }}>R$ {(usingPackage ? serviceTotalRaw : serviceTotal).toFixed(2).replace('.', ',')}</Typography>
                          </Box>
                          {usingPackage && serviceTotalRaw > 0 && (
                            <Box sx={{ display:'flex', justifyContent:'space-between', py:0.4 }}>
                              <Typography sx={{ fontSize:13, color:'#94a3b8' }}>★ Coberto pelo pacote</Typography>
                              <Typography sx={{ fontSize:13, color:'#a5b4fc', fontWeight:700 }}>-R$ {serviceTotalRaw.toFixed(2).replace('.', ',')}</Typography>
                            </Box>
                          )}
                          {creditEnabledPublic && creditAvailable > 0 && totalPrice > 0 && (
                            <>
                              <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', py:0.6 }}>
                                <Box sx={{ display:'flex', alignItems:'center', gap:0.8 }}>
                                  <Checkbox size="small" checked={useCreditBalance}
                                    onChange={e => setUseCreditBalance(e.target.checked)}
                                    sx={{ color:'#86efac', p:0.3, '&.Mui-checked': { color:'#4ade80' } }} />
                                  <Typography sx={{ fontSize:13, color:'#e2e8f0', fontWeight:600 }}>
                                    Usar meu crédito (R$ {creditAvailable.toFixed(2).replace('.', ',')} disponível)
                                  </Typography>
                                </Box>
                              </Box>
                              {creditAppliedEstimate > 0 && (
                                <Box sx={{ display:'flex', justifyContent:'space-between', py:0.4 }}>
                                  <Typography sx={{ fontSize:13, color:'#94a3b8' }}>★ Coberto por crédito</Typography>
                                  <Typography sx={{ fontSize:13, color:'#4ade80', fontWeight:700 }}>-R$ {creditAppliedEstimate.toFixed(2).replace('.', ',')}</Typography>
                                </Box>
                              )}
                            </>
                          )}
                          {/* Removido (21/09/2026) — o convite genérico de login para
                              "consultar e usar crédito" aparecia pra QUALQUER visitante
                              de QUALQUER empresa depois que o crédito saiu do piloto e
                              virou global (antes só afetava a empresa 7). Sem forma segura
                              de saber se vale a pena convidar sem consultar o telefone
                              digitado (proibido — vazaria/permitiria uso indevido de saldo
                              de outra pessoa), a opção adotada foi remover o convite: quem
                              já sabe que tem conta usa "Já tenho conta"/Google normalmente;
                              a caixa de usar crédito (acima) continua aparecendo sozinha
                              pra quem já chega autenticado com sessão forte e saldo > 0. */}
                          {isPartial && (<>
                            <Box sx={{ display:'flex', justifyContent:'space-between', py:0.4 }}>
                              <Typography sx={{ fontSize:13, color:'#94a3b8' }}>Sinal {payMethodSel === 'pix' && pixDiscount > 0 ? `(Pix -${pixDiscount}%)` : (paymentSelectorB && payMethodSel === 'card' ? '(Cartão)' : '(Pix)')}</Typography>
                              <Typography sx={{ fontSize:13, color:'#4ade80' }}>R$ {displayPay.toFixed(2).replace('.', ',')}</Typography>
                            </Box>
                            <Box sx={{ display:'flex', justifyContent:'space-between', py:0.4 }}>
                              <Typography sx={{ fontSize:13, color:'#94a3b8' }}>No estabelecimento</Typography>
                              <Typography sx={{ fontSize:13, color:'white' }}>R$ {(totalPrice - calcPay).toFixed(2).replace('.', ',')}</Typography>
                            </Box>
                          </>)}
                          {selectedBumps.length > 0 && (
                            <Box sx={{ mt:1.1, display:'flex', flexDirection:'column', gap:0.8 }}>
                              {selectedBumps.map((b: any, i: number) => {
                                const originalPrice = Number(b.original_price || 0);
                                const currentPrice = Number(b.price || 0);
                                const hasDiscount = originalPrice > currentPrice;
                                const savings = hasDiscount ? originalPrice - currentPrice : 0;

                                return (
                                  <Box key={`sum-bump-${i}`} sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:1.2 }}>
                                    <Box sx={{ flex:1, minWidth:0 }}>
                                      <Typography sx={{ fontSize:11.5, fontWeight:700, color:'rgba(255,255,255,0.92)' }} noWrap>
                                        + {b.name}
                                      </Typography>
                                      {hasDiscount ? (
                                        <Box sx={{ mt:0.28, display:'inline-flex', alignItems:'center', px:0.8, py:0.28, bgcolor:'#dcfce7', borderRadius:1 }}>
                                          <Typography sx={{ fontSize:9.5, fontWeight:800, color:'#16a34a', lineHeight:1 }}>
                                            Economia R$ {savings.toFixed(2).replace('.', ',')}
                                          </Typography>
                                        </Box>
                                      ) : null}
                                    </Box>
                                    <Typography sx={{ fontSize:11.5, fontWeight:800, color: hasDiscount ? accentColor : 'white', flexShrink:0 }}>
                                      R$ {currentPrice.toFixed(2).replace('.', ',')}
                                    </Typography>
                                  </Box>
                                );
                              })}
                            </Box>
                          )}
                          <Box sx={{ height:'1px', bgcolor:'rgba(255,255,255,0.1)', mt:1.5, mb:1 }} />
                          <Box sx={{ display:'flex', justifyContent:'space-between', pt:0.5 }}>
                            <Typography sx={{ fontSize:17, fontWeight:700, color:'white' }}>{showOnlinePayment ? 'Pagar agora' : 'Total'}</Typography>
                            <Typography sx={{ fontSize:17, fontWeight:700, color: (() => {
                              try {
                                const h = (accentColor || '').replace('#','');
                                if (h.length < 6) return 'rgba(255,255,255,0.95)';
                                const r=parseInt(h.slice(0,2),16),g=parseInt(h.slice(2,4),16),b=parseInt(h.slice(4,6),16);
                                return (0.299*r+0.587*g+0.114*b)/255 > 0.35 ? accentColor : 'rgba(255,255,255,0.95)';
                              } catch { return 'rgba(255,255,255,0.95)'; }
                            })() }}>R$ {showOnlinePayment ? displayPay.toFixed(2).replace('.', ',') : calcPay.toFixed(2).replace('.', ',')}</Typography>
                          </Box>
                        </Box>
                      </Box>

                      {/* Seletor de forma de pagamento — piloto (lista compacta + selo Recomendado) */}
                      {paymentSelectorB && hasPayment && (pixEnabled || cardEnabled) && (
                        <PaymentMethodSelector
                          value={payMethodSel}
                          onChange={(m: any) => {
                            if (m === 'pix' && bricksControllerRef.current) { try { bricksControllerRef.current.unmount(); } catch(_){} bricksControllerRef.current = null; }
                            if (m === 'card') { bricksInitRef.current = false; setBricksReady(false); }
                            setPayMethodSel(m);
                          }}
                          pixEnabled={pixEnabled}
                          cardEnabled={cardEnabled}
                          cashEnabled={!!company?.settings?.mp_cash_enabled}
                          pixDiscount={pixDiscount}
                          accentColor={accentColor}
                          T={T}
                          isPartial={!!isPartial}
                          total={totalPrice}
                          payNow={displayPay}
                          disabled={submitting}
                        />
                      )}
                      {/* Seletor de forma de pagamento */}
                      {!paymentSelectorB && hasPayment && (pixEnabled || cardEnabled) && (
                        <Box>
                          <Typography fontWeight={700} fontSize={14} sx={{ color: T?.textPrimary ?? '#1a1a1a' }} mb={1.2}>Como voce quer pagar{isPartial ? ' o sinal' : ''}?</Typography>
                          <Box sx={{ display:'flex', flexDirection:'column', gap:1 }}>
                            {pixEnabled && (
                              <Box onClick={() => { setPayMethodSel('pix'); if (bricksControllerRef.current) { try { bricksControllerRef.current.unmount(); } catch(_){} bricksControllerRef.current = null; } }} sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.5, borderRadius:2.5, border: payMethodSel === 'pix' ? `2px solid ${accentColor}` : `2px solid ${T?.border ?? '#e5e7eb'}`, bgcolor: payMethodSel === 'pix' ? `${accentColor}10` : (T?.surfaceAlt ?? '#fafafa'), cursor:'pointer', transition:'all 0.15s' }}>
                                <Box sx={{ width:40, height:40, borderRadius:2, bgcolor: payMethodSel === 'pix' ? '#e6faf8' : (T?.surface ?? '#f0f0f0'), display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, overflow:'hidden' }}>
                                  <Box component="img" src="/pix-logo.svg" alt="PIX" sx={{ width:26, height:26, objectFit:'contain', filter: payMethodSel === 'pix' ? 'none' : 'grayscale(0.5) opacity(0.6)' }} />
                                </Box>
                                <Box sx={{ flex:1 }}>
                                  <Box sx={{ display:'flex', alignItems:'center', gap:0.8 }}>
                                    <Typography fontWeight={700} fontSize={14} sx={{ color: T?.textPrimary ?? '#1a1a1a' }}>Pix · instantâneo</Typography>
                                    <Box sx={{ px:0.7, py:0.15, bgcolor: T ? '#14532d' : '#dcfce7', borderRadius:1 }}>
                                      <Typography fontSize={9} fontWeight={800} sx={{ color: T ? '#86efac' : '#16a34a', letterSpacing:0.3 }}>RECOMENDADO</Typography>
                                    </Box>
                                  </Box>
                                  <Typography fontSize={12} sx={{ color: T?.textSecondary ?? '#6b7280' }}>{pixDiscount > 0 ? `${pixDiscount}% de desconto · aprovação imediata` : 'Aprovação imediata · sem taxa'}</Typography>
                                </Box>
                                <Box sx={{ width:20, height:20, borderRadius:'50%', border: payMethodSel === 'pix' ? `6px solid ${accentColor}` : `2px solid ${T?.border ?? '#d1d5db'}`, flexShrink:0 }} />
                              </Box>
                            )}
                            {cardEnabled && (
                              <Box onClick={() => { setPayMethodSel('card'); bricksInitRef.current = false; setBricksReady(false); }} sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.5, borderRadius:2.5, border: payMethodSel === 'card' ? `2px solid ${accentColor}` : `2px solid ${T?.border ?? '#e5e7eb'}`, bgcolor: payMethodSel === 'card' ? `${accentColor}10` : (T?.surfaceAlt ?? '#fafafa'), cursor:'pointer', transition:'all 0.15s' }}>
                                <Box sx={{ width:40, height:40, borderRadius:2, bgcolor: payMethodSel === 'card' ? `${accentColor}15` : (T?.surface ?? '#f0f0f0'), display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, overflow:'hidden' }}>
                                  <Box component="img" src="/card-icon.svg" alt="Cartão" sx={{ width:28, height:28, objectFit:'contain', filter: payMethodSel === 'card' ? 'none' : 'grayscale(0.5) opacity(0.6)' }} />
                                </Box>
                                <Box sx={{ flex:1 }}>
                                  <Typography fontWeight={700} fontSize={14} sx={{ color: T?.textPrimary ?? '#1a1a1a' }}>Cartão de crédito</Typography>
                                  <Typography fontSize={12} sx={{ color: T?.textSecondary ?? '#6b7280' }}>Visa, Mastercard, Elo · parcele em até {company?.settings?.mp_max_installments || 12}x</Typography>
                                </Box>
                                <Box sx={{ width:20, height:20, borderRadius:'50%', border: payMethodSel === 'card' ? `6px solid ${accentColor}` : `2px solid ${T?.border ?? '#d1d5db'}`, flexShrink:0 }} />
                              </Box>
                            )}
                          </Box>

                          {/* Pagar no local — só aparece se mp_cash_enabled */}
                          {company?.settings?.mp_cash_enabled && (
                            <Box onClick={() => setPayMethodSel('cash')} sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.5, borderRadius:2.5,
                              border: payMethodSel === 'cash' ? `2px solid ${accentColor}` : `2px solid ${T?.border ?? '#e5e7eb'}`,
                              bgcolor: payMethodSel === 'cash' ? `${accentColor}10` : (T?.surfaceAlt ?? '#fafafa'),
                              cursor:'pointer', transition:'all 0.15s' }}>
                              <Box sx={{ width:40, height:40, borderRadius:2, bgcolor: payMethodSel === 'cash' ? '#f0fdf4' : (T?.surface ?? '#f0f0f0'),
                                display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                                <Typography fontSize={22}>🏪</Typography>
                              </Box>
                              <Box sx={{ flex:1 }}>
                                <Typography fontWeight={700} fontSize={14} sx={{ color: T?.textPrimary ?? '#1a1a1a' }}>Pagar no local</Typography>
                                <Typography fontSize={12} sx={{ color: T?.textSecondary ?? '#6b7280' }}>O estabelecimento recebe o valor no atendimento</Typography>
                              </Box>
                              <Box sx={{ width:20, height:20, borderRadius:'50%',
                                border: payMethodSel === 'cash' ? `6px solid ${accentColor}` : `2px solid ${T?.border ?? '#d1d5db'}`,
                                flexShrink:0 }} />
                            </Box>
                          )}
                        </Box>
                      )}


                      {/* ── Order Bumps: "Aproveite também" ──────────── */}
                      {(() => {
                        // Coleta bumps de todos os serviços selecionados
                        const rawBumps = selected.flatMap((s: any) => (s.order_bumps || []).map((b: any) => ({ ...b, _fromService: s.id })));
                        // Deduplica por type+id
                        const seen = new Set<string>();
                        const uniqueBumps = rawBumps.filter((b: any) => {
                          const k = b.type === 'manual' ? `${b.type}-${b.id || b.name}` : `${b.type}-${b.id}`; if (seen.has(k)) return false; seen.add(k); return true;
                        });
                        // Resolve objetos reais da empresa (nome, preço do catálogo)
                        const resolvedBumps = uniqueBumps.slice(0, 3).map((b: any) => {
                          if (b.type === 'service') {
                            const svc = company?.services?.find((s: any) => s.id === b.id);
                            return svc ? { ...svc, _bumpType: 'service' } : null;
                          } else if (b.type === 'product') {
                            const prd = company?.products?.find((p: any) => p.id === b.id);
                            return prd ? { ...prd, _bumpType: 'product' } : null;
                          } else if (b.type === 'bump_item') {
                            const bi = (company as any)?.order_bump_items?.find((x: any) => x.id === b.id);
                            return bi ? { ...bi, _bumpType: 'bump_item' } : null;
                          } else if (b.type === 'manual') {
                            return { ...b, _bumpType: 'manual' };
                          }
                          return null;
                        }).filter(Boolean);

                        if (!resolvedBumps.length) return null;
                        return (
                          <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:2.5, border: `1.5px solid ${T?.border ?? '#f0f0f0'}`, overflow:'hidden' }}>
                            <Box sx={{ px:2, py:1.4, borderBottom: `1px solid ${T?.border ?? '#f5f5f5'}` }}>
                              <Typography sx={{ fontWeight: 900, fontSize: { xs: 19, sm: 21 }, lineHeight: 1.1, color: T?.textPrimary ?? "#111827" }}>Aproveite também</Typography>
                              <Typography sx={{ fontSize: { xs: 10, sm: 11 }, lineHeight: 1.2, color: T?.textSecondary ?? "#64748b" }}>Itens recomendados para seu atendimento</Typography>
                            </Box>
                            {resolvedBumps.map((bump: any) => {
                              const isBumpSel = bump._bumpType === 'manual' ? selectedBumps.some((b: any) => b._bumpType === 'manual' && b.name === bump.name) : selectedBumps.some((b: any) => b._bumpType === bump._bumpType && b.id === bump.id);
                              return (
                                <Box key={bump._bumpType === 'manual' ? 'manual-' + bump.name : `${bump._bumpType}-${bump.id}`}
                                  onClick={() => setSelectedBumps(prev => {
                                    if (isBumpSel) {
                                      return bump._bumpType === 'manual'
                                        ? prev.filter((b: any) => !(b._bumpType === 'manual' && b.name === bump.name))
                                        : prev.filter((b: any) => !(b._bumpType === bump._bumpType && b.id === bump.id));
                                    }
                                    return [...prev, bump];
                                  })}
                                  sx={{ display:'flex', alignItems:'stretch', gap:2, px:2.6, py:1.9, cursor:'pointer', borderBottom: `1px solid ${T?.border ?? '#eef2f7'}`,
                                    bgcolor: isBumpSel ? `${accentColor}08` : (T?.bg ?? '#fff'),
                                    '&:hover': { bgcolor: isBumpSel ? `${accentColor}12` : (T?.surfaceAlt ?? '#fafafa') }, transition:'background 0.12s' }}>
                                  {bump.image_url && (
                                    <Box sx={{ width:74, height:74, borderRadius:3, overflow:'hidden', bgcolor: T?.surfaceAlt ?? '#f8fafc', border: `1px solid ${T?.border ?? '#e2e8f0'}`, flexShrink:0 }}>
                                      <img src={bump.image_url_md || bump.image_url} alt={bump.name} loading="lazy" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                                    </Box>
                                  )}
                                  <Box sx={{ flex:1, minWidth:0, display:'flex', flexDirection:'column', justifyContent:'center' }}>
                                    <Typography fontSize={16} fontWeight={800} sx={{ color: isBumpSel ? accentColor : (T?.textPrimary ?? '#111827'), lineHeight:1.14, display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden' }}>{bump.name}</Typography>
                                    {bump.description && <Typography fontSize={8} sx={{ color: T?.textSecondary ?? '#64748b', mt:0.06, lineHeight:1.05 }} noWrap>{bump.description}</Typography>}
                                    <Box sx={{ mt:1.05, display:'flex', alignItems:'baseline', gap:1.1, flexWrap:'wrap' }}>
                                      {bump.original_price && Number(bump.original_price) > Number(bump.price) && (
                                        <Typography fontSize={15} fontWeight={900} sx={{ color:'#94a3b8', textDecoration:'line-through', textDecorationThickness:'2px', lineHeight:1, opacity:1 }}>
                                          R$ {Number(bump.original_price).toFixed(2).replace('.', ',')}
                                        </Typography>
                                      )}
                                      <Typography fontSize={21} fontWeight={900} sx={{ color: accentColor, lineHeight:1, letterSpacing:'0', textShadow:'0.2px 0 0 currentColor' }}>
                                        R$ {Number(bump.price).toFixed(2).replace('.', ',')}
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Box sx={{ width:32, height:32, alignSelf:'center', borderRadius:'50%', border:`2px solid ${isBumpSel ? accentColor : (T?.border ?? '#cbd5e1')}`,
                                    bgcolor: isBumpSel ? accentColor : (T?.surface ?? '#fff'), display:'flex', alignItems:'center', justifyContent:'center',
                                    flexShrink:0, transition:'all 0.12s', boxShadow: isBumpSel ? `0 6px 14px ${accentColor}33` : 'none' }}>
                                    <Typography fontSize={13} fontWeight={800} sx={{ color: isBumpSel ? '#fff' : accentColor, lineHeight:1, display:'flex', alignItems:'center', justifyContent:'center', width:'100%', height:'100%' }}>
                                      {isBumpSel ? '✓' : '+'}
                                    </Typography>
                                  </Box>
                                </Box>
                              );
                            })}
                          </Box>
                        );
                      })()}

                      <Button fullWidth variant="contained"
                        onClick={() => { if (isPreview && pilotUI) { setTestConfirmOpen(true); } else { handleSubmit(); } }}
                        disabled={submitting}
                        sx={{ fontWeight:800, py:1.6, borderRadius:2.5, bgcolor:'#16a34a', '&:hover': { bgcolor:'#15803d' }, textTransform:'none', fontSize:15, letterSpacing:0.3, boxShadow:'0 4px 16px rgba(22,163,74,0.35)' }}>
                        {submitting ? (
                          <Box sx={{ display:'flex', alignItems:'center', justifyContent:'center', gap:1 }}>
                            <CircularProgress size={18} color="inherit" />
                            <span>{paymentSelectorB ? (isCashSelected ? 'Confirmando reserva...' : showOnlinePayment ? 'Preparando pagamento...' : 'Confirmando horário...') : 'Confirmando horário...'}</span>
                          </Box>
                        ) : paymentSelectorB && isCashSelected ? 'Confirmar reserva e pagar no local'
                          : paymentSelectorB && showOnlinePayment ? `Ir para o pagamento · R$ ${displayPay.toFixed(2).replace('.', ',')}`
                          : isCashSelected ? 'Reservar e pagar no estabelecimento' : showOnlinePayment ? `Pagar R$ ${displayPay.toFixed(2).replace('.', ',')} e confirmar` : 'Confirmar agendamento'}
                      </Button>
                      {submitting && (
                        <Typography fontSize={12} color="text.secondary" textAlign="center" mt={1}>
                          Aguarde alguns segundos. Não feche esta tela.
                        </Typography>
                      )}
                    </>
                  );
                })()}
              </Box>
            </>
          )}

          {step === 'payment' && (
            <>
              {/* Header pagamento */}
              <Box sx={{ position:'sticky', top:0, bgcolor: T?.bg ?? '#fff', zIndex:10, borderBottom: `1px solid ${T?.border ?? '#f0f0f0'}` }}>
                <Box sx={{ px:{ xs:2, sm:3 }, pt:2, pb:1, display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                    <IconButton size="small" onClick={async () => {
                      if (bricksControllerRef.current) { try { await bricksControllerRef.current.unmount(); } catch(_){} bricksControllerRef.current = null; }
                      if (countdownRef.current) clearInterval(countdownRef.current);
                      if (pixPollingRef.interval) { clearInterval(pixPollingRef.interval); pixPollingRef.interval = null; }
                      setPixData(null);
                      if (pendingBookingId) { axios.delete(`${API}/public/${slug}/bookings/${pendingBookingId}`, { data: { token: pendingBookingToken } }).catch(() => {}); }
                      bricksInitRef.current = false;
                      setStep('confirm');
                    }} sx={{ color: T?.textSecondary ?? '#888', ml:-1 }}><ChevronLeft /></IconButton>
                    <Box>
                      <Typography fontSize={12} fontWeight={500} sx={{ color: accentColor }} mb={0.2}>Pagamento</Typography>
                      <Typography fontWeight={800} fontSize={16} sx={{ color: T?.textPrimary ?? '#1a1a1a' }} lineHeight={1.2}>Finalizar agendamento</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ px:1.5, py:0.5, bgcolor: payCountdown < 120 ? (T ? 'rgba(239,68,68,0.35)' : '#fee2e2') : (T ? 'rgba(22,163,74,0.3)' : '#f0fdf4'), borderRadius:2, border: T ? `1px solid ${payCountdown < 120 ? 'rgba(239,68,68,0.6)' : 'rgba(22,163,74,0.55)'}` : 'none', display:'flex', alignItems:'center', gap:0.5 }}>
                    <AccessTime sx={{ fontSize:13, color: payCountdown < 120 ? (T ? '#ffffff' : '#dc2626') : (T ? '#ffffff' : '#16a34a') }} />
                    <Typography fontSize={12} fontWeight={700} sx={{ color: payCountdown < 120 ? (T ? '#ffffff' : '#dc2626') : (T ? '#ffffff' : '#16a34a'), lineHeight:1 }}>
                      {String(Math.floor(payCountdown / 60)).padStart(2,'0')}:{String(payCountdown % 60).padStart(2,'0')}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ mx:2, mb:1.5, height:4, bgcolor: T?.border ?? '#f0f0f0', borderRadius:2, overflow:'hidden' }}>
                  <Box sx={{ height:'100%', bgcolor: payCountdown < 120 ? '#ef4444' : accentColor, borderRadius:2, width:`${(payCountdown/payTotalSeconds)*100}%`, transition:'width 1s linear' }} />
                </Box>
              </Box>

              <Box sx={{ px:{ xs:2.5, sm:4 }, py:2.5, display:'flex', flexDirection:'column', gap:2, bgcolor: T?.bg ?? '#fff' }}>
                {/* Heading limpo */}
                <Box sx={{ textAlign:'center' }}>
                  <Typography fontSize={22} fontWeight={900} sx={{ color: T?.textPrimary ?? '#0f172a' }} lineHeight={1.2} mb={0.5}>
                    Finalize seu pagamento
                  </Typography>
                  <Typography fontSize={13} sx={{ color: T?.textSecondary ?? '#64748b' }}>Seu horário está reservado. Confirme para garantir.</Typography>
                </Box>

                {/* Resumo compacto */}
                <Box sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.5, bgcolor: T?.surfaceAlt ?? '#f8fafc', borderRadius:2.5, border: `1px solid ${T?.border ?? '#e2e8f0'}` }}>
                  {company?.logo_url
                    ? <Avatar src={company.logo_url} sx={{ width:40, height:40, borderRadius:1.5 }} />
                    : <Box sx={{ width:40, height:40, borderRadius:1.5, bgcolor:accentColor, display:'flex', alignItems:'center', justifyContent:'center' }}><Typography fontWeight={900} fontSize={16} color="#fff">{(company?.name||'B')[0]}</Typography></Box>
                  }
                  <Box sx={{ flex:1, minWidth:0 }}>
                    <Typography fontWeight={700} fontSize={13} sx={{ color: T?.textPrimary ?? '#0f172a' }} noWrap>{selected.map((s: any) => s.name).join(' + ')}</Typography>
                    <Typography fontSize={12} sx={{ color: T?.textSecondary ?? '#64748b' }}>
                      {selDate && format(selDate, "EEE, d 'de' MMM", { locale: ptBR })} · {selTime}
                    </Typography>
                  </Box>
                  <Box sx={{ px:1, py:0.3, bgcolor: T ? '#14532d' : '#dcfce7', borderRadius:1.5 }}>
                    <Typography fontSize={10} fontWeight={800} sx={{ color: T ? '#86efac' : '#16a34a' }}>✓ Reservado</Typography>
                  </Box>
                </Box>

                {/* Serviços removidos — info já no resumo acima */}

                {/* Totais */}
                {(() => {
                  const total = selected.reduce((a: number, s: any) => a + Number(s.price), 0);
                  const pixDiscount = company?.settings?.mp_pix_discount || 0;
                  const isPix = payMethodSel === 'pix';
                  // Calcular sinal direto das configurações — igual ao confirm step
                  let toPay = total;
                  if (company?.settings?.payment_partial) {
                    if (company.settings.payment_partial_type === 'fixed') {
                      toPay = Math.min(Number(company.settings.payment_partial_fixed || 0), total);
                    } else {
                      toPay = Math.min(+(total * (company.settings.payment_partial_pct || 30) / 100).toFixed(2), total);
                    }
                  }
                  const isPartial = !!(company?.settings?.payment_partial && toPay < total);
                  const remaining = isPartial ? Math.max(0, +(total - toPay).toFixed(2)) : 0;
                  const discount = isPix && pixDiscount > 0 ? +(toPay * pixDiscount / 100).toFixed(2) : 0;
                  const pixFinal = isPix && pixDiscount > 0 ? +(toPay * (1 - pixDiscount/100)).toFixed(2) : toPay;
                  return (
                    <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:2.5, border: `1px solid ${T?.border ?? '#e5e7eb'}`, p:2, boxShadow:'0 1px 4px rgba(0,0,0,0.05)' }}>
                      <Box sx={{ display:'flex', justifyContent:'space-between', mb:1 }}>
                        <Typography fontSize={13} sx={{ color: T?.textSecondary ?? '#64748b' }}>Subtotal</Typography>
                        <Typography fontSize={13} fontWeight={600} sx={{ color: T?.textPrimary ?? '#0f172a' }}>R$ {total.toFixed(2).replace('.', ',')}</Typography>
                      </Box>
                      {isPix && pixDiscount > 0 && (
                        <Box sx={{ display:'flex', justifyContent:'space-between', mb:1, alignItems:'center' }}>
                          <Box sx={{ display:'flex', alignItems:'center', gap:0.8 }}>
                            <Typography fontSize={13} sx={{ color: T?.textSecondary ?? '#64748b' }}>Desconto Pix</Typography>
                            <Box sx={{ px:0.8, py:0.2, bgcolor: T ? '#14532d' : '#dcfce7', borderRadius:1 }}>
                              <Typography fontSize={10} fontWeight={800} sx={{ color: T ? '#86efac' : '#16a34a' }}>◈ {pixDiscount}% OFF</Typography>
                            </Box>
                          </Box>
                          <Typography fontSize={13} fontWeight={600} sx={{ color: T ? '#86efac' : '#16a34a' }}>– R$ {discount.toFixed(2).replace('.', ',')}</Typography>
                        </Box>
                      )}
                      <Divider sx={{ my:1, borderColor: T?.border }} />
                      <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb: isPartial ? 1 : 0 }}>
                        <Typography fontSize={15} fontWeight={800} sx={{ color: T?.textPrimary ?? '#0f172a' }}>{isPartial ? 'Sinal a pagar' : 'Total a pagar'}</Typography>
                        <Typography fontSize={20} fontWeight={900} sx={{ color: T?.textPrimary ?? '#0f172a' }}>R$ {pixFinal.toFixed(2).replace('.', ',')}</Typography>
                      </Box>
                      {isPartial && (
                        <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', bgcolor: T?.surfaceAlt ?? '#f8fafc', borderRadius:1.5, px:1.5, py:0.8, border: `1px solid ${T?.border ?? '#e2e8f0'}` }}>
                          <Typography fontSize={12} sx={{ color: T?.textSecondary ?? '#64748b' }}>Restante no estabelecimento</Typography>
                          <Typography fontSize={13} fontWeight={700} sx={{ color: T?.textSecondary ?? '#475569' }}>R$ {remaining.toFixed(2).replace('.', ',')}</Typography>
                        </Box>
                      )}
                    </Box>
                  );
                })()}

                {/* Timer compacto */}
                <Box sx={{ display:'flex', alignItems:'center', justifyContent:'center', gap:0.8, py:0.5 }}>
                  <Typography fontSize={12} sx={{ color: payCountdown < 120 ? (T ? '#fecaca' : '#dc2626') : (T?.textSecondary ?? '#94a3b8') }}>
                    Reserva expira em {String(Math.floor(payCountdown / 60)).padStart(2,'0')}:{String(payCountdown % 60).padStart(2,'0')}
                  </Typography>
                </Box>

                {/* Forma de pagamento label */}
                <Typography fontSize={13} fontWeight={700} sx={{ color: T?.textPrimary ?? '#1a1a1a' }} mb={-0.5}>Forma de pagamento</Typography>

                {/* Segurança */}
                <Box sx={{ display:'flex', alignItems:'center', justifyContent:'center', gap:0.8, py:0.8 }}>
                  <Typography fontSize={11} sx={{ color: T?.textSecondary ?? '#94a3b8' }}>🔒 Pagamento seguro via Mercado Pago</Typography>
                </Box>

                {/* PIX direto — sem Brick */}
                {payMethodSel === 'pix' && !pixData && (
                  <Button fullWidth variant="contained" disabled={pixCreating}
                    onClick={async () => {
                      setPixCreating(true);
                      try {
                        const pixDiscount = company?.settings?.mp_pix_discount || 0;
                        // Calcular sinal localmente para envio ao backend
                        const _pTotal = selected.reduce((a: number, s: any) => a + Number(s.price), 0);
                        let _pDeposit = _pTotal;
                        if (company?.settings?.payment_partial) {
                          if (company.settings.payment_partial_type === 'fixed') {
                            _pDeposit = Math.min(Number(company.settings.payment_partial_fixed || 0), _pTotal);
                          } else {
                            _pDeposit = Math.min(+(_pTotal * (company.settings.payment_partial_pct || 30) / 100).toFixed(2), _pTotal);
                          }
                        }
                        const finalAmt = pixDiscount > 0 ? +(_pDeposit * (1 - pixDiscount / 100)).toFixed(2) : _pDeposit;
                        const resp = await axios.post(`${API}/public/${slug}/create-pix`, {
                          booking_id: pendingBookingId,
                          amount: finalAmt,
                          service_name: pendingServiceName,
                          payer_email: custUser?.email || undefined,
                          payer_first_name: (custUser?.name || name || 'Cliente').split(' ')[0],
                          payer_last_name: (custUser?.name || name || '').split(' ').slice(1).join(' ') || 'Agendali',
                          device_id: await getMpDeviceId(),
                        });
                        setPixData({ qr_code: resp.data.qr_code, qr_code_base64: resp.data.qr_code_base64, payment_id: resp.data.payment_id });
                        // Iniciar polling a cada 3s
                        pixPollingRef.interval = setInterval(async () => {
                          try {
                            const st = await axios.get(`${API}/public/${slug}/payment-status/${resp.data.payment_id}`);
                            if (st.data.status === 'approved') {
                              clearInterval(pixPollingRef.interval);
                              if (countdownRef.current) clearInterval(countdownRef.current);
                              setBookingResult((prev: any) => prev ? { ...prev, payment_status: 'paid' } : prev);
                              setStep('done');
                            }
                          } catch (_) {}
                        }, 3000);
                      } catch (e: any) {
                        setSnack(e?.response?.data?.error || 'Erro ao gerar PIX. Tente novamente.');
                      } finally {
                        setPixCreating(false);
                      }
                    }}
                    sx={{ fontWeight:800, py:1.6, borderRadius:2.5, bgcolor:'#16a34a', '&:hover':{bgcolor:'#15803d'}, textTransform:'none', fontSize:15, boxShadow:'0 4px 16px rgba(22,163,74,0.35)' }}>
                    {pixCreating ? <CircularProgress size={22} color="inherit" /> : (
                      <Box sx={{ display:'flex', alignItems:'center', gap:1.2 }}>
                        {paymentSelectorB ? <PixSymbol size={24} color="#ffffff" /> : <Box component="img" src="/pix-logo.svg" alt="PIX" sx={{ width:22, height:22, filter:'brightness(10)' }} />}
                        <span>Gerar QR Code PIX</span>
                      </Box>
                    )}
                  </Button>
                )}
                {payMethodSel === 'pix' && pixData && (
                  <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', gap:2, p:2, bgcolor: T ? T.surfaceAlt : '#fafffe', borderRadius:3, border: T ? `1.5px solid ${T.border}` : '1.5px solid #d1fae5', boxShadow:'0 2px 12px rgba(0,0,0,0.04)' }}>
                    {paymentSelectorB ? <PixSymbol size={36} /> : <Box component="img" src="/pix-logo.svg" alt="PIX" sx={{ width:32, height:32 }} />}
                    <Typography fontWeight={800} fontSize={16} sx={{ color: T?.textPrimary ?? '#0f172a' }}>Escaneie o QR Code</Typography>
                    <Typography fontSize={12} sx={{ color: T?.textSecondary ?? '#64748b' }}>Abra o app do banco e escaneie o código abaixo</Typography>
                    {pixData.qr_code_base64 ? (
                      <Box component="img" src={`data:image/png;base64,${pixData.qr_code_base64}`} sx={{ width:220, height:220, borderRadius:3, border:'4px solid #fff', boxShadow:'0 4px 20px rgba(0,0,0,0.12)' }} />
                    ) : (
                      <Box sx={{ width:200, height:200, bgcolor: T?.surface ?? '#e5e7eb', borderRadius:2, display:'flex', alignItems:'center', justifyContent:'center' }}>
                        <Typography fontSize={12} sx={{ color: T?.textSecondary ?? '#6b7280' }} textAlign="center">QR Code indisponível</Typography>
                      </Box>
                    )}
                    <Typography fontSize={12} sx={{ color: T?.textSecondary ?? '#64748b' }} textAlign="center">Ou use o código Pix Copia e Cola:</Typography>
                    <Box sx={{ width:'100%', p:1.5, bgcolor: T?.surface ?? '#fff', borderRadius:2, border: T ? `1px solid ${T.border}` : '1px solid #d1fae5', wordBreak:'break-all' }}>
                      <Typography fontSize={11} sx={{ color: T?.textPrimary ?? '#374151', fontFamily:'monospace', lineHeight:1.6 }}>{pixData.qr_code.length > 120 ? pixData.qr_code.slice(0, 120) + '...' : pixData.qr_code}</Typography>
                    </Box>
                    <Button fullWidth variant="contained"
                      onClick={() => { navigator.clipboard.writeText(pixData.qr_code); setPixCopied(true); setTimeout(() => setPixCopied(false), 3000); }}
                      sx={{ fontWeight:800, py:1.3, borderRadius:2.5, bgcolor: pixCopied ? '#16a34a' : (T ? '#e2e8f0' : '#0f172a'), '&:hover': { bgcolor: pixCopied ? '#15803d' : (T ? '#cbd5e1' : '#1e293b') }, color: pixCopied ? '#fff' : (T ? '#0f172a' : '#fff'), textTransform:'none', fontSize:14, letterSpacing:0.3, boxShadow:'0 2px 8px rgba(0,0,0,0.2)' }}>
                      {pixCopied ? '✓ Copiado!' : 'Copiar código Pix'}
                    </Button>
                    <Box sx={{ display:'flex', alignItems:'center', gap:1, p:1.5, bgcolor: T?.surface ?? '#fff', borderRadius:2, border: T ? `1px solid ${T.border}` : '1px solid #d1fae5', width:'100%' }}>
                      <CircularProgress size={14} sx={{ color:'#16a34a', flexShrink:0 }} />
                      <Typography fontSize={12} sx={{ color: T ? '#86efac' : '#166534' }} fontWeight={600}>Aguardando pagamento... Seu agendamento será confirmado automaticamente.</Typography>
                    </Box>
                  </Box>
                )}

                {/* MP Bricks container — apenas para cartão */}
                {payMethodSel === 'card' && (
                  <>
                    <Box id="mp-bricks-container" />
                    {bricksError && (
                      <Alert severity="warning" sx={{ mb: 1.5, borderRadius: 2, fontSize: 12 }}>
                        {bricksError}
                      </Alert>
                    )}
                    {!bricksReady && (
                      <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', py:4, gap:1.5 }}>
                        <CircularProgress size={28} sx={{ color: accentColor }} />
                        <Typography fontSize={13} color="text.secondary">Carregando formulário do cartão...</Typography>
                      </Box>
                    )}
                    {bricksError && (
                      <Button
                        fullWidth
                        variant="outlined"
                        onClick={() => {
                          setBricksError('');
                          setBricksReady(false);
                          bricksInitRef.current = false;
                          setBricksRetryKey(v => v + 1);
                        }}
                        sx={{ mt: 1, borderRadius: 2, textTransform: 'none', fontWeight: 700 }}
                      >
                        Tentar carregar cartão novamente
                      </Button>
                    )}
                  </>
                )}

                {/* Cancelar */}
                <Button variant="text" fullWidth
                  sx={{ borderRadius:2.5, textTransform:'none', fontSize:13, py:1, color:'#94a3b8', '&:hover': { bgcolor: T ? 'rgba(255,255,255,0.06)' : '#f8f8f8', color: T?.textSecondary ?? '#64748b' } }}
                  onClick={async () => {
                    if (bricksControllerRef.current) { try { await bricksControllerRef.current.unmount(); } catch(_){} bricksControllerRef.current = null; }
                    if (countdownRef.current) clearInterval(countdownRef.current);
                    if (pendingBookingId) { axios.delete(`${API}/public/${slug}/bookings/${pendingBookingId}`, { data: { token: pendingBookingToken } }).catch(() => {}); }
                    bricksInitRef.current = false;
                    setStep('confirm');
                    setSnack('Agendamento cancelado. Nenhum pagamento foi cobrado.');
                  }}>
                  Cancelar pagamento
                </Button>
                <Box sx={{ height: 16 }} />
              </Box>
            </>
          )}

          {step === 'done' && (() => {
            const serviceTotal = selected.reduce((acc: number, s: any) => acc + Number(s.price || 0), 0);
            const bumpTotal = selectedBumps.reduce((acc: number, b: any) => acc + Number(b.price || 0), 0);
            const savingsTotal = selectedBumps.reduce((acc: number, b: any) => {
              const originalPrice = Number(b.original_price || 0);
              const currentPrice = Number(b.price || 0);
              return acc + (originalPrice > currentPrice ? (originalPrice - currentPrice) : 0);
            }, 0);
            const finalTotal = serviceTotal + bumpTotal;
            // Piloto de Crédito — esta tela (pós-confirmação) usava só estado
            // local (seleção do cliente), nunca o que o backend realmente
            // confirmou. Sem crédito isso coincidia por acaso; com crédito
            // aplicado, ficava mostrando o valor cheio de novo, contradizendo
            // a etapa anterior. Daqui em diante, sempre que existir resposta
            // do backend (bookingResult), ela manda — nunca recalcular aqui.
            const creditAppliedFinal = Number(bookingResult?.credit_applied || 0);
            const amountDueFinal = bookingResult?.amount_due != null ? Number(bookingResult.amount_due) : finalTotal;
            const depositDueFinal = bookingResult?.deposit_due != null ? Number(bookingResult.deposit_due) : null;

            return (
              <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', textAlign:'center' }}>
                {/* Topo limpo: fundo branco, check verde universal de sucesso */}
                <Box sx={{ width:'100%', bgcolor: T?.bg ?? '#fff', pt:{ xs:2.5, sm:4 }, pb:{ xs:2, sm:3.5 }, px:{ xs:2.5, sm:3 }, display:'flex', flexDirection:'column', alignItems:'center', gap:{ xs:1, sm:1.5 }, position:'relative', borderBottom: `1px solid ${T?.border ?? '#f1f5f9'}` }}>
                  <IconButton
                    size="small"
                    onClick={() => setModalOpen(false)}
                    sx={{ position:'absolute', top:14, right:14, color: T?.textSecondary ?? '#64748b', bgcolor: T?.surfaceAlt ?? '#f1f5f9', '&:hover': { bgcolor: T?.border ?? '#e2e8f0' } }}
                  >
                    <Close sx={{ fontSize:18 }} />
                  </IconButton>

                  {/* Ícone de sucesso: verde fixo, legível em qualquer accentColor */}
                  <Box sx={{ width:{ xs:64, sm:76 }, height:{ xs:64, sm:76 }, borderRadius:'50%', bgcolor:'#dcfce7', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:{ xs:'0 0 0 6px #f0fdf4', sm:'0 0 0 10px #f0fdf4' } }}>
                    <CheckCircle sx={{ fontSize:{ xs:38, sm:46 }, color:'#16a34a' }} />
                  </Box>

                  <Typography fontWeight={900} sx={{ fontSize:{ xs:20, sm:23 }, color: T?.textPrimary ?? '#0f172a', mt:{ xs:0.3, sm:0.5 } }} lineHeight={1.15}>
                    Agendamento confirmado
                  </Typography>

                  <Typography sx={{ fontSize:{ xs:13, sm:13.5 }, color: T?.textSecondary ?? '#475569', maxWidth:{ xs:240, sm:270 }, lineHeight:1.5 }}>
                    Seu horário foi reservado com sucesso e já está pronto para acompanhamento.
                  </Typography>
                  {bookingResult?.package_payment_pending === true && (
                    <Alert severity="warning" sx={{ borderRadius:2, textAlign:'left', mt:0.5, maxWidth:{ xs:'100%', sm:380 } }}>
                      O pagamento do seu pacote continua pendente no estabelecimento. Seu horário já está garantido.
                    </Alert>
                  )}
                </Box>

                <Box sx={{ width:'100%', px:2.5, pt:2.5, pb:1 }}>
                  <Box sx={{ bgcolor: T?.bg ?? '#fff', borderRadius:3, p:2.5, boxShadow:'0 4px 24px rgba(15,23,42,0.08)', textAlign:'left', border: `1px solid ${T?.border ?? '#e8edf4'}` }}>
                    {bookingResult && (
                      <>
                        <Typography fontSize={10.5} fontWeight={800} sx={{ color: T?.textPrimary ?? '#94a3b8', textTransform:'uppercase', letterSpacing:1.2, mb:1.5 }}>
                          Resumo final
                        </Typography>

                        <Typography fontWeight={900} fontSize={17} sx={{ color: T?.textPrimary ?? '#0f172a' }} mb={1.1}>
                          {selected.map((s: any) => s.name).join(' + ')}
                        </Typography>

                        <Box sx={{ display:'flex', flexWrap:'wrap', gap:0.8, mb:1.8 }}>
                          <Box sx={{ px:1.4, py:0.65, bgcolor:'#eff6ff', borderRadius:2, border:'1px solid #dbeafe' }}>
                            <Typography fontSize={12.5} fontWeight={700} color="#1d4ed8" sx={{ textTransform:'capitalize' }}>
                              {selDate && format(selDate, "EEE, d 'de' MMMM", { locale: ptBR })}
                            </Typography>
                          </Box>

                          <Box sx={{ px:1.4, py:0.65, bgcolor: T?.surfaceAlt ?? '#f8fafc', borderRadius:2, border: `1px solid ${T?.border ?? '#e2e8f0'}` }}>
                            <Typography fontSize={12.5} fontWeight={700} sx={{ color: T?.textPrimary ?? '#334155' }}>
                              {selTime}
                            </Typography>
                          </Box>

                          {selPro && (
                            <Box sx={{ px:1.4, py:0.65, bgcolor: T?.surfaceAlt ?? '#f8fafc', borderRadius:2, border: `1px solid ${T?.border ?? '#e2e8f0'}` }}>
                              <Typography fontSize={12.5} fontWeight={700} sx={{ color: T?.textPrimary ?? '#334155' }}>
                                {selPro.name}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        {selectedBumps.length > 0 && (
                          <Box sx={{ mb:1.8, p:1.5, bgcolor: T?.surfaceAlt ?? '#f8fafc', border: `1px solid ${T?.border ?? '#e2e8f0'}`, borderRadius:2.2 }}>
                            <Typography fontSize={11} fontWeight={800} sx={{ color: T?.textSecondary ?? '#64748b', textTransform:'uppercase', letterSpacing:0.9, mb:1 }}>
                              Extras adicionados
                            </Typography>

                            {selectedBumps.map((b: any, i: number) => {
                              const originalPrice = Number(b.original_price || 0);
                              const currentPrice = Number(b.price || 0);
                              const savings = originalPrice > currentPrice ? (originalPrice - currentPrice) : 0;

                              return (
                                <Box key={`done-bump-${i}`} sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:1, py:0.7, borderBottom: i < selectedBumps.length - 1 ? `1px solid ${T?.border ?? '#e5e7eb'}` : 'none' }}>
                                  <Box sx={{ flex:1, minWidth:0 }}>
                                    <Typography fontSize={13} fontWeight={800} sx={{ color: T?.textPrimary ?? '#0f172a' }}>
                                      + {b.name}
                                    </Typography>

                                    {!!b.description && (
                                      <Typography fontSize={11} sx={{ color: T?.textSecondary ?? '#64748b', mt:0.2, lineHeight:1.3 }}>
                                        {b.description}
                                      </Typography>
                                    )}

                                    {savings > 0 && (
                                      <Box sx={{ mt:0.45, display:'inline-flex', alignItems:'center', px:0.8, py:0.26, bgcolor:'#dcfce7', borderRadius:1 }}>
                                        <Typography sx={{ fontSize:9.5, fontWeight:800, color:'#16a34a', lineHeight:1 }}>
                                          Economia R$ {savings.toFixed(2).replace('.', ',')}
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>

                                  <Box sx={{ textAlign:'right', flexShrink:0 }}>
                                    {originalPrice > currentPrice && (
                                      <Typography fontSize={11} sx={{ color: T?.textSecondary ?? '#94a3b8', textDecoration:'line-through', lineHeight:1.1 }}>
                                        R$ {originalPrice.toFixed(2).replace('.', ',')}
                                      </Typography>
                                    )}

                                    <Typography fontSize={14} fontWeight={900} sx={{ color: accentColor, mt:0.15 }}>
                                      R$ {currentPrice.toFixed(2).replace('.', ',')}
                                    </Typography>
                                  </Box>
                                </Box>
                              );
                            })}
                          </Box>
                        )}

                        <Divider sx={{ mb:1.5, borderColor: T?.border }} />

                        <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:0.8 }}>
                          <Typography fontSize={13} sx={{ color: T?.textSecondary ?? '#64748b' }} fontWeight={600}>Servicos</Typography>
                          <Typography fontSize={13} sx={{ color: T?.textPrimary ?? '#0f172a' }} fontWeight={700}>
                            R$ {serviceTotal.toFixed(2).replace('.', ',')}
                          </Typography>
                        </Box>

                        {selectedBumps.length > 0 && (
                          <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:0.8 }}>
                            <Typography fontSize={13} sx={{ color: T?.textSecondary ?? '#64748b' }} fontWeight={600}>Extras</Typography>
                            <Typography fontSize={13} sx={{ color: T?.textPrimary ?? '#0f172a' }} fontWeight={700}>
                              R$ {bumpTotal.toFixed(2).replace('.', ',')}
                            </Typography>
                          </Box>
                        )}

                        {savingsTotal > 0 && (
                          <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:1.1 }}>
                            <Typography fontSize={13} sx={{ color: isDark ? '#4ade80' : '#16a34a' }} fontWeight={700}>Desconto conquistado</Typography>
                            <Typography fontSize={13} sx={{ color: isDark ? '#4ade80' : '#16a34a' }} fontWeight={900}>
                              R$ {savingsTotal.toFixed(2).replace('.', ',')}
                            </Typography>
                          </Box>
                        )}

                        {creditAppliedFinal > 0 && (
                          <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:1.1 }}>
                            <Typography fontSize={13} sx={{ color: isDark ? '#4ade80' : '#16a34a' }} fontWeight={700}>★ Coberto por crédito</Typography>
                            <Typography fontSize={13} sx={{ color: isDark ? '#4ade80' : '#16a34a' }} fontWeight={900}>
                              -R$ {creditAppliedFinal.toFixed(2).replace('.', ',')}
                            </Typography>
                          </Box>
                        )}

                        {/* Total final — vem do backend (amountDueFinal) sempre que possível,
                            nunca recalculado aqui, pra nunca contradizer a etapa de confirmação. */}
                        <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', pt:1.3, borderTop: `2px solid ${T?.border ?? '#f1f5f9'}` }}>
                          <Typography fontSize={15.5} sx={{ color: T?.textPrimary ?? '#0f172a' }} fontWeight={900}>Total do serviço</Typography>
                          <Typography fontWeight={900} fontSize={20} sx={{ color: T?.textPrimary ?? '#0f172a', letterSpacing:'-0.3px' }}>
                            R$ {amountDueFinal.toFixed(2).replace('.', ',')}
                          </Typography>
                        </Box>
                        {/* Pagar no local: sem cobrança antecipada — valor total é devido no estabelecimento */}
                        {(() => {
                          const isCashSelected = !!(company?.settings?.mp_cash_enabled && payMethodSel === 'cash');
                          if (isCashSelected) {
                            return (
                              <Box sx={{ mt:1.5, p:1.5, bgcolor: T?.surfaceAlt ?? '#f8fafc', borderRadius:2, border: `1px solid ${T?.border ?? '#e2e8f0'}` }}>
                                <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                                  <Typography fontSize={13} sx={{ color: T?.textSecondary ?? '#475569' }} fontWeight={700}>Pagamento no estabelecimento</Typography>
                                  <Typography fontSize={14} fontWeight={900} sx={{ color: T?.textPrimary ?? '#0f172a' }}>R$ {amountDueFinal.toFixed(2).replace('.', ',')}</Typography>
                                </Box>
                              </Box>
                            );
                          }
                          return null;
                        })()}
                        {/* Sinal pago + restante — só aparece quando payment_partial está ativo e o pagamento foi online */}
                        {(() => {
                          const isCashSelected = !!(company?.settings?.mp_cash_enabled && payMethodSel === 'cash');
                          const hasPartial = !isCashSelected && !!(company?.settings?.payment_required && company?.settings?.mp_public_key && company?.settings?.payment_partial);
                          if (!hasPartial) return null;
                          // Sinal: usa sempre o que o backend confirmou (depositDueFinal, já
                          // líquido de crédito real por real — nunca uma % recalculada aqui
                          // em cima do total, que duplicaria o erro já corrigido na etapa
                          // anterior). Só recalcula localmente se por algum motivo a resposta
                          // do backend não trouxe deposit_due.
                          let paidNow = depositDueFinal;
                          if (paidNow === null) {
                            paidNow = finalTotal;
                            if (company.settings.payment_partial_type === 'fixed') {
                              paidNow = Math.min(Number(company.settings.payment_partial_fixed || 0), finalTotal);
                            } else {
                              paidNow = Math.min(+(finalTotal * (company.settings.payment_partial_pct || 30) / 100).toFixed(2), finalTotal);
                            }
                          }
                          const remainingAtEstab = Math.max(0, +(amountDueFinal - paidNow).toFixed(2));
                          const methodLabel = payMethodSel === 'card' ? 'Cartão' : 'PIX';
                          return (
                            <Box sx={{ mt:1.5, p:1.5, bgcolor: T ? 'rgba(22,163,74,0.12)' : '#f0fdf4', borderRadius:2, border: T ? '1px solid rgba(22,163,74,0.3)' : '1px solid #bbf7d0' }}>
                              <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:0.8 }}>
                                <Typography fontSize={13} sx={{ color: T ? '#86efac' : '#166534' }} fontWeight={700}>✓ Pago agora ({methodLabel})</Typography>
                                <Typography fontSize={14} fontWeight={900} sx={{ color: T ? '#4ade80' : '#16a34a' }}>R$ {paidNow.toFixed(2).replace('.', ',')}</Typography>
                              </Box>
                              <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                                <Typography fontSize={13} sx={{ color: T?.textSecondary ?? '#475569' }} fontWeight={600}>Restante no estabelecimento</Typography>
                                <Typography fontSize={14} fontWeight={700} sx={{ color: T?.textSecondary ?? '#475569' }}>R$ {remainingAtEstab.toFixed(2).replace('.', ',')}</Typography>
                              </Box>
                            </Box>
                          );
                        })()}
                      </>
                    )}
                  </Box>

                  {company?.settings?.show_add_to_calendar === true && (
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => {
                      try {
                        const title = `Agendamento - ${selected.map((s: any) => s.name).join(' + ')}`;
                        const dateObj = selDate ? new Date(selDate) : new Date();
                        const [h, m] = String(selTime || '09:00').split(':').map(Number);
                        dateObj.setHours(h || 9, m || 0, 0, 0, 0);
                        const totalMinutes = selected.reduce((acc: number, s: any) => acc + Number(s.duration || s.duration_minutes || s.duration_min || 30), 0) || 30;
                        const endObj = new Date(dateObj.getTime() + totalMinutes * 60000);
                        const fmt = (d: Date) => d.toISOString().replace(/[-:]|\.\d{3}/g, '');
                        const details = [
                          company?.name ? `Estabelecimento: ${company.name}` : '',
                          selPro?.name ? `Profissional: ${selPro.name}` : '',
                          selected.length ? `Servico: ${selected.map((s: any) => s.name).join(' + ')}` : '',
                          selectedBumps.length ? `Extras: ${selectedBumps.map((b: any) => b.name).join(', ')}` : '',
                        ].filter(Boolean).join('\n');
                        const params = new URLSearchParams({
                          action: 'TEMPLATE',
                          text: title,
                          dates: `${fmt(dateObj)}/${fmt(endObj)}`,
                          details,
                        });
                        if (company?.address) params.set('location', company.address);
                        window.open(`https://calendar.google.com/calendar/render?${params.toString()}`, '_blank', 'noopener,noreferrer');
                      } catch (_) {
                        setSnack('Nao foi possivel abrir o calendario agora.');
                      }
                    }}
                    sx={{ fontWeight:900, py:1.65, borderRadius:2.5, mt:2.5, bgcolor:accentColor, '&:hover': { filter:'brightness(0.9)', transform:'translateY(-1px)' }, transition:'all 0.15s', textTransform:'none', fontSize:15.5, boxShadow:`0 6px 20px ${accentColor}44`, letterSpacing:'0.01em' }}
                  >
                    Adicionar ao calendário
                  </Button>
                  )}

                  <Button
                    fullWidth
                    variant="text"
                    onClick={() => setModalOpen(false)}
                    sx={{ mt:0.5, mb:1, textTransform:'none', fontWeight:700, color:'#94a3b8', fontSize:14, '&:hover': { color:'#64748b', bgcolor:'transparent' } }}
                  >
                    Fechar
                  </Button>
                </Box>
              </Box>
            );
          })()}
        </DialogContent>
      </Dialog>

      {/* ===== CONFIRMAÇÃO V2 (piloto visual — Parte 5, gated por confirmation_ui_v2_pilot) ===== */}
      <ConfirmationV2
        open={modalOpen && step === 'done' && confirmationV2Pilot}
        onClose={() => setModalOpen(false)}
        isDark={isDark}
        accentColor={accentColor}
        company={company}
        slug={slug}
        selDate={selDate}
        selTime={selTime}
        selPro={selPro}
        selected={selected}
        selectedBumps={selectedBumps}
        payMethodSel={payMethodSel}
        showAddToCalendar={company?.settings?.show_add_to_calendar === true}
        onAddToCalendar={handleAddToCalendar}
        showAddress={company?.settings?.show_confirmation_address === true}
        hasValidSession={!!bookingResult?.customer_token}
        isPreview={isPreview}
        upsellOffer={upsellOffer}
        upsellAccepted={upsellAccepted}
        upsellAccepting={upsellAccepting}
        onAcceptUpsell={acceptUpsellOffer}
      />

      {/* ===== AVALIAÇÃO PROATIVA (piloto — Parte 1, rodada 3) ===== */}
      <ProactiveReviewModal
        open={pendingReviewOpen}
        booking={pendingReview}
        isDark={isDark}
        accentColor={accentColor}
        onSkip={skipPendingReview}
        onSubmit={submitPendingReview}
        submitting={pendingReviewSubmitting}
      />

      {/* ===== PACOTE — SELETOR "ESCOLHA O QUE VAI USAR HOJE" (Rodada 5.2) ===== */}
      <Dialog
        open={packagePickerOpen}
        onClose={() => setPackagePickerOpen(false)}
        maxWidth="sm"
        fullWidth
        fullScreen={packagePickerFullScreen}
        PaperProps={{ sx: packagePickerFullScreen ? { m: 0, borderRadius: 0, height: '100%' } : { borderRadius: 3, m: 2, maxHeight: '85vh' } }}
        sx={{ '& .MuiDialog-container': { alignItems: packagePickerFullScreen ? 'stretch' : 'center' } }}
      >
        <DialogTitle sx={{ fontWeight: 900, fontSize: 20, color: '#111827', pb: 1 }}>
          Escolha o que vai usar hoje
        </DialogTitle>
        <DialogContent sx={{ pt: 0, flex: 1 }}>
          {packagePickerPlan && (() => {
            const daysLeft = getSubscriptionDaysLeft(packagePickerPlan.end_date);
            const totalRemaining = packagePickerItems.reduce((s: number, it: any) => s + getSubscriptionRemaining(it), 0);
            return (
              <Box sx={{ p: 1.4, borderRadius: 2.5, bgcolor: '#f8fafc', border: '1px solid #e2e8f0', mb: 2 }}>
                <Typography fontWeight={900} fontSize={14} color="#111827">
                  {packagePickerPlan.subscription_plan?.public_title || packagePickerPlan.plan_name || 'Pacote ativo'}
                </Typography>
                {packagePickerPlan.status === 'pending_local_payment' ? (
                  <>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mt: 0.6 }}>
                      <Typography fontSize={12} fontWeight={700} color="#475569">
                        {totalRemaining} {totalRemaining === 1 ? 'uso reservado' : 'usos reservados'}
                      </Typography>
                      <Typography fontSize={12} color="#94a3b8">
                        · agende até {String(packagePickerPlan.end_date || '').split('-').reverse().join('/')}
                      </Typography>
                    </Box>
                    <Typography fontSize={12} fontWeight={700} sx={{ color: '#b45309', mt: 0.6 }}>
                      Pagamento pendente no estabelecimento
                    </Typography>
                  </>
                ) : (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mt: 0.6 }}>
                    <Typography fontSize={12} fontWeight={700} color="#475569">
                      {totalRemaining} {totalRemaining === 1 ? 'item disponível' : 'itens disponíveis'}
                    </Typography>
                    {daysLeft !== null && (
                      <Typography fontSize={12} color="#94a3b8">
                        · {daysLeft > 0 ? `válido por mais ${daysLeft} dia(s)` : 'último dia de validade'}
                      </Typography>
                    )}
                  </Box>
                )}
              </Box>
            );
          })()}

          <Typography fontSize={12.5} color="#94a3b8" sx={{ mb: 1.2 }}>
            Toque para marcar os itens desta visita. O tempo total é calculado antes de abrir a agenda.
          </Typography>

          <Box sx={{ display:'flex', flexDirection:'column', gap:1 }}>
            {packagePickerItems.length > 0 ? packagePickerItems.map((item: any) => {
              const serviceId = Number(item?.service_id || item?.service?.id || 0);
              const selected = packageSelectionIds.includes(serviceId);
              const remaining = getSubscriptionRemaining(item);
              const duration = Number(item?.service?.duration_min || 0);

              return (
                <Box
                  key={item.id}
                  onClick={() => togglePackageSelection(item)}
                  role="checkbox"
                  aria-checked={selected}
                  sx={{
                    p: 1.4,
                    borderRadius: 2.5,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.2,
                    border: selected ? `2px solid ${accentColor}` : '1px solid #e5e7eb',
                    bgcolor: selected ? `${accentColor}10` : '#fff',
                    cursor: 'pointer',
                    transition: 'all 0.15s'
                  }}
                >
                  {selected ? (
                    <CheckCircle sx={{ fontSize: 24, color: accentColor, flexShrink: 0 }} />
                  ) : (
                    <Box sx={{ width: 24, height: 24, borderRadius: '50%', border: '2px solid #cbd5e1', flexShrink: 0 }} />
                  )}
                  <Box sx={{ minWidth:0, flex: 1 }}>
                    <Typography fontWeight={900} fontSize={14} color="#111827">
                      {getSubscriptionItemLabel(item)}
                    </Typography>
                    <Typography fontSize={12} color="#64748b" sx={{ mt:0.25 }}>
                      {remaining} restante(s){duration > 0 ? ` · ${duration} min` : ''}
                    </Typography>
                  </Box>
                </Box>
              );
            }) : (
              <Alert severity="warning" sx={{ borderRadius: 2 }}>
                Você não tem saldo disponível neste pacote para agendar agora.
              </Alert>
            )}
          </Box>
        </DialogContent>

        {/* Resumo fixo — fora da área de scroll, sempre visível mesmo com lista longa */}
        <Box sx={{ px: 3, pt: 1.5, pb: 1, borderTop: '1px solid #f1f5f9', flexShrink: 0 }}>
          <Box sx={{ p: 1.4, borderRadius: 2.5, bgcolor: '#f8fafc', border: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography fontSize={12} color="#64748b">
              Tempo estimado desta visita
            </Typography>
            <Typography fontWeight={900} fontSize={18} color="#111827">
              {selectedPackageDuration || 0} min
            </Typography>
          </Box>
        </Box>
        <DialogActions sx={{ px: 3, pb: 2.5, gap: 1, flexShrink: 0 }}>
          <Button
            onClick={() => setPackagePickerOpen(false)}
            sx={{ textTransform:'none', fontWeight:700 }}
          >
            Fechar
          </Button>
          <Button
            variant="contained"
            onClick={continuePackageBooking}
            disabled={!packageSelectionIds.length}
            sx={{
              bgcolor: accentColor,
              '&:hover': { filter:'brightness(0.94)' },
              textTransform:'none',
              fontWeight:800,
              borderRadius:2
            }}
          >
            Continuar para agenda
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={loginOpen}
        onClose={() => { setLoginOpen(false); resetLoginForm(); setLoginThenBook(false); setGoogleReturnPlanId(null); }}
        maxWidth="xs" fullWidth
        PaperProps={{ sx: { borderRadius: 3, m: 2 } }}>
        <DialogContent sx={{ p: 3, pt: 2.5 }}>
          <Box display="flex" justifyContent="flex-end" mb={0.5}>
            <IconButton size="small" onClick={() => { setLoginOpen(false); resetLoginForm(); setLoginThenBook(false); setGoogleReturnPlanId(null); }} sx={{ color: T?.textSecondary ?? '#888' }}>
              <Close />
            </IconButton>
          </Box>
          <Box textAlign="center" mb={3}>
            <Typography fontWeight={800} fontSize={26} lineHeight={1.1}>
              {loginMode === 'login' ? 'Entrar' : 'Criar Conta'}
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              {googleReturnPlanId
                ? (loginMode === 'login' ? 'Entre para continuar com a compra' : 'Crie sua conta para comprar este pacote.')
                : (loginMode === 'login' ? 'Acesse sua conta para agendar' : 'Preencha seus dados')}
            </Typography>
          </Box>

          {loginError && <Alert severity="error" sx={{ mb:2, borderRadius:2, fontSize:13 }}>{loginError}</Alert>}

          {loginMode === 'register' && (
            <>
              <TextField fullWidth label="Seu nome completo" value={loginName}
                onChange={e => setLoginName(e.target.value)} sx={{ mb:1.5 }}
                InputProps={{ sx: { borderRadius:2 } }} autoFocus />
              <TextField fullWidth label="WhatsApp" value={loginPhone}
                onChange={e => {
                  const n = e.target.value.replace(/\D/g,'').slice(0,11);
                  const f = n.length > 6 ? `(${n.slice(0,2)}) ${n.slice(2,7)}-${n.slice(7)}` : n.length > 2 ? `(${n.slice(0,2)}) ${n.slice(2)}` : n;
                  setLoginPhone(f);
                }}
                placeholder="(11) 99999-9999" sx={{ mb:1.5 }}
                InputProps={{ sx: { borderRadius:2 } }} />
            </>
          )}

          <TextField fullWidth label={loginMode === 'login' ? 'E-mail ou telefone' : 'E-mail'} value={loginEmail}
            type={loginMode === 'login' ? 'text' : 'email'}
            onChange={e => setLoginEmail(e.target.value)} sx={{ mb:1.5 }}
            onKeyDown={e => e.key === 'Enter' && loginMode === 'login' && handleLogin()}
            inputProps={{ inputMode: 'text' }}
            InputProps={{ sx: { borderRadius:2 } }} />

          <TextField fullWidth label="Senha" type={loginShowPwd ? 'text' : 'password'}
            value={loginPassword}
            onChange={e => setLoginPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && loginMode === 'login' && handleLogin()}
            sx={{ mb: loginMode === 'login' ? 1 : 2.5 }}
            InputProps={{
              sx: { borderRadius:2 },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setLoginShowPwd(v => !v)} edge="end">
                    {loginShowPwd ? <VisibilityOff sx={{ fontSize:18 }} /> : <Visibility sx={{ fontSize:18 }} />}
                  </IconButton>
                </InputAdornment>
              )
            }} />

          {loginMode === 'login' && (
            <Box textAlign="center" mb={2.5}>
              <Typography variant="caption" color="text.secondary">Não consegue acessar? </Typography>
              <Typography component="span" variant="caption" fontWeight={700} color="primary" sx={{ cursor:'pointer', textDecoration:'underline' }}
                onClick={() => setForgotOpen(true)}>
                Redefina a senha
              </Typography>
            </Box>
          )}

          <Box sx={{ display:'flex', gap:1.5, mb:2 }}>
            <Button fullWidth variant={loginMode === 'register' ? 'contained' : 'text'}
              onClick={() => loginMode === 'login' ? (setLoginMode('register'), setLoginEmail(''), setLoginError('')) : handleRegister()}
              disabled={loginLoading}
              sx={{
                borderRadius:2, fontWeight:800, py:1.4, textTransform:'none', letterSpacing:0.5, fontSize:13,
                ...(loginMode === 'register'
                  ? { bgcolor: T ? '#e2e8f0' : '#1a1a1a', color: T ? '#0f172a' : '#fff', '&:hover': { bgcolor: T ? '#cbd5e1' : '#333' } }
                  : { color: T?.textSecondary ?? '#444', '&:hover': { bgcolor: T?.surfaceAlt ?? '#f5f5f5' } })
              }}>
              {loginLoading && loginMode === 'register' ? <CircularProgress size={20} color="inherit" /> : 'CRIAR CONTA'}
            </Button>
            <Button fullWidth variant={loginMode === 'login' ? 'contained' : 'text'}
              onClick={() => loginMode === 'register' ? (setLoginMode('login'), setLoginError('')) : handleLogin()}
              disabled={loginLoading}
              sx={{
                borderRadius:2, fontWeight:800, py:1.4, textTransform:'none', letterSpacing:0.5, fontSize:13,
                ...(loginMode === 'login'
                  ? { bgcolor: T ? '#e2e8f0' : '#1a1a1a', color: T ? '#0f172a' : '#fff', '&:hover': { bgcolor: T ? '#cbd5e1' : '#333' } }
                  : { color: T?.textSecondary ?? '#444', '&:hover': { bgcolor: T?.surfaceAlt ?? '#f5f5f5' } })
              }}>
              {loginLoading && loginMode === 'login' ? <CircularProgress size={20} color="inherit" /> : 'ENTRAR'}
            </Button>
          </Box>

          <Box sx={{ display:'flex', alignItems:'center', gap:1.5, mb:2 }}>
            <Box sx={{ flex:1, height:'1px', bgcolor: T?.border ?? '#e0e0e0' }} />
            <Typography variant="caption" sx={{ color: T?.textSecondary }}>ou</Typography>
            <Box sx={{ flex:1, height:'1px', bgcolor: T?.border ?? '#e0e0e0' }} />
          </Box>

          {/* ── Google OAuth (redirect) + estados de pending/conflict ── */}
          {!googlePending && !googlePhoneConflict && !googleEmailNeedsPassword && (
            <Button fullWidth variant="outlined" size="large"
              startIcon={googleLoading ? <CircularProgress size={18} sx={{ color: '#555' }} /> : <GoogleG />}
              onClick={handleGoogleLogin}
              disabled={googleLoading || loginLoading}
              sx={{ borderRadius:2, textTransform:'none', fontWeight:600, fontSize:13, py:1.2, color: T?.textPrimary ?? '#333', borderColor: T?.border ?? '#ddd', '&:hover': { borderColor: T?.border ?? '#bbb', bgcolor: T?.surfaceAlt ?? '#fafafa' } }}>
              {googleLoading ? 'Redirecionando...' : 'Continuar com Google'}
            </Button>
          )}

          {/* Completar cadastro Google — nome + WhatsApp */}
          {googlePending && !googlePhoneConflict && (
            <Box sx={{ mt:1 }}>
              <Alert severity="info" sx={{ mb:1.5, borderRadius:2, fontSize:12 }}>
                Quase lá! Precisamos do seu nome e WhatsApp para finalizar.
              </Alert>
              <TextField fullWidth label="Seu nome" size="small" value={googlePendingName}
                onChange={e => setGooglePendingName(e.target.value)}
                sx={{ mb:1.5 }} InputProps={{ sx: { borderRadius:2 } }} />
              <TextField fullWidth label="WhatsApp (com DDD)" size="small" value={googlePendingPhone}
                onChange={e => setGooglePendingPhone(e.target.value)}
                placeholder="(11) 99999-9999"
                error={!!googlePendingPhoneError}
                helperText={googlePendingPhoneError}
                sx={{ mb:1.5 }} InputProps={{ sx: { borderRadius:2 } }} />
              <Button fullWidth variant="contained" onClick={handleGoogleComplete} disabled={googleLoading}
                sx={{ borderRadius:2, fontWeight:700, textTransform:'none', bgcolor:'#1a1a1a', '&:hover':{ bgcolor:'#333' } }}>
                {googleLoading ? <CircularProgress size={20} color="inherit" /> : 'Concluir cadastro'}
              </Button>
              <Button fullWidth size="small" sx={{ mt:0.5, color:'#999', textTransform:'none', fontSize:12 }}
                onClick={() => { setGooglePending(false); setLoginError(''); }}>
                Cancelar
              </Button>
            </Box>
          )}

          {/* Conflito de WhatsApp — oferecer vinculação */}
          {googlePhoneConflict && (
            <Box sx={{ mt:1 }}>
              <Alert severity="warning" sx={{ mb:1.5, borderRadius:2, fontSize:12 }}>
                Encontramos uma conta com este WhatsApp ({googleConflictOldName}). Deseja unir os dados ao seu Google?
              </Alert>
              {googleConflictOldHasPassword ? (
                <>
                  <TextField fullWidth label="Senha da conta antiga" type="password" size="small"
                    value={googleConflictPassword} onChange={e => setGoogleConflictPassword(e.target.value)}
                    error={!!googleConflictError} helperText={googleConflictError}
                    sx={{ mb:1.5 }} InputProps={{ sx: { borderRadius:2 } }} />
                  <Button fullWidth variant="contained" onClick={handleGoogleLink} disabled={googleLoading}
                    sx={{ borderRadius:2, fontWeight:700, textTransform:'none', bgcolor:'#1a1a1a' }}>
                    {googleLoading ? <CircularProgress size={20} color="inherit" /> : 'Vincular conta'}
                  </Button>
                </>
              ) : (
                <>
                  <Alert severity="info" sx={{ mb:1.5, borderRadius:2, fontSize:12 }}>
                    Esta conta foi cadastrada pelo salão. Clique em vincular para unir seu histórico ao Google.
                  </Alert>
                  <Button fullWidth variant="contained" onClick={handleGoogleLink} disabled={googleLoading}
                    sx={{ borderRadius:2, fontWeight:700, textTransform:'none', bgcolor:'#1a1a1a' }}>
                    {googleLoading ? <CircularProgress size={20} color="inherit" /> : 'Vincular conta'}
                  </Button>
                </>
              )}
              <Button fullWidth size="small" sx={{ mt:0.5, color:'#999', textTransform:'none', fontSize:12 }}
                onClick={() => { setGooglePhoneConflict(false); setGooglePendingPhone(''); }}>
                Usar WhatsApp diferente
              </Button>
            </Box>
          )}

          {/* E-mail já cadastrado numa conta COM senha — sempre exige senha,
              nunca vincula automático (achado da revisão pré-liberação global) */}
          {googleEmailNeedsPassword && (
            <Box sx={{ mt:1 }}>
              <Alert severity="warning" sx={{ mb:1.5, borderRadius:2, fontSize:12 }}>
                Encontramos uma conta com este e-mail ({googleConflictOldName}). Confirme sua senha para vincular ao Google.
              </Alert>
              <TextField fullWidth label="Sua senha" type="password" size="small"
                value={googleConflictPassword} onChange={e => setGoogleConflictPassword(e.target.value)}
                error={!!googleConflictError} helperText={googleConflictError}
                sx={{ mb:1.5 }} InputProps={{ sx: { borderRadius:2 } }} />
              <Button fullWidth variant="contained" onClick={handleGoogleEmailLink} disabled={googleLoading}
                sx={{ borderRadius:2, fontWeight:700, textTransform:'none', bgcolor:'#1a1a1a' }}>
                {googleLoading ? <CircularProgress size={20} color="inherit" /> : 'Vincular conta'}
              </Button>
              <Button fullWidth size="small" sx={{ mt:0.5, color:'#999', textTransform:'none', fontSize:12 }}
                onClick={() => { setGoogleEmailNeedsPassword(false); setGoogleConflictPassword(''); setGoogleConflictError(''); }}>
                Cancelar
              </Button>
            </Box>
          )}

          <Typography variant="caption" color="text.secondary" display="block" textAlign="center" mt={2} lineHeight={1.5}>
            Ao continuar, você concorda com os{' '}
            <Typography component="span" variant="caption" fontWeight={700} color="text.primary" sx={{ cursor:'pointer' }}>Termos de Uso</Typography>
            {' '}e a{' '}
            <Typography component="span" variant="caption" fontWeight={700} color="text.primary" sx={{ cursor:'pointer' }}>Política de Privacidade</Typography>
          </Typography>
        </DialogContent>
      </Dialog>


      {/* TERMS/PRIVACY DIALOG */}
      <Dialog open={termsOpen} onClose={() => setTermsOpen(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3, m: 2, maxHeight: '85vh' } }}>
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ px: 3, py: 2.5, borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography sx={{ fontWeight: 700, fontSize: 15, color: '#111827' }}>{company?.name}</Typography>
            <Button size="small" onClick={() => setTermsOpen(false)} sx={{ minWidth: 0, color: '#6b7280', fontSize: 20, lineHeight: 1 }}>×</Button>
          </Box>
          <Box sx={{ p: 3, overflow: 'auto', maxHeight: '70vh' }}>
            <Typography sx={{ fontSize: 13, color: '#374151', whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>{termsText}</Typography>
          </Box>
        </DialogContent>
      </Dialog>

      {/* ===== MODAL: INFORMAÇÕES PARA O ATENDIMENTO =====
          Fundo do Paper via "& .MuiDialog-paper" (não via PaperProps) — no MUI v9
          instalado neste projeto, PaperProps.sx não aplica bgcolor de forma
          confiável ao Paper do Dialog, mesmo padrão já usado no modal de
          pagamento MP Bricks logo abaixo. */}
      {(() => {
        const intakeAllQuestions = Array.isArray(company?.settings?.intake_form_questions) ? company.settings.intake_form_questions : [];
        const intakeIsRequired = company?.settings?.intake_form_required === true;
        const intakeMissingCount = intakeAllQuestions.filter((q: any) => !String(intakeDraftAnswers[q.id] || '').trim()).length;
        const intakeCanSave = !intakeIsRequired || intakeMissingCount === 0;
        return (
          <Dialog open={intakeModalOpen} onClose={() => setIntakeModalOpen(false)} maxWidth="sm" fullWidth
            sx={{ '& .MuiDialog-paper': { borderRadius: 3, m: 2, maxHeight: '85vh', bgcolor: T ? T.surface : '#fff' } }}>
            <DialogTitle sx={{ fontWeight: 800, fontSize: 16, color: T?.textPrimary ?? '#0f172a' }}>Informações para o atendimento</DialogTitle>
            <DialogContent dividers sx={{ borderColor: T?.border }}>
              {intakeIsRequired && (
                <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: accentColor, mb: 2 }}>
                  Para continuar, responda todas as perguntas.
                </Typography>
              )}
              {intakeAllQuestions.map((q: any) => (
                <Box key={q.id} sx={{ mb: 2.5 }}>
                  <Typography fontSize={13.5} fontWeight={600} sx={{ color: T?.textPrimary ?? '#0f172a', mb: 1 }}>{q.label}</Typography>
                  {(q.type === 'yes_no' || q.type === 'yes_no_na') ? (
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      {(q.type === 'yes_no' ? ['Sim', 'Não'] : ['Sim', 'Não', 'Não se aplica']).map(opt => {
                        const selected = intakeDraftAnswers[q.id] === opt;
                        return (
                          <Button key={opt} size="small" variant={selected ? 'contained' : 'outlined'}
                            onClick={() => setIntakeDraftAnswers((prev: any) => ({ ...prev, [q.id]: opt }))}
                            sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 1.5, fontSize: 12.5,
                              ...(selected ? { bgcolor: accentColor, color: '#fff', '&:hover': { bgcolor: accentColor } }
                                : { borderColor: T ? T.textSecondary : '#cbd5e1', color: T?.textPrimary ?? '#0f172a',
                                    '&:hover': { borderColor: accentColor, bgcolor: T ? 'rgba(255,255,255,0.04)' : undefined } }) }}>
                            {opt}
                          </Button>
                        );
                      })}
                    </Box>
                  ) : (
                    <TextField fullWidth multiline={q.type === 'long_text'} minRows={q.type === 'long_text' ? 3 : 1} size="small"
                      value={intakeDraftAnswers[q.id] || ''}
                      onChange={e => setIntakeDraftAnswers((prev: any) => ({ ...prev, [q.id]: e.target.value }))}
                      placeholder="Sua resposta..."
                      InputLabelProps={{ sx: { color: T?.textSecondary } }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2, fontSize: 13.5,
                          color: T?.textPrimary ?? '#0f172a',
                          bgcolor: T ? T.surfaceAlt : '#fff',
                          '& fieldset': { borderColor: T?.border ?? '#e5e7eb' },
                          '&:hover fieldset': { borderColor: T ? T.textSecondary : '#cbd5e1' },
                          '&.Mui-focused fieldset': { borderColor: accentColor },
                        },
                        '& .MuiInputBase-input::placeholder': { color: T?.textSecondary, opacity: 1 },
                      }} />
                  )}
                </Box>
              ))}
            </DialogContent>
            <DialogActions sx={{ px: 2.5, pb: 2.5 }}>
              <Button onClick={() => setIntakeModalOpen(false)} sx={{ textTransform: 'none', fontWeight: 700, color: T?.textSecondary ?? '#64748b' }}>
                Cancelar
              </Button>
              <Button variant="contained" disabled={!intakeCanSave}
                onClick={() => {
                  const saved = intakeAllQuestions
                    .filter((q: any) => String(intakeDraftAnswers[q.id] || '').trim().length > 0)
                    .map((q: any) => ({ question_id: q.id, question_label: q.label, type: q.type, answer: String(intakeDraftAnswers[q.id]).trim() }));
                  setIntakeSavedAnswers(saved);
                  setIntakeModalOpen(false);
                }}
                sx={{ bgcolor: accentColor, color: '#fff', borderRadius: 1.5, textTransform: 'none', fontWeight: 700, '&:hover': { filter: 'brightness(0.9)' },
                  '&.Mui-disabled': { bgcolor: T ? T.surfaceAlt : '#e2e8f0', color: T ? T.textSecondary : '#94a3b8' } }}>
                Salvar respostas
              </Button>
            </DialogActions>
          </Dialog>
        );
      })()}

      {/* ===== SNACKBAR ===== */}
      <Snackbar open={!!snack} autoHideDuration={3000} onClose={() => setSnack('')}
        anchorOrigin={{ vertical:'bottom', horizontal:'center' }}
        message={snack} />

      {/* ===== MODAL PAGAMENTO MP BRICKS ===== */}
      <Dialog open={payModal} fullWidth maxWidth="md" onClose={() => {}}
        sx={{
          '& .MuiDialog-paper': {
            width: { xs: '100vw', sm: 'auto' },
            maxWidth: { xs: '100vw', sm: '860px' },
            height: { xs: 'calc(100dvh - env(safe-area-inset-top, 0px))', sm: 'auto' },
            maxHeight: { xs: 'calc(100dvh - env(safe-area-inset-top, 0px))', sm: '92vh' },
            margin: { xs: 0, sm: '16px' },
            position: { xs: 'fixed', sm: 'relative' },
            left: { xs: 0, sm: 'auto' },
            right: { xs: 0, sm: 'auto' },
            bottom: { xs: 0, sm: 'auto' },
            top: { xs: 'env(safe-area-inset-top, 0px)', sm: 'auto' },
            borderRadius: { xs: '20px 20px 0 0', sm: '20px' },
            overflow: 'hidden',
          },
          '& .MuiDialog-container': {
            alignItems: { xs: 'flex-end', sm: 'center' },
          },
        }}>
        {/* Header com logo e info */}
        <Box sx={{ bgcolor: '#009ee3', px: 3, pt: 2.5, pb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
            {company?.logo_url && (
              <Avatar src={company.logo_url} sx={{ width: 36, height: 36, border: '2px solid rgba(255,255,255,0.5)' }} />
            )}
            <Box>
              <Typography fontSize={13} fontWeight={700} color="#fff">{company?.name}</Typography>
              <Typography fontSize={11} color="rgba(255,255,255,0.8)">Pagamento para confirmar agendamento</Typography>
            </Box>
          </Box>
          {/* Resumo do serviço */}
          <Box sx={{ bgcolor: 'rgba(255,255,255,0.15)', borderRadius: 2, p: 1.5, mb: 1.5 }}>
            <Typography fontSize={12} color="rgba(255,255,255,0.8)" mb={0.2}>Serviço</Typography>
            <Typography fontSize={14} fontWeight={700} color="#fff">{pendingServiceName}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
              <Box>
                {company?.settings?.payment_partial && payAmount < selected.reduce((a: number, s: any) => a + Number(s.price), 0) && (
                  <Typography fontSize={11} color="rgba(255,255,255,0.65)" mb={0.2}>
                    {company.settings.payment_partial_type === 'fixed'
                      ? 'Sinal (valor fixo)'
                      : `Sinal de ${company.settings.payment_partial_pct || 30}% — restante no estabelecimento`}
                  </Typography>
                )}
                <Typography fontSize={22} fontWeight={800} color="#fff">
                  R$ {payAmount.toFixed(2).replace('.', ',')}
                </Typography>
              </Box>
              {company?.settings?.mp_pix_discount > 0 && (
                <Box sx={{ bgcolor: '#00c853', borderRadius: 1, px: 0.8, py: 0.2 }}>
                  <Typography fontSize={10} fontWeight={700} color="#fff">
                    PIX {company.settings.mp_pix_discount}% OFF = R$ {(payAmount * (1 - company.settings.mp_pix_discount / 100)).toFixed(2).replace('.', ',')}
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
          {/* Countdown */}
          <Box sx={{ bgcolor: payCountdown < 120 ? 'rgba(255,80,80,0.3)' : 'rgba(255,255,255,0.12)', borderRadius: 1.5, p: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ flex: 1 }}>
              <Typography fontSize={11} color="rgba(255,255,255,0.9)" mb={0.3}>
                ⏱ Tempo para pagar: <b style={{ color: payCountdown < 120 ? '#ffcdd2' : '#fff' }}>
                  {String(Math.floor(payCountdown / 60)).padStart(2,'0')}:{String(payCountdown % 60).padStart(2,'0')}
                </b>
              </Typography>
              <Box sx={{ height: 4, bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 2, overflow: 'hidden' }}>
                <Box sx={{ height: '100%', bgcolor: payCountdown < 120 ? '#ff5252' : '#fff', borderRadius: 2, width: `${(payCountdown / payTotalSeconds)*100}%`, transition: 'width 1s linear' }} />
              </Box>
            </Box>
          </Box>
        </Box>

        <DialogContent sx={{ pt: 2, px: 2.5, pb: 1 }}>
          <Typography fontSize={12} color="text.secondary" mb={1.5} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            🔒 Pagamento 100% seguro — processado pelo Mercado Pago
          </Typography>
          <Box id="mp-bricks-container-old" sx={{ minHeight: 200, display: "none" }} />
          {!bricksReady && (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4, gap: 1 }}>
              <CircularProgress size={28} sx={{ color: '#009ee3' }} />
              <Typography fontSize={12} color="text.secondary">Carregando formulário de pagamento...</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2, pt: 0 }}>
          <Button size="small" color="error" variant="outlined" sx={{ fontSize: 11, borderRadius: 2 }} onClick={async () => {
            if (bricksControllerRef.current) { try { await bricksControllerRef.current.unmount(); } catch(_){} bricksControllerRef.current = null; }
            if (countdownRef.current) clearInterval(countdownRef.current);
            // Cancela o agendamento
            if (pendingBookingId) {
              axios.delete(`${API}/public/${slug}/bookings/${pendingBookingId}`, { data: { token: pendingBookingToken } }).catch(() => {});
            }
            setPayModal(false);
            setSnack('Agendamento cancelado. Nenhum pagamento foi cobrado.');
          }}>✕ Cancelar agendamento</Button>
        </DialogActions>
      </Dialog>

      {/* ===== MODAL FILA DE ESPERA ===== */}
      <Dialog open={waitlistOpen} onClose={() => { setWaitlistOpen(false); setWaitlistDone(null); }} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3, m: 2 } }}>
        <DialogTitle sx={{ pb: 1, display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box sx={{ width: 38, height: 38, borderRadius: 2, bgcolor: '#fff8e1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <HourglassEmpty sx={{ color: '#f59e0b', fontSize: 22 }} />
          </Box>
          <Box>
            <Typography fontWeight={800} fontSize={15}>Avise-me quando abrir vaga</Typography>
            <Typography fontSize={11} color="text.secondary">Cadastre seu contato e avisamos quando abrir um horário disponível.</Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pt: 0 }}>
          {waitlistDone ? (
            <Box sx={{ py: 2, textAlign: 'center' }}>
              <CheckCircle sx={{ fontSize: 52, color: '#22c55e', mb: 1 }} />
              <Typography fontWeight={800} fontSize={16} mb={0.5}>Cadastro realizado! 🎉</Typography>
              <Typography fontSize={13} color="text.secondary" mb={1}>
                Você é o <b>{waitlistDone.position}º</b> na lista de espera.
              </Typography>
              <Box sx={{ p: 2, bgcolor: '#f0fdf4', borderRadius: 2, border: '1px solid #bbf7d0' }}>
                <Typography fontSize={12} color="#166534" lineHeight={1.6}>
                  📱 Assim que um horário abrir, você receberá um aviso no WhatsApp.<br />
                  ⏱️ Você terá <b>15 minutos</b> para confirmar o agendamento.
                </Typography>
              </Box>
            </Box>
          ) : (
            <Box sx={{ pt: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {/* Serviços selecionados (read-only) */}
              {selected.length > 0 && (
                <Box sx={{ p: 1.2, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                  <Typography fontSize={11} fontWeight={700} color="#64748b" mb={0.4}>Serviço(s) que você quer agendar</Typography>
                  <Typography fontSize={13} fontWeight={600} color="#0f172a">
                    {selected.map((s: any) => s.name).join(', ')}
                  </Typography>
                </Box>
              )}
              {/* Data capturada automaticamente */}
              {selDate && (
                <Box sx={{ p: 1.2, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                  <Typography fontSize={11} fontWeight={700} color="#64748b" mb={0.4}>Data preferida</Typography>
                  <Typography fontSize={13} fontWeight={600} color="#0f172a">
                    {selDate.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' })}
                  </Typography>
                </Box>
              )}
              {/* Período */}
              <Box>
                <Typography fontSize={11} fontWeight={700} color="#64748b" mb={0.6}>Período preferido</Typography>
                <Box sx={{ display: 'flex', gap: 0.8, flexWrap: 'wrap' }}>
                  {[
                    { key: 'manhã',    label: '☀️ Manhã' },
                    { key: 'tarde',    label: '🌤 Tarde' },
                    { key: 'qualquer', label: 'Qualquer horário' },
                  ].map(p => (
                    <Box key={p.key} onClick={() => setWaitlistPeriod(p.key)}
                      sx={{
                        px: 1.5, py: 0.6, borderRadius: 99, cursor: 'pointer',
                        border: `1.5px solid ${waitlistPeriod === p.key ? '#f59e0b' : '#e2e8f0'}`,
                        bgcolor: waitlistPeriod === p.key ? '#fff8e1' : '#fff',
                        color: waitlistPeriod === p.key ? '#92400e' : '#64748b',
                        fontSize: 12, fontWeight: 600,
                        transition: 'all 0.15s',
                        '&:hover': { borderColor: '#f59e0b' },
                      }}>
                      {p.label}
                    </Box>
                  ))}
                </Box>
              </Box>
              <TextField label="Seu nome" fullWidth size="small" value={waitlistName}
                onChange={e => setWaitlistName(e.target.value)}
                InputProps={{ sx: { borderRadius: 2 } }} />
              <TextField label="WhatsApp" fullWidth size="small" value={waitlistPhone}
                error={!!waitlistPhone && waitlistPhone.replace(/\D/g,'').length < 10}
                helperText={!!waitlistPhone && waitlistPhone.replace(/\D/g,'').length < 10 ? 'DDD + número completo (ex: 11912345678)' : ''}
                onPaste={e => {
                  e.preventDefault();
                  const p = e.clipboardData.getData('text').replace(/\D/g,'').slice(0,11);
                  const f = p.length > 6 ? `(${p.slice(0,2)}) ${p.slice(2,7)}-${p.slice(7)}` : p.length > 2 ? `(${p.slice(0,2)}) ${p.slice(2)}` : p;
                  setWaitlistPhone(f);
                }}
                onChange={e => {
                  const n = e.target.value.replace(/\D/g,'').slice(0,11);
                  const f = n.length > 6 ? `(${n.slice(0,2)}) ${n.slice(2,7)}-${n.slice(7)}` : n.length > 2 ? `(${n.slice(0,2)}) ${n.slice(2)}` : n;
                  setWaitlistPhone(f);
                }}
                placeholder="(11) 99999-9999"
                InputProps={{ startAdornment: <InputAdornment position="start"><WhatsApp sx={{ fontSize: 16, color: '#25d366' }} /></InputAdornment>, sx: { borderRadius: 2 } }} />
              <TextField label="E-mail (opcional)" fullWidth size="small" value={waitlistEmail}
                onChange={e => setWaitlistEmail(e.target.value)}
                InputProps={{ sx: { borderRadius: 2 } }} />
            </Box>
          )}
        </DialogContent>
        {!waitlistDone && (
          <DialogActions sx={{ px: 2.5, pb: 2.5, gap: 1 }}>
            <Button variant="outlined" size="small" onClick={() => setWaitlistOpen(false)}
              sx={{ borderRadius: 2, textTransform: 'none', flex: 1 }}>Cancelar</Button>
            <Button variant="contained" size="small" disabled={waitlistSaving || !waitlistName || waitlistPhone.replace(/\D/g,'').length < 10}
              startIcon={waitlistSaving ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : <NotificationsActive sx={{ fontSize: 15 }} />}
              onClick={async () => {
                setWaitlistSaving(true);
                try {
                  // Snapshot dos serviços selecionados
                  const svcSnapshot = selected.map((s: any) => ({ id: s.id, name: s.name, price: s.price, duration_min: s.duration_min }));
                  const r = await axios.post(`${API}/public/${slug}/waitlist`, {
                    customer_name: waitlistName,
                    customer_phone: waitlistPhone,
                    customer_email: waitlistEmail,
                    professional_id: selPro?.id || null,
                    service_id: selected.length === 1 ? selected[0].id : null,
                    preferred_date: selDate ? selDate.toISOString().slice(0, 10) : null,
                    preferred_period: waitlistPeriod || 'qualquer',
                    services_snapshot: svcSnapshot.length > 0 ? svcSnapshot : null,
                  });
                  setWaitlistDone(r.data);
                } catch (e: any) {
                  setSnack(e.response?.data?.error || 'Erro ao entrar na fila');
                } finally { setWaitlistSaving(false); }
              }}
              sx={{ borderRadius: 2, textTransform: 'none', flex: 2, bgcolor: '#f59e0b', '&:hover': { bgcolor: '#d97706' } }}>
              {waitlistSaving ? 'Salvando...' : 'Quero ser avisado(a)'}
            </Button>
          </DialogActions>
        )}
        {waitlistDone && (
          <DialogActions sx={{ px: 2.5, pb: 2.5 }}>
            <Button fullWidth variant="contained" onClick={() => { setWaitlistOpen(false); setWaitlistDone(null); setWaitlistName(''); setWaitlistPhone(''); setWaitlistEmail(''); setWaitlistPeriod('qualquer'); }}
              sx={{ borderRadius: 2, textTransform: 'none', bgcolor: '#22c55e', '&:hover': { bgcolor: '#16a34a' } }}>
              Entendido! ✓
            </Button>
          </DialogActions>
        )}
      </Dialog>


      {/* Dialog recuperação de senha */}
      <Dialog open={forgotOpen} onClose={() => { setForgotOpen(false); setForgotSent(false); setForgotEmail(''); setForgotError(''); }} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3, p: 1 } }}>
        <DialogTitle sx={{ fontWeight: 800, fontSize: 18 }}>
          {forgotSent ? '📧 E-mail enviado!' : 'Recuperar senha'}
        </DialogTitle>
        <DialogContent>
          {forgotSent ? (
            <Box>
              <Typography fontSize={14} color="#555" lineHeight={1.7}>
                Se o e-mail <strong>{forgotEmail}</strong> estiver cadastrado, você receberá as instruções em breve.<br/><br/>Verifique também a pasta de <strong>spam</strong>.
              </Typography>
            </Box>
          ) : (
            <Box>
              <Typography fontSize={13} color="#777" mb={2}>
                Digite seu e-mail para receber o link de redefinição de senha.
              </Typography>
              {forgotError && <Alert severity="error" sx={{ mb: 2, fontSize: 12, borderRadius: 2 }}>{forgotError}</Alert>}
              <TextField fullWidth label="E-mail" type="email" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)}
                size="small" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} autoFocus />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button onClick={() => { setForgotOpen(false); setForgotSent(false); setForgotEmail(''); setForgotError(''); }}
            sx={{ textTransform: 'none', color: '#888', fontWeight: 600 }}>Fechar</Button>
          {!forgotSent && (
            <Button variant="contained" onClick={handleForgotCustomer} disabled={forgotLoading || !forgotEmail}
              sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2, bgcolor: '#1a1a1a', '&:hover': { bgcolor: '#333' } }}>
              {forgotLoading ? <CircularProgress size={18} color="inherit" /> : 'Enviar link'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {/* Modal de avaliações */}
      {/* Barra de preview — visivel apenas para dono/admin via ?preview=true.
          UI V2 é o padrão global; empresas com legacy_client_ui=true
          continuam com a barra original, sem nenhuma mudança de comportamento. */}
      {isPreview && (pilotUI ? (
        <PreviewBarV2 hasSelection={selected.length > 0} />
      ) : (
        <Box
          onClick={() => { if (window.history.length > 1) { window.history.back(); } else { window.location.href = '/dashboard'; } }}
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 2000,
            bgcolor: 'rgba(15,23,42,0.97)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            paddingBottom: 'env(safe-area-inset-bottom, 0px)',
            borderRadius: '14px 14px 0 0',
            boxShadow: '0 -4px 20px rgba(0,0,0,0.22)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            pt: 1.2,
            pb: 1.2,
            gap: 0.4,
            cursor: 'pointer',
            WebkitTapHighlightColor: 'transparent',
            userSelect: 'none',
            transition: 'background 0.15s',
            '&:active': { bgcolor: 'rgba(30,41,59,0.98)' },
          }}
        >
          <Box sx={{ width: 32, height: 4, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.18)', mb: 0.8 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Typography sx={{ fontSize: 18, lineHeight: 1, color: 'rgba(255,255,255,0.75)', mt: '-1px' }}>&#8249;</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#fff', letterSpacing: '-0.01em' }}>
              Voltar ao painel
            </Typography>
          </Box>
          <Typography sx={{ fontSize: 11, color: 'rgba(255,255,255,0.38)', letterSpacing: '0.04em', textTransform: 'uppercase', mt: 0.25 }}>
            Modo de prévia
          </Typography>
        </Box>
      ))}

      <TestBookingConfirmDialog
        open={testConfirmOpen}
        loading={submitting}
        onCancel={() => setTestConfirmOpen(false)}
        onConfirm={() => { setTestConfirmOpen(false); handleSubmit(); }}
      />

      <ReviewsModal
        open={showReviewsModal}
        onClose={() => setShowReviewsModal(false)}
        reviews={reviews}
      />
    </Box>
  );
}
